var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScrapBins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Scrap_Bins",
    "data-name": "Scrap Bins",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 130,
    height: 107.313,
    viewBox: "0 0 130 107.313",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-3 {\n        clip-path: url(#clip-path-3);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-5 {\n        fill: #582a3a;\n      }\n\n      .cls-6 {\n        fill: #532436;\n      }\n\n      .cls-7 {\n        fill: #814e5b;\n      }\n\n      .cls-8 {\n        fill: #7a4955;\n      }\n\n      .cls-9 {\n        fill: #4e2132;\n      }\n\n      .cls-10 {\n        fill: #8a6c73;\n      }\n\n      .cls-11 {\n        fill: #644150;\n      }\n\n      .cls-12 {\n        fill: #a08387;\n      }\n\n      .cls-13 {\n        opacity: 0.6;\n      }\n\n      .cls-14 {\n        clip-path: url(#clip-path-5);\n      }\n\n      .cls-15 {\n        clip-path: url(#clip-path-6);\n      }\n\n      .cls-16 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-17 {\n        clip-path: url(#clip-path-7);\n      }\n\n      .cls-18 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-19 {\n        clip-path: url(#clip-path-8);\n      }\n\n      .cls-20 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-21 {\n        fill: #6e3f4b;\n      }\n\n      .cls-22 {\n        fill: #ecdcce;\n      }\n\n      .cls-23 {\n        clip-path: url(#clip-path-10);\n      }\n\n      .cls-24 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-25 {\n        opacity: 0.8;\n      }\n\n      .cls-26 {\n        clip-path: url(#clip-path-12);\n      }\n\n      .cls-27 {\n        fill: #976e6f;\n      }\n\n      .cls-28 {\n        opacity: 0.9;\n      }\n\n      .cls-29 {\n        clip-path: url(#clip-path-13);\n      }\n\n      .cls-30 {\n        fill: #e6d5c6;\n      }\n\n      .cls-31 {\n        opacity: 0.4;\n      }\n\n      .cls-32 {\n        clip-path: url(#clip-path-14);\n      }\n\n      .cls-33 {\n        fill: #500a1e;\n      }\n\n      .cls-34 {\n        clip-path: url(#clip-path-15);\n      }\n\n      .cls-35 {\n        clip-path: url(#clip-path-16);\n      }\n\n      .cls-36 {\n        clip-path: url(#clip-path-17);\n      }\n\n      .cls-37 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-38 {\n        clip-path: url(#clip-path-19);\n      }\n\n      .cls-39 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-40 {\n        fill: #552837;\n      }\n\n      .cls-41 {\n        clip-path: url(#clip-path-21);\n      }\n\n      .cls-42 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-43 {\n        clip-path: url(#clip-path-23);\n      }\n\n      .cls-44 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-45 {\n        clip-path: url(#clip-path-24);\n      }\n\n      .cls-46 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-47 {\n        clip-path: url(#clip-path-26);\n      }\n\n      .cls-48 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-49 {\n        fill: #411928;\n      }\n\n      .cls-50 {\n        clip-path: url(#clip-path-28);\n      }\n\n      .cls-51 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-52 {\n        clip-path: url(#clip-path-30);\n      }\n\n      .cls-53 {\n        fill: url(#linear-gradient-13);\n      }\n\n      .cls-54 {\n        clip-path: url(#clip-path-32);\n      }\n\n      .cls-55 {\n        fill: url(#linear-gradient-14);\n      }\n\n      .cls-56 {\n        clip-path: url(#clip-path-33);\n      }\n\n      .cls-57 {\n        fill: url(#linear-gradient-15);\n      }\n\n      .cls-58 {\n        clip-path: url(#clip-path-35);\n      }\n\n      .cls-59 {\n        fill: url(#linear-gradient-16);\n      }\n\n      .cls-60 {\n        clip-path: url(#clip-path-42);\n      }\n\n      .cls-61 {\n        fill: url(#linear-gradient-17);\n      }\n\n      .cls-62 {\n        clip-path: url(#clip-path-44);\n      }\n\n      .cls-63 {\n        fill: url(#linear-gradient-18);\n      }\n\n      .cls-64 {\n        clip-path: url(#clip-path-46);\n      }\n\n      .cls-65 {\n        fill: url(#linear-gradient-19);\n      }\n\n      .cls-66 {\n        clip-path: url(#clip-path-48);\n      }\n\n      .cls-67 {\n        fill: url(#linear-gradient-20);\n      }\n\n      .cls-68 {\n        clip-path: url(#clip-path-49);\n      }\n\n      .cls-69 {\n        fill: url(#linear-gradient-21);\n      }\n\n      .cls-70 {\n        clip-path: url(#clip-path-51);\n      }\n\n      .cls-71 {\n        fill: url(#linear-gradient-22);\n      }\n\n      .cls-72 {\n        clip-path: url(#clip-path-53);\n      }\n\n      .cls-73 {\n        fill: url(#linear-gradient-23);\n      }\n\n      .cls-74 {\n        clip-path: url(#clip-path-55);\n      }\n\n      .cls-75 {\n        fill: url(#linear-gradient-24);\n      }\n\n      .cls-76 {\n        clip-path: url(#clip-path-57);\n      }\n\n      .cls-77 {\n        fill: url(#linear-gradient-25);\n      }\n\n      .cls-78 {\n        opacity: 0.7;\n      }\n\n      .cls-79 {\n        clip-path: url(#clip-path-59);\n      }\n\n      .cls-80 {\n        clip-path: url(#clip-path-60);\n      }\n\n      .cls-81 {\n        fill: url(#linear-gradient-26);\n      }\n\n      .cls-82 {\n        clip-path: url(#clip-path-62);\n      }\n\n      .cls-83 {\n        fill: #c57c2d;\n      }\n\n      .cls-84 {\n        fill: #ffe166;\n      }\n\n      .cls-85 {\n        opacity: 0.45;\n      }\n\n      .cls-86 {\n        clip-path: url(#clip-path-63);\n      }\n\n      .cls-87 {\n        fill: #861616;\n      }\n\n      .cls-88 {\n        fill: #fad241;\n      }\n\n      .cls-89 {\n        fill: #eb4e44;\n      }\n\n      .cls-90 {\n        clip-path: url(#clip-path-64);\n      }\n\n      .cls-91 {\n        clip-path: url(#clip-path-65);\n      }\n\n      .cls-92 {\n        clip-path: url(#clip-path-66);\n      }\n\n      .cls-93 {\n        fill: url(#linear-gradient-27);\n      }\n\n      .cls-94 {\n        clip-path: url(#clip-path-69);\n      }\n\n      .cls-95 {\n        fill: url(#linear-gradient-28);\n      }\n\n      .cls-96 {\n        fill: #decbbe;\n      }\n\n      .cls-97 {\n        fill: #8b5865;\n      }\n\n      .cls-98 {\n        fill: #f2efe2;\n      }\n\n      .cls-99 {\n        clip-path: url(#clip-path-72);\n      }\n\n      .cls-100 {\n        clip-path: url(#clip-path-73);\n      }\n\n      .cls-101 {\n        fill: url(#linear-gradient-29);\n      }\n\n      .cls-102 {\n        clip-path: url(#clip-path-74);\n      }\n\n      .cls-103 {\n        fill: url(#linear-gradient-30);\n      }\n\n      .cls-104 {\n        clip-path: url(#clip-path-75);\n      }\n\n      .cls-105 {\n        fill: url(#linear-gradient-31);\n      }\n\n      .cls-106 {\n        fill: #73434f;\n      }\n\n      .cls-107 {\n        clip-path: url(#clip-path-77);\n      }\n\n      .cls-108 {\n        fill: url(#linear-gradient-32);\n      }\n\n      .cls-109 {\n        opacity: 0.95;\n      }\n\n      .cls-110 {\n        clip-path: url(#clip-path-79);\n      }\n\n      .cls-111 {\n        fill: #a97f7f;\n      }\n\n      .cls-112 {\n        clip-path: url(#clip-path-80);\n      }\n\n      .cls-113 {\n        fill: url(#linear-gradient-33);\n      }\n\n      .cls-114 {\n        clip-path: url(#clip-path-82);\n      }\n\n      .cls-115 {\n        clip-path: url(#clip-path-83);\n      }\n\n      .cls-116 {\n        fill: url(#linear-gradient-34);\n      }\n\n      .cls-117 {\n        fill: #633442;\n      }\n\n      .cls-118 {\n        clip-path: url(#clip-path-85);\n      }\n\n      .cls-119 {\n        fill: url(#linear-gradient-35);\n      }\n\n      .cls-120 {\n        clip-path: url(#clip-path-87);\n      }\n\n      .cls-121 {\n        fill: url(#linear-gradient-36);\n      }\n\n      .cls-122 {\n        clip-path: url(#clip-path-89);\n      }\n\n      .cls-123 {\n        fill: url(#linear-gradient-37);\n      }\n\n      .cls-124 {\n        clip-path: url(#clip-path-91);\n      }\n\n      .cls-125 {\n        fill: url(#linear-gradient-38);\n      }\n\n      .cls-126 {\n        clip-path: url(#clip-path-93);\n      }\n\n      .cls-127 {\n        fill: url(#linear-gradient-39);\n      }\n\n      .cls-128 {\n        clip-path: url(#clip-path-95);\n      }\n\n      .cls-129 {\n        fill: url(#linear-gradient-40);\n      }\n\n      .cls-130 {\n        clip-path: url(#clip-path-97);\n      }\n\n      .cls-131 {\n        fill: url(#linear-gradient-41);\n      }\n\n      .cls-132 {\n        clip-path: url(#clip-path-99);\n      }\n\n      .cls-133 {\n        fill: url(#radial-gradient);\n      }\n\n      .cls-134 {\n        clip-path: url(#clip-path-100);\n      }\n\n      .cls-135 {\n        fill: url(#linear-gradient-42);\n      }\n\n      .cls-136 {\n        clip-path: url(#clip-path-102);\n      }\n\n      .cls-137 {\n        clip-path: url(#clip-path-103);\n      }\n\n      .cls-138 {\n        clip-path: url(#clip-path-104);\n      }\n\n      .cls-139 {\n        fill: url(#linear-gradient-43);\n      }\n\n      .cls-140 {\n        clip-path: url(#clip-path-106);\n      }\n\n      .cls-141 {\n        fill: #613443;\n      }\n\n      .cls-142 {\n        fill: #a28489;\n      }\n\n      .cls-143 {\n        clip-path: url(#clip-path-107);\n      }\n\n      .cls-144 {\n        fill: url(#linear-gradient-44);\n      }\n\n      .cls-145 {\n        fill: #88666b;\n      }\n\n      .cls-146 {\n        fill: #987676;\n      }\n\n      .cls-147 {\n        fill: #7d505c;\n      }\n\n      .cls-148 {\n        opacity: 0.5;\n      }\n\n      .cls-149 {\n        clip-path: url(#clip-path-110);\n      }\n\n      .cls-150 {\n        clip-path: url(#clip-path-111);\n      }\n\n      .cls-151 {\n        fill: #94767b;\n      }\n\n      .cls-152 {\n        clip-path: url(#clip-path-112);\n      }\n\n      .cls-153 {\n        fill: #b29498;\n      }\n\n      .cls-154 {\n        clip-path: url(#clip-path-113);\n      }\n\n      .cls-155 {\n        clip-path: url(#clip-path-118);\n      }\n\n      .cls-156 {\n        fill: #b5979b;\n      }\n\n      .cls-157 {\n        opacity: 0.46;\n      }\n\n      .cls-158 {\n        clip-path: url(#clip-path-119);\n      }\n\n      .cls-159 {\n        clip-path: url(#clip-path-121);\n      }\n\n      .cls-160 {\n        opacity: 0.41;\n      }\n\n      .cls-161 {\n        clip-path: url(#clip-path-122);\n      }\n\n      .cls-162 {\n        clip-path: url(#clip-path-123);\n      }\n\n      .cls-163 {\n        fill: #ab8d91;\n      }\n\n      .cls-164 {\n        clip-path: url(#clip-path-124);\n      }\n\n      .cls-165 {\n        fill: #784b57;\n      }\n\n      .cls-166 {\n        fill: #6e414d;\n      }\n\n      .cls-167 {\n        fill: #855864;\n      }\n\n      .cls-168 {\n        opacity: 0.47;\n      }\n\n      .cls-169 {\n        clip-path: url(#clip-path-127);\n      }\n\n      .cls-170 {\n        fill: #9e8287;\n      }\n\n      .cls-171 {\n        clip-path: url(#clip-path-128);\n      }\n\n      .cls-172 {\n        opacity: 0.38;\n      }\n\n      .cls-173 {\n        clip-path: url(#clip-path-129);\n      }\n\n      .cls-174 {\n        clip-path: url(#clip-path-133);\n      }\n\n      .cls-175 {\n        clip-path: url(#clip-path-138);\n      }\n\n      .cls-176 {\n        fill: url(#linear-gradient-45);\n      }\n\n      .cls-177 {\n        opacity: 0.72;\n      }\n\n      .cls-178 {\n        clip-path: url(#clip-path-140);\n      }\n\n      .cls-179 {\n        fill: #851928;\n      }\n\n      .cls-180 {\n        clip-path: url(#clip-path-141);\n      }\n\n      .cls-181 {\n        clip-path: url(#clip-path-142);\n      }\n\n      .cls-182 {\n        fill: url(#linear-gradient-46);\n      }\n\n      .cls-183 {\n        clip-path: url(#clip-path-144);\n      }\n\n      .cls-184 {\n        opacity: 0.77;\n      }\n\n      .cls-185 {\n        clip-path: url(#clip-path-145);\n      }\n\n      .cls-186 {\n        opacity: 0.66;\n      }\n\n      .cls-187 {\n        clip-path: url(#clip-path-146);\n      }\n\n      .cls-188 {\n        fill: #59323f;\n      }\n\n      .cls-189 {\n        clip-path: url(#clip-path-147);\n      }\n\n      .cls-190 {\n        fill: url(#linear-gradient-47);\n      }\n\n      .cls-191 {\n        clip-path: url(#clip-path-148);\n      }\n\n      .cls-192 {\n        fill: url(#linear-gradient-48);\n      }\n\n      .cls-193 {\n        opacity: 0.65;\n      }\n\n      .cls-194 {\n        clip-path: url(#clip-path-150);\n      }\n\n      .cls-195 {\n        clip-path: url(#clip-path-151);\n      }\n\n      .cls-196 {\n        opacity: 0.35;\n      }\n\n      .cls-197 {\n        clip-path: url(#clip-path-152);\n      }\n\n      .cls-198 {\n        clip-path: url(#clip-path-153);\n      }\n\n      .cls-199 {\n        fill: url(#linear-gradient-49);\n      }\n\n      .cls-200 {\n        fill: #781421;\n      }\n\n      .cls-201 {\n        clip-path: url(#clip-path-155);\n      }\n\n      .cls-202 {\n        fill: #f3614c;\n      }\n\n      .cls-203 {\n        clip-path: url(#clip-path-156);\n      }\n\n      .cls-204 {\n        clip-path: url(#clip-path-157);\n      }\n\n      .cls-205 {\n        fill: url(#linear-gradient-50);\n      }\n\n      .cls-206 {\n        clip-path: url(#clip-path-158);\n      }\n\n      .cls-207 {\n        fill: url(#linear-gradient-51);\n      }\n\n      .cls-208 {\n        clip-path: url(#clip-path-160);\n      }\n\n      .cls-209 {\n        clip-path: url(#clip-path-161);\n      }\n\n      .cls-210 {\n        clip-path: url(#clip-path-162);\n      }\n\n      .cls-211 {\n        clip-path: url(#clip-path-163);\n      }\n\n      .cls-212 {\n        fill: url(#linear-gradient-52);\n      }\n\n      .cls-213 {\n        fill: #f05349;\n      }\n\n      .cls-214 {\n        clip-path: url(#clip-path-165);\n      }\n\n      .cls-215 {\n        fill: url(#linear-gradient-53);\n      }\n\n      .cls-216 {\n        clip-path: url(#clip-path-167);\n      }\n\n      .cls-217 {\n        clip-path: url(#clip-path-168);\n      }\n\n      .cls-218 {\n        clip-path: url(#clip-path-169);\n      }\n\n      .cls-219 {\n        fill: url(#linear-gradient-54);\n      }\n\n      .cls-220 {\n        clip-path: url(#clip-path-172);\n      }\n\n      .cls-221 {\n        clip-path: url(#clip-path-173);\n      }\n\n      .cls-222 {\n        fill: url(#linear-gradient-55);\n      }\n\n      .cls-223 {\n        clip-path: url(#clip-path-175);\n      }\n\n      .cls-224 {\n        fill: url(#linear-gradient-56);\n      }\n\n      .cls-225 {\n        clip-path: url(#clip-path-177);\n      }\n\n      .cls-226 {\n        fill: url(#linear-gradient-57);\n      }\n\n      .cls-227 {\n        clip-path: url(#clip-path-178);\n      }\n\n      .cls-228 {\n        fill: url(#linear-gradient-58);\n      }\n\n      .cls-229 {\n        clip-path: url(#clip-path-179);\n      }\n\n      .cls-230 {\n        fill: url(#linear-gradient-59);\n      }\n\n      .cls-231 {\n        clip-path: url(#clip-path-181);\n      }\n\n      .cls-232 {\n        fill: #917172;\n      }\n\n      .cls-233 {\n        clip-path: url(#clip-path-182);\n      }\n\n      .cls-234 {\n        fill: url(#linear-gradient-60);\n      }\n\n      .cls-235 {\n        clip-path: url(#clip-path-184);\n      }\n\n      .cls-236 {\n        clip-path: url(#clip-path-185);\n      }\n\n      .cls-237 {\n        clip-path: url(#clip-path-186);\n      }\n\n      .cls-238 {\n        fill: url(#linear-gradient-61);\n      }\n\n      .cls-239 {\n        clip-path: url(#clip-path-187);\n      }\n\n      .cls-240 {\n        fill: url(#linear-gradient-62);\n      }\n\n      .cls-241 {\n        clip-path: url(#clip-path-189);\n      }\n\n      .cls-242 {\n        opacity: 0.74;\n      }\n\n      .cls-243 {\n        clip-path: url(#clip-path-190);\n      }\n\n      .cls-244 {\n        fill: #e8493f;\n      }\n\n      .cls-245 {\n        clip-path: url(#clip-path-191);\n      }\n\n      .cls-246 {\n        clip-path: url(#clip-path-192);\n      }\n\n      .cls-247 {\n        fill: #781221;\n      }\n\n      .cls-248 {\n        clip-path: url(#clip-path-193);\n      }\n\n      .cls-249 {\n        fill: url(#linear-gradient-63);\n      }\n\n      .cls-250 {\n        clip-path: url(#clip-path-194);\n      }\n\n      .cls-251 {\n        fill: url(#linear-gradient-64);\n      }\n\n      .cls-252 {\n        clip-path: url(#clip-path-196);\n      }\n\n      .cls-253 {\n        clip-path: url(#clip-path-197);\n      }\n\n      .cls-254 {\n        fill: url(#linear-gradient-65);\n      }\n\n      .cls-255 {\n        fill: #3c1623;\n      }\n\n      .cls-256 {\n        clip-path: url(#clip-path-199);\n      }\n\n      .cls-257 {\n        fill: url(#linear-gradient-66);\n      }\n\n      .cls-258 {\n        clip-path: url(#clip-path-201);\n      }\n\n      .cls-259 {\n        fill: #320b16;\n      }\n\n      .cls-260 {\n        clip-path: url(#clip-path-202);\n      }\n\n      .cls-261 {\n        clip-path: url(#clip-path-203);\n      }\n\n      .cls-262 {\n        clip-path: url(#clip-path-205);\n      }\n\n      .cls-263 {\n        fill: url(#linear-gradient-67);\n      }\n\n      .cls-264 {\n        clip-path: url(#clip-path-207);\n      }\n\n      .cls-265 {\n        fill: url(#linear-gradient-68);\n      }\n\n      .cls-266 {\n        clip-path: url(#clip-path-209);\n      }\n\n      .cls-267 {\n        fill: url(#linear-gradient-69);\n      }\n\n      .cls-268 {\n        clip-path: url(#clip-path-210);\n      }\n\n      .cls-269 {\n        fill: url(#linear-gradient-70);\n      }\n\n      .cls-270 {\n        clip-path: url(#clip-path-212);\n      }\n\n      .cls-271 {\n        fill: url(#linear-gradient-71);\n      }\n\n      .cls-272 {\n        clip-path: url(#clip-path-214);\n      }\n\n      .cls-273 {\n        clip-path: url(#clip-path-215);\n      }\n\n      .cls-274 {\n        fill: url(#linear-gradient-72);\n      }\n\n      .cls-275 {\n        clip-path: url(#clip-path-217);\n      }\n\n      .cls-276 {\n        clip-path: url(#clip-path-218);\n      }\n\n      .cls-277 {\n        fill: url(#linear-gradient-73);\n      }\n\n      .cls-278 {\n        clip-path: url(#clip-path-220);\n      }\n\n      .cls-279 {\n        fill: url(#linear-gradient-74);\n      }\n\n      .cls-280 {\n        clip-path: url(#clip-path-222);\n      }\n\n      .cls-281 {\n        fill: url(#linear-gradient-75);\n      }\n\n      .cls-282 {\n        clip-path: url(#clip-path-224);\n      }\n\n      .cls-283 {\n        fill: url(#linear-gradient-76);\n      }\n\n      .cls-284 {\n        clip-path: url(#clip-path-226);\n      }\n\n      .cls-285 {\n        fill: url(#linear-gradient-77);\n      }\n\n      .cls-286 {\n        clip-path: url(#clip-path-228);\n      }\n\n      .cls-287 {\n        fill: url(#linear-gradient-78);\n      }\n\n      .cls-288 {\n        clip-path: url(#clip-path-230);\n      }\n\n      .cls-289 {\n        fill: url(#linear-gradient-79);\n      }\n\n      .cls-290 {\n        clip-path: url(#clip-path-232);\n      }\n\n      .cls-291 {\n        fill: url(#linear-gradient-80);\n      }\n\n      .cls-292 {\n        clip-path: url(#clip-path-234);\n      }\n\n      .cls-293 {\n        fill: url(#radial-gradient-2);\n      }\n\n      .cls-294 {\n        clip-path: url(#clip-path-235);\n      }\n\n      .cls-295 {\n        fill: url(#linear-gradient-81);\n      }\n\n      .cls-296 {\n        clip-path: url(#clip-path-237);\n      }\n\n      .cls-297 {\n        fill: #32000a;\n      }\n\n      .cls-298 {\n        clip-path: url(#clip-path-238);\n      }\n\n      .cls-299 {\n        clip-path: url(#clip-path-242);\n      }\n\n      .cls-300 {\n        fill: #552838;\n      }\n\n      .cls-301 {\n        fill: #5c2f40;\n      }\n\n      .cls-302 {\n        clip-path: url(#clip-path-243);\n      }\n\n      .cls-303 {\n        fill: #8d5c68;\n      }\n\n      .cls-304 {\n        opacity: 0.2;\n      }\n\n      .cls-305 {\n        clip-path: url(#clip-path-244);\n      }\n\n      .cls-306 {\n        clip-path: url(#clip-path-245);\n      }\n\n      .cls-307 {\n        fill: url(#linear-gradient-82);\n      }\n\n      .cls-308 {\n        clip-path: url(#clip-path-247);\n      }\n\n      .cls-309 {\n        fill: #4e4479;\n      }\n\n      .cls-310 {\n        clip-path: url(#clip-path-248);\n      }\n\n      .cls-311 {\n        clip-path: url(#clip-path-249);\n      }\n\n      .cls-312 {\n        clip-path: url(#clip-path-250);\n      }\n\n      .cls-313 {\n        fill: url(#linear-gradient-83);\n      }\n\n      .cls-314 {\n        clip-path: url(#clip-path-252);\n      }\n\n      .cls-315 {\n        fill: #330b31;\n      }\n\n      .cls-316 {\n        fill: #798bcb;\n      }\n\n      .cls-317 {\n        opacity: 0.44;\n      }\n\n      .cls-318 {\n        clip-path: url(#clip-path-253);\n      }\n\n      .cls-319 {\n        fill: #281932;\n      }\n\n      .cls-320 {\n        fill: #554d7f;\n      }\n\n      .cls-321 {\n        fill: #502131;\n      }\n\n      .cls-322 {\n        fill: #8a9ad6;\n      }\n\n      .cls-323 {\n        clip-path: url(#clip-path-255);\n      }\n\n      .cls-324 {\n        fill: #707bc2;\n      }\n\n      .cls-325 {\n        clip-path: url(#clip-path-256);\n      }\n\n      .cls-326 {\n        fill: url(#linear-gradient-84);\n      }\n\n      .cls-327 {\n        clip-path: url(#clip-path-257);\n      }\n\n      .cls-328 {\n        fill: url(#linear-gradient-85);\n      }\n\n      .cls-329 {\n        fill: #9ba8e0;\n      }\n\n      .cls-330 {\n        clip-path: url(#clip-path-259);\n      }\n\n      .cls-331 {\n        fill: #a5afe6;\n      }\n\n      .cls-332 {\n        fill: #adb7e9;\n      }\n\n      .cls-333 {\n        clip-path: url(#clip-path-260);\n      }\n\n      .cls-334 {\n        fill: url(#linear-gradient-86);\n      }\n\n      .cls-335 {\n        clip-path: url(#clip-path-262);\n      }\n\n      .cls-336 {\n        clip-path: url(#clip-path-263);\n      }\n\n      .cls-337 {\n        clip-path: url(#clip-path-264);\n      }\n\n      .cls-338 {\n        clip-path: url(#clip-path-266);\n      }\n\n      .cls-339 {\n        clip-path: url(#clip-path-267);\n      }\n\n      .cls-340 {\n        fill: url(#linear-gradient-87);\n      }\n\n      .cls-341 {\n        fill: #603240;\n      }\n\n      .cls-342 {\n        fill: #461e2d;\n      }\n\n      .cls-343 {\n        fill: #572939;\n      }\n\n      .cls-344 {\n        clip-path: url(#clip-path-269);\n      }\n\n      .cls-345 {\n        fill: url(#linear-gradient-88);\n      }\n\n      .cls-346 {\n        clip-path: url(#clip-path-271);\n      }\n\n      .cls-347 {\n        fill: #58283b;\n      }\n\n      .cls-348 {\n        clip-path: url(#clip-path-272);\n      }\n\n      .cls-349 {\n        clip-path: url(#clip-path-273);\n      }\n\n      .cls-350 {\n        fill: url(#linear-gradient-89);\n      }\n\n      .cls-351 {\n        clip-path: url(#clip-path-275);\n      }\n\n      .cls-352 {\n        clip-path: url(#clip-path-276);\n      }\n\n      .cls-353 {\n        fill: #552737;\n      }\n\n      .cls-354 {\n        clip-path: url(#clip-path-277);\n      }\n\n      .cls-355 {\n        fill: #623342;\n      }\n\n      .cls-356 {\n        clip-path: url(#clip-path-279);\n      }\n\n      .cls-357 {\n        clip-path: url(#clip-path-280);\n      }\n\n      .cls-358 {\n        clip-path: url(#clip-path-282);\n      }\n\n      .cls-359 {\n        fill: url(#linear-gradient-90);\n      }\n\n      .cls-360 {\n        clip-path: url(#clip-path-283);\n      }\n\n      .cls-361 {\n        fill: url(#linear-gradient-91);\n      }\n\n      .cls-362 {\n        clip-path: url(#clip-path-285);\n      }\n\n      .cls-363 {\n        clip-path: url(#clip-path-286);\n      }\n\n      .cls-364 {\n        clip-path: url(#clip-path-287);\n      }\n\n      .cls-365 {\n        clip-path: url(#clip-path-288);\n      }\n\n      .cls-366 {\n        fill: url(#linear-gradient-92);\n      }\n\n      .cls-367 {\n        clip-path: url(#clip-path-289);\n      }\n\n      .cls-368 {\n        fill: url(#linear-gradient-93);\n      }\n\n      .cls-369 {\n        fill: #473d68;\n      }\n\n      .cls-370 {\n        fill: #544f8a;\n      }\n\n      .cls-371 {\n        clip-path: url(#clip-path-291);\n      }\n\n      .cls-372 {\n        fill: url(#linear-gradient-94);\n      }\n\n      .cls-373 {\n        fill: #89696c;\n      }\n\n      .cls-374 {\n        fill: #5a4fa5;\n      }\n\n      .cls-375 {\n        fill: #937376;\n      }\n\n      .cls-376 {\n        clip-path: url(#clip-path-293);\n      }\n\n      .cls-377 {\n        fill: url(#linear-gradient-95);\n      }\n\n      .cls-378 {\n        clip-path: url(#clip-path-294);\n      }\n\n      .cls-379 {\n        fill: url(#linear-gradient-96);\n      }\n\n      .cls-380 {\n        fill: #493f78;\n      }\n\n      .cls-381 {\n        clip-path: url(#clip-path-296);\n      }\n\n      .cls-382 {\n        fill: url(#linear-gradient-97);\n      }\n\n      .cls-383 {\n        opacity: 0.3;\n      }\n\n      .cls-384 {\n        clip-path: url(#clip-path-298);\n      }\n\n      .cls-385 {\n        fill: #281632;\n      }\n\n      .cls-386 {\n        clip-path: url(#clip-path-299);\n      }\n\n      .cls-387 {\n        opacity: 0.25;\n      }\n\n      .cls-388 {\n        clip-path: url(#clip-path-300);\n      }\n\n      .cls-389 {\n        clip-path: url(#clip-path-301);\n      }\n\n      .cls-390 {\n        clip-path: url(#clip-path-302);\n      }\n\n      .cls-391 {\n        fill: url(#linear-gradient-98);\n      }\n\n      .cls-392 {\n        fill: #d0b6b3;\n      }\n\n      .cls-393 {\n        clip-path: url(#clip-path-304);\n      }\n\n      .cls-394 {\n        fill: url(#linear-gradient-99);\n      }\n\n      .cls-395 {\n        fill: #d7c9c2;\n      }\n\n      .cls-396 {\n        opacity: 0.85;\n      }\n\n      .cls-397 {\n        clip-path: url(#clip-path-306);\n      }\n\n      .cls-398 {\n        clip-path: url(#clip-path-307);\n      }\n\n      .cls-399 {\n        fill: url(#linear-gradient-100);\n      }\n\n      .cls-400 {\n        clip-path: url(#clip-path-308);\n      }\n\n      .cls-401 {\n        clip-path: url(#clip-path-309);\n      }\n\n      .cls-402 {\n        fill: url(#linear-gradient-101);\n      }\n\n      .cls-403 {\n        clip-path: url(#clip-path-310);\n      }\n\n      .cls-404 {\n        fill: #ffa831;\n      }\n\n      .cls-405 {\n        clip-path: url(#clip-path-311);\n      }\n\n      .cls-406 {\n        clip-path: url(#clip-path-313);\n      }\n\n      .cls-407 {\n        fill: url(#linear-gradient-102);\n      }\n\n      .cls-408 {\n        clip-path: url(#clip-path-315);\n      }\n\n      .cls-409 {\n        fill: url(#linear-gradient-103);\n      }\n\n      .cls-410 {\n        clip-path: url(#clip-path-318);\n      }\n\n      .cls-411 {\n        fill: url(#linear-gradient-104);\n      }\n\n      .cls-412 {\n        clip-path: url(#clip-path-320);\n      }\n\n      .cls-413 {\n        fill: url(#linear-gradient-105);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26768",
    "data-name": "Rectangle 26768",
    className: "cls-1",
    width: 130,
    height: 107.313
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77152",
    "data-name": "Path 77152",
    className: "cls-1",
    d: "M445.479,462.383c-.283.525-.283,1.091,0,1.266l13.89,8.573c.283.175.742-.109,1.026-.633s.283-1.092,0-1.266L446.5,461.75a.354.354,0,0,0-.189-.052,1.145,1.145,0,0,0-.837.685",
    transform: "translate(-445.266 -461.698)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -3.643,
    y1: 2.465,
    x2: -3.634,
    y2: 2.465,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#421a28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511,
    stopColor: "#4e2132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3c1623"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26445",
    "data-name": "Rectangle 26445",
    className: "cls-1",
    width: 3.881,
    height: 1.675
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77168",
    "data-name": "Path 77168",
    className: "cls-1",
    d: "M54.745,335.519l5.465-3.373a9.019,9.019,0,0,1,.111-1.434,5,5,0,0,0-1.827-.378c-2.223,0-3.748,1.885-3.748,5.184",
    transform: "translate(-54.745 -330.335)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.916,
    y1: 8.489,
    x2: -0.897,
    y2: 8.489,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4e2132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#411928"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77169",
    "data-name": "Path 77169",
    className: "cls-1",
    d: "M70.72,319.088l-5.465,3.373c-2.162,1.334-2.162,5.662,0,9.665s5.667,6.167,7.829,4.833l5.465-3.373c2.162-1.335,2.162-5.662,0-9.665-1.729-3.2-4.317-5.227-6.391-5.227a2.7,2.7,0,0,0-1.439.394",
    transform: "translate(-63.634 -318.694)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -0.188,
    y1: 2.539,
    x2: -0.182,
    y2: 2.539,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#84515e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.327,
    stopColor: "#6e3f4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.721,
    stopColor: "#4e2132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#411928"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77170",
    "data-name": "Path 77170",
    className: "cls-1",
    d: "M85.251,319.088l-4.7,2.9c1.722-1.063,5.76,1.01,7.948,4.759,2.31,3.958,2.338,8.222-.208,9.794l4.79-2.957c2.162-1.335,2.162-5.662,0-9.665-1.729-3.2-4.317-5.227-6.391-5.227a2.7,2.7,0,0,0-1.439.394",
    transform: "translate(-80.55 -318.694)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -0.364,
    y1: 2.844,
    x2: -0.357,
    y2: 2.844,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#582a3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.654,
    stopColor: "#4e2132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#411928"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77173",
    "data-name": "Path 77173",
    className: "cls-1",
    d: "M82.257,367.314c-1.185.732-1.185,3.1,0,5.3s3.107,3.381,4.293,2.65,1.185-3.1,0-5.3c-.948-1.755-2.367-2.866-3.5-2.866a1.478,1.478,0,0,0-.789.216",
    transform: "translate(-81.368 -367.098)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -0.92,
    y1: 5.13,
    x2: -0.906,
    y2: 5.13,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2efe2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171,
    stopColor: "#ecdcce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.389,
    stopColor: "#cab6b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.728,
    stopColor: "#a57d82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966e6e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26452",
    "data-name": "Rectangle 26452",
    className: "cls-1",
    width: 1.805,
    height: 0.947
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26453",
    "data-name": "Rectangle 26453",
    className: "cls-1",
    width: 2.06,
    height: 5.236
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26454",
    "data-name": "Rectangle 26454",
    className: "cls-1",
    width: 0.155,
    height: 0.597
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26455",
    "data-name": "Rectangle 26455",
    className: "cls-1",
    width: 0.86,
    height: 1.316
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26456",
    "data-name": "Rectangle 26456",
    className: "cls-1",
    width: 5.015,
    height: 7.844
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77180",
    "data-name": "Path 77180",
    className: "cls-1",
    d: "M95.778,396.3l-.244.15c-.131.081-.131.344,0,.587s.344.375.476.293l.244-.15c.131-.081.131-.344,0-.587a.531.531,0,0,0-.388-.317.163.163,0,0,0-.087.024",
    transform: "translate(-95.436 -396.274)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -9.311,
    y1: 34.993,
    x2: -9.212,
    y2: 34.993,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77182",
    "data-name": "Path 77182",
    className: "cls-1",
    d: "M91.384,380.489l-.244.15c-.131.081-.131.344,0,.587s.344.375.475.294l.244-.15c.131-.081.131-.344,0-.587a.531.531,0,0,0-.388-.318.164.164,0,0,0-.087.024",
    transform: "translate(-91.042 -380.465)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -8.874,
    y1: 36.501,
    x2: -8.775,
    y2: 36.501,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#643241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.657,
    stopColor: "#4e2132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#411928"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77184",
    "data-name": "Path 77184",
    className: "cls-1",
    d: "M106.386,408.27l-.244.15c-.131.081-.131.344,0,.587s.344.375.475.294l.244-.15c.131-.081.131-.344,0-.587a.531.531,0,0,0-.388-.318.164.164,0,0,0-.087.024",
    transform: "translate(-106.044 -408.246)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -10.365,
    y1: 33.844,
    x2: -10.265,
    y2: 33.844,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77186",
    "data-name": "Path 77186",
    className: "cls-1",
    d: "M94.6,379.205l-.99.611c-.534.329-.534,1.4,0,2.385s1.4,1.522,1.932,1.192l.99-.611c.534-.329.534-1.4,0-2.385a2.158,2.158,0,0,0-1.577-1.29.665.665,0,0,0-.355.1",
    transform: "translate(-93.206 -379.108)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -2.104,
    y1: 9.103,
    x2: -2.079,
    y2: 9.103,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77187",
    "data-name": "Path 77187",
    className: "cls-1",
    d: "M100.387,379.205l-.44.271c.533-.329,1.532.122,2.231,1.008a3.262,3.262,0,0,1,.481.823,3.455,3.455,0,0,0-.34-.91,2.158,2.158,0,0,0-1.577-1.29.665.665,0,0,0-.355.1",
    transform: "translate(-99.947 -379.108)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -5.197,
    y1: 24.483,
    x2: -5.145,
    y2: 24.483,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77189",
    "data-name": "Path 77189",
    className: "cls-1",
    d: "M95.778,370.1l-.244.15c-.131.081-.131.344,0,.587s.344.375.476.293l.244-.15c.131-.081.131-.344,0-.587a.531.531,0,0,0-.388-.317.164.164,0,0,0-.087.024",
    transform: "translate(-95.436 -370.081)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -9.311,
    y1: 37.494,
    x2: -9.212,
    y2: 37.494,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77194",
    "data-name": "Path 77194",
    className: "cls-1",
    d: "M121.145,399.6c-.131.081-.131.344,0,.587a.577.577,0,0,0,.35.312,6.279,6.279,0,0,0-.183-1Z",
    transform: "translate(-121.047 -399.494)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -18.324,
    y1: 46.03,
    x2: -18.17,
    y2: 46.03,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77196",
    "data-name": "Path 77196",
    className: "cls-1",
    d: "M116.995,409.394l-.244.15c-.131.081-.131.344,0,.587s.344.375.475.294l.244-.15c.131-.081.131-.344,0-.587a.531.531,0,0,0-.388-.317.163.163,0,0,0-.087.024",
    transform: "translate(-116.653 -409.37)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -11.421,
    y1: 33.741,
    x2: -11.321,
    y2: 33.741,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77198",
    "data-name": "Path 77198",
    className: "cls-1",
    d: "M155.121,371.185l-5.465,3.373c-2.162,1.335-2.162,5.662,0,9.665s5.667,6.167,7.829,4.833l5.465-3.373c2.162-1.335,2.162-5.662,0-9.665-1.729-3.2-4.317-5.227-6.39-5.227a2.7,2.7,0,0,0-1.439.394",
    transform: "translate(-148.035 -370.791)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -0.663,
    y1: 2.254,
    x2: -0.657,
    y2: 2.254,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77199",
    "data-name": "Path 77199",
    className: "cls-1",
    d: "M169.652,371.185l-4.7,2.9c1.722-1.063,5.76,1.01,7.948,4.759,2.31,3.957,2.338,8.222-.208,9.794l4.79-2.957c2.162-1.335,2.162-5.662,0-9.665-1.729-3.2-4.317-5.227-6.39-5.227a2.7,2.7,0,0,0-1.439.394",
    transform: "translate(-164.951 -370.791)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -0.914,
    y1: 2.521,
    x2: -0.907,
    y2: 2.521,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77202",
    "data-name": "Path 77202",
    className: "cls-1",
    d: "M166.658,419.411c-1.185.732-1.185,3.1,0,5.3s3.107,3.382,4.293,2.65,1.185-3.1,0-5.3c-.948-1.756-2.367-2.866-3.5-2.866a1.479,1.479,0,0,0-.789.216",
    transform: "translate(-165.769 -419.195)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: -2.084,
    y1: 4.465,
    x2: -2.07,
    y2: 4.465,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-42"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77209",
    "data-name": "Path 77209",
    className: "cls-1",
    d: "M180.179,448.395l-.244.15c-.131.081-.131.344,0,.587s.344.375.476.294l.244-.151c.131-.081.131-.344,0-.587a.531.531,0,0,0-.388-.317.163.163,0,0,0-.087.024",
    transform: "translate(-179.837 -448.371)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -17.703,
    y1: 30.011,
    x2: -17.603,
    y2: 30.011,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77211",
    "data-name": "Path 77211",
    className: "cls-1",
    d: "M175.785,432.587l-.244.15c-.131.081-.131.344,0,.587s.344.374.475.294l.244-.15c.131-.081.131-.344,0-.587a.531.531,0,0,0-.388-.317.162.162,0,0,0-.087.024",
    transform: "translate(-175.443 -432.563)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: -17.267,
    y1: 31.526,
    x2: -17.167,
    y2: 31.526,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-46"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77213",
    "data-name": "Path 77213",
    className: "cls-1",
    d: "M190.787,460.367l-.244.15c-.131.081-.131.344,0,.587s.344.375.475.293l.244-.15c.131-.081.131-.344,0-.587a.531.531,0,0,0-.388-.318.163.163,0,0,0-.087.024",
    transform: "translate(-190.445 -460.343)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: -18.755,
    y1: 28.863,
    x2: -18.655,
    y2: 28.863,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77215",
    "data-name": "Path 77215",
    className: "cls-1",
    d: "M179,431.3l-.99.611c-.534.329-.534,1.4,0,2.385s1.4,1.522,1.932,1.193l.99-.611c.534-.329.534-1.4,0-2.385a2.158,2.158,0,0,0-1.577-1.29.664.664,0,0,0-.355.1",
    transform: "translate(-177.607 -431.205)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: -4.169,
    y1: 7.877,
    x2: -4.144,
    y2: 7.877,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-49"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77216",
    "data-name": "Path 77216",
    className: "cls-1",
    d: "M184.788,431.3l-.44.271c.534-.329,1.532.122,2.231,1.008a3.268,3.268,0,0,1,.481.823,3.449,3.449,0,0,0-.34-.91,2.158,2.158,0,0,0-1.577-1.29.664.664,0,0,0-.355.1",
    transform: "translate(-184.348 -431.205)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: -9.585,
    y1: 21.145,
    x2: -9.533,
    y2: 21.145,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-51"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77218",
    "data-name": "Path 77218",
    className: "cls-1",
    d: "M180.179,422.2l-.244.15c-.131.081-.131.344,0,.587s.344.375.476.294l.244-.15c.131-.081.131-.344,0-.587a.532.532,0,0,0-.388-.318.163.163,0,0,0-.087.024",
    transform: "translate(-179.837 -422.178)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: -17.702,
    y1: 32.513,
    x2: -17.602,
    y2: 32.513,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-53"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77223",
    "data-name": "Path 77223",
    className: "cls-1",
    d: "M205.546,451.693c-.131.081-.131.344,0,.587a.576.576,0,0,0,.35.312,6.306,6.306,0,0,0-.183-1Z",
    transform: "translate(-205.448 -451.59)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: -31.291,
    y1: 39.403,
    x2: -31.137,
    y2: 39.403,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-55"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77225",
    "data-name": "Path 77225",
    className: "cls-1",
    d: "M201.4,461.491l-.244.15c-.131.081-.131.344,0,.587s.344.375.475.294l.244-.151c.131-.081.131-.344,0-.587a.531.531,0,0,0-.388-.318.164.164,0,0,0-.087.024",
    transform: "translate(-201.054 -461.467)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: -19.812,
    y1: 28.759,
    x2: -19.713,
    y2: 28.759,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-57"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77228",
    "data-name": "Path 77228",
    className: "cls-1",
    d: "M151.323,337.327l-.764.32-5.465,3.373.764-.32a2.211,2.211,0,0,1,2,.335l6.785,4.188a4.9,4.9,0,0,1,1.742,2.133l1.845,4.094a4.847,4.847,0,0,1,.457,1.939v4.287l5.465-3.373v-4.287a4.848,4.848,0,0,0-.457-1.939l-1.845-4.094a4.906,4.906,0,0,0-1.742-2.132l-6.786-4.189a2.7,2.7,0,0,0-1.388-.452,1.56,1.56,0,0,0-.608.118",
    transform: "translate(-145.095 -337.209)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: -0.623,
    y1: 2.319,
    x2: -0.618,
    y2: 2.319,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8b5865"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.103,
    stopColor: "#814e5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#814e5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#6a3b48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886,
    stopColor: "#5e303f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4e2132"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-59"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26499",
    "data-name": "Rectangle 26499",
    className: "cls-1",
    width: 18.038,
    height: 17.969
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-60"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77230",
    "data-name": "Path 77230",
    className: "cls-1",
    d: "M66.275,287.815l.027-.017-.027.017m5.464-3.372h0L66.3,287.8a1.477,1.477,0,0,1,1.541.172l6.785,4.188a6.39,6.39,0,0,1,2,2.131l.764,1.263,5.465-3.373-.764-1.263a6.389,6.389,0,0,0-2-2.13L73.308,284.6a1.908,1.908,0,0,0-.983-.32,1.069,1.069,0,0,0-.587.165",
    transform: "translate(-66.275 -284.277)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: -0.382,
    y1: 3.912,
    x2: -0.375,
    y2: 3.912,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8b5865"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.093,
    stopColor: "#814e5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745,
    stopColor: "#814e5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a3b48"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-62"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26502",
    "data-name": "Rectangle 26502",
    className: "cls-1",
    width: 15.89,
    height: 10.648
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-63"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26503",
    "data-name": "Rectangle 26503",
    className: "cls-1",
    width: 19.869,
    height: 12.264
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-64"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26504",
    "data-name": "Rectangle 26504",
    className: "cls-1",
    width: 17.256,
    height: 10.651
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-65"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26505",
    "data-name": "Rectangle 26505",
    className: "cls-1",
    width: 1.176,
    height: 1.987
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-66"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77250",
    "data-name": "Path 77250",
    className: "cls-1",
    d: "M162.189,327.559l-.129.079.926,1.467.129-.08a.157.157,0,0,0,.06-.142v-.537a.49.49,0,0,0-.2-.378l-.639-.394a.177.177,0,0,0-.091-.03.1.1,0,0,0-.052.014",
    transform: "translate(-162.06 -327.545)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: -12.924,
    y1: 32.157,
    x2: -12.843,
    y2: 32.157,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#814e5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#73434f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.709,
    stopColor: "#4e2132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#411928"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-69"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77253",
    "data-name": "Path 77253",
    className: "cls-1",
    d: "M217.955,361.981l-.129.079.926,1.467.129-.08a.157.157,0,0,0,.06-.142v-.537a.49.49,0,0,0-.2-.378L218.1,362a.175.175,0,0,0-.091-.03.1.1,0,0,0-.053.014",
    transform: "translate(-217.826 -361.967)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: -17.435,
    y1: 29.616,
    x2: -17.354,
    y2: 29.616,
    xlinkHref: "#linear-gradient-27"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-72"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26512",
    "data-name": "Rectangle 26512",
    className: "cls-1",
    width: 9.047,
    height: 5.584
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-73"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77270",
    "data-name": "Path 77270",
    className: "cls-1",
    d: "M344.9,514.616l5.465-3.373a9,9,0,0,1,.111-1.433,5.005,5.005,0,0,0-1.827-.378c-2.223,0-3.748,1.886-3.748,5.184",
    transform: "translate(-344.896 -509.432)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: -6.429,
    y1: 5.018,
    x2: -6.41,
    y2: 5.018,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-74"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77271",
    "data-name": "Path 77271",
    className: "cls-1",
    d: "M359.581,503.831l-4.175,2.577c-2.162,1.334-2.162,5.662,0,9.665s5.667,6.167,7.829,4.833l4.175-2.577c2.162-1.334,2.162-5.662,0-9.665-1.729-3.2-4.317-5.227-6.39-5.227a2.7,2.7,0,0,0-1.439.394",
    transform: "translate(-353.785 -503.437)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: -1.943,
    y1: 1.601,
    x2: -1.937,
    y2: 1.601,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-75"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77272",
    "data-name": "Path 77272",
    className: "cls-1",
    d: "M374.112,503.831l-3.411,2.106c1.722-1.063,5.76,1.009,7.948,4.759,2.31,3.957,2.338,8.222-.208,9.794l3.5-2.161c2.162-1.334,2.162-5.662,0-9.665-1.729-3.2-4.317-5.227-6.39-5.227a2.7,2.7,0,0,0-1.439.394",
    transform: "translate(-370.701 -503.437)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: -2.429,
    y1: 1.794,
    x2: -2.422,
    y2: 1.794,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-77"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77275",
    "data-name": "Path 77275",
    className: "cls-1",
    d: "M372.408,546.412c-1.185.732-1.185,3.1,0,5.3s3.107,3.382,4.293,2.65,1.185-3.1,0-5.3c-.948-1.755-2.367-2.866-3.5-2.866a1.478,1.478,0,0,0-.789.216",
    transform: "translate(-371.519 -546.196)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: -4.923,
    y1: 2.842,
    x2: -4.909,
    y2: 2.842,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-79"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26519",
    "data-name": "Rectangle 26519",
    className: "cls-1",
    width: 5.547,
    height: 8.091
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-80"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77278",
    "data-name": "Path 77278",
    className: "cls-1",
    d: "M377.712,549.573c-.881.544-.881,2.306,0,3.938s2.309,2.512,3.19,1.969l1.436-.887a6.8,6.8,0,0,0-.885-3.391,6.263,6.263,0,0,0-2.3-2.515Z",
    transform: "translate(-377.052 -548.686)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: -6.075,
    y1: 3.379,
    x2: -6.059,
    y2: 3.379,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-82"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26522",
    "data-name": "Rectangle 26522",
    className: "cls-1",
    width: 4.16,
    height: 6.503
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-83"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77281",
    "data-name": "Path 77281",
    className: "cls-1",
    d: "M390.861,558.862a.739.739,0,0,0,.308.57c.17.105.308.02.308-.19a.739.739,0,0,0-.308-.571.265.265,0,0,0-.137-.045c-.1,0-.17.086-.17.235",
    transform: "translate(-390.861 -558.627)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: -71.961,
    y1: 28.479,
    x2: -71.776,
    y2: 28.479,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ecdcce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.138,
    stopColor: "#cab6b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.567,
    stopColor: "#a28283"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#917172"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-85"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77283",
    "data-name": "Path 77283",
    className: "cls-1",
    d: "M390.861,587.407a.74.74,0,0,0,.308.571c.17.105.308.02.308-.19a.74.74,0,0,0-.308-.571.266.266,0,0,0-.137-.045c-.1,0-.17.086-.17.235",
    transform: "translate(-390.861 -587.172)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: -71.962,
    y1: 24.469,
    x2: -71.777,
    y2: 24.469,
    xlinkHref: "#linear-gradient-34"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-87"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77285",
    "data-name": "Path 77285",
    className: "cls-1",
    d: "M402.422,580.271a.739.739,0,0,0,.308.571c.17.105.308.02.308-.19a.74.74,0,0,0-.308-.57.268.268,0,0,0-.138-.045c-.1,0-.171.086-.171.235",
    transform: "translate(-402.422 -580.036)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: -74.079,
    y1: 25.471,
    x2: -73.895,
    y2: 25.471,
    xlinkHref: "#linear-gradient-34"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-89"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77287",
    "data-name": "Path 77287",
    className: "cls-1",
    d: "M379.3,566a.739.739,0,0,0,.308.571c.17.105.308.02.308-.19a.74.74,0,0,0-.308-.571.267.267,0,0,0-.138-.045c-.1,0-.17.086-.17.235",
    transform: "translate(-379.3 -565.764)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: -69.828,
    y1: 27.473,
    x2: -69.643,
    y2: 27.473,
    xlinkHref: "#linear-gradient-34"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-91"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77289",
    "data-name": "Path 77289",
    className: "cls-1",
    d: "M399.126,567.876c-.12.074-.12.315,0,.538s.315.343.436.269.12-.315,0-.538a.487.487,0,0,0-.356-.291.149.149,0,0,0-.08.022",
    transform: "translate(-399.035 -567.854)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: -68.248,
    y1: 27.111,
    x2: -68.076,
    y2: 27.111,
    xlinkHref: "#linear-gradient-34"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-93"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77291",
    "data-name": "Path 77291",
    className: "cls-1",
    d: "M382.775,577.968c-.12.074-.12.315,0,.538s.316.343.436.269.12-.315,0-.538a.487.487,0,0,0-.356-.291.151.151,0,0,0-.08.022",
    transform: "translate(-382.685 -577.946)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: -65.445,
    y1: 25.698,
    x2: -65.274,
    y2: 25.698,
    xlinkHref: "#linear-gradient-34"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-95"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77293",
    "data-name": "Path 77293",
    className: "cls-1",
    d: "M399.126,588.06c-.12.074-.12.315,0,.538s.315.343.436.269.12-.315,0-.538a.487.487,0,0,0-.356-.291.15.15,0,0,0-.08.022",
    transform: "translate(-399.035 -588.038)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: -68.245,
    y1: 24.281,
    x2: -68.074,
    y2: 24.281,
    xlinkHref: "#linear-gradient-34"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-97"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77295",
    "data-name": "Path 77295",
    className: "cls-1",
    d: "M382.775,557.784c-.12.074-.12.315,0,.538s.316.343.436.269.12-.315,0-.538a.487.487,0,0,0-.356-.291.151.151,0,0,0-.08.022",
    transform: "translate(-382.685 -557.762)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: -65.445,
    y1: 28.525,
    x2: -65.274,
    y2: 28.525,
    xlinkHref: "#linear-gradient-34"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-99"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77297",
    "data-name": "Path 77297",
    className: "cls-1",
    d: "M387.216,567.582c-.335.207-.335.877,0,1.5s.878.956,1.212.749.335-.877,0-1.5a1.354,1.354,0,0,0-.99-.81.416.416,0,0,0-.223.061",
    transform: "translate(-386.965 -567.521)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.491,
    cy: 1.119,
    r: 0.926,
    gradientTransform: "matrix(1.335, 0, 0, -1.069, 9.701, 22.465)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8b5865"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.147,
    stopColor: "#8b5865"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.437,
    stopColor: "#814e5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4e2132"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-100"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77298",
    "data-name": "Path 77298",
    className: "cls-1",
    d: "M356.426,466.913l.027-.017-.027.017m5.464-3.372h0l-5.436,3.356a1.478,1.478,0,0,1,1.541.172l7.19,4.438a4.906,4.906,0,0,1,1.742,2.133l1.845,4.094a4.85,4.85,0,0,1,.457,1.939v4.287l5.465-3.373V476.3a4.848,4.848,0,0,0-.457-1.939l-1.845-4.094a4.906,4.906,0,0,0-1.742-2.133l-7.19-4.438a1.906,1.906,0,0,0-.983-.32,1.071,1.071,0,0,0-.587.165",
    transform: "translate(-356.426 -463.375)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: -1.775,
    y1: 1.675,
    x2: -1.769,
    y2: 1.675,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8b5865"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#814e5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    stopColor: "#814e5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633,
    stopColor: "#6a3b48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#5e303f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4e2132"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-102"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26542",
    "data-name": "Rectangle 26542",
    className: "cls-1",
    width: 17.687,
    height: 14.195
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-103"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26543",
    "data-name": "Rectangle 26543",
    className: "cls-1",
    width: 20.15,
    height: 12.438
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-104"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77313",
    "data-name": "Path 77313",
    className: "cls-1",
    d: "M398.646,446.131l-5.142,3.174c-.611.377-.611,1.6,0,2.731s1.6,1.743,2.213,1.366l5.142-3.174c.611-.377.611-1.6,0-2.732a2.471,2.471,0,0,0-1.806-1.477.764.764,0,0,0-.407.111",
    transform: "translate(-393.046 -446.02)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: -4.767,
    y1: 4.182,
    x2: -4.755,
    y2: 4.182,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b29498"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.327,
    stopColor: "#946e76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7d505c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#613443"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-106"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26546",
    "data-name": "Rectangle 26546",
    className: "cls-1",
    width: 7.43,
    height: 6.796
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-107"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77316",
    "data-name": "Path 77316",
    className: "cls-1",
    d: "M427.37,463.861l-5.142,3.174c-.611.377-.611,1.6,0,2.731s1.6,1.743,2.212,1.366l5.142-3.174c.611-.377.611-1.6,0-2.732a2.47,2.47,0,0,0-1.806-1.477.763.763,0,0,0-.407.111",
    transform: "translate(-421.77 -463.75)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: -5.125,
    y1: 3.955,
    x2: -5.113,
    y2: 3.955,
    xlinkHref: "#linear-gradient-43"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-110"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26550",
    "data-name": "Rectangle 26550",
    className: "cls-1",
    width: 24.857,
    height: 15
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-111"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26551",
    "data-name": "Rectangle 26551",
    className: "cls-1",
    width: 1.114,
    height: 0.688
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-112"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26552",
    "data-name": "Rectangle 26552",
    className: "cls-1",
    width: 0.557,
    height: 0.688
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-113"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26553",
    "data-name": "Rectangle 26553",
    className: "cls-1",
    width: 24.857,
    height: 15.687
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-118"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26558",
    "data-name": "Rectangle 26558",
    className: "cls-1",
    width: 0.294,
    height: 6.911
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-119"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26559",
    "data-name": "Rectangle 26559",
    className: "cls-1",
    width: 1.54,
    height: 0.593
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-121"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26561",
    "data-name": "Rectangle 26561",
    className: "cls-1",
    width: 1.53,
    height: 0.61
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-122"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26562",
    "data-name": "Rectangle 26562",
    className: "cls-1",
    width: 0.3,
    height: 6.844
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-123"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26563",
    "data-name": "Rectangle 26563",
    className: "cls-1",
    width: 0.335,
    height: 8.302
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-124"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26564",
    "data-name": "Rectangle 26564",
    className: "cls-1",
    width: 0.204,
    height: 0.062
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-127"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26567",
    "data-name": "Rectangle 26567",
    className: "cls-1",
    width: 0.344,
    height: 8.302
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-128"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26568",
    "data-name": "Rectangle 26568",
    className: "cls-1",
    width: 0.655,
    height: 0.384
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-129"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26569",
    "data-name": "Rectangle 26569",
    className: "cls-1",
    width: 19.275,
    height: 12.466
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-133"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26573",
    "data-name": "Rectangle 26573",
    className: "cls-1",
    width: 0.343,
    height: 8.302
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-138"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77423",
    "data-name": "Path 77423",
    className: "cls-1",
    d: "M361.276,269.087l-.345.367a.588.588,0,0,0-.087.518l.5,2.436a.612.612,0,0,0,.264.385l.838.484c.123.071.231.038.264-.081l.5-1.857a.968.968,0,0,0-.087-.619l-.345-.765a1.972,1.972,0,0,0-.752-.885.837.837,0,0,0-.411-.125.454.454,0,0,0-.341.142",
    transform: "translate(-360.824 -268.945)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: -9.827,
    y1: 16.015,
    x2: -9.799,
    y2: 16.015,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eb4e44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b23035"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-140"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26580",
    "data-name": "Rectangle 26580",
    className: "cls-1",
    width: 0.18,
    height: 0.916
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-141"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26581",
    "data-name": "Rectangle 26581",
    className: "cls-1",
    width: 0.18,
    height: 0.908
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-142"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77426",
    "data-name": "Path 77426",
    className: "cls-1",
    d: "M364.794,267.93h0m.309-.176-.309.176v0a.651.651,0,0,1,.643.066,1.972,1.972,0,0,1,.752.885l.345.765a1.175,1.175,0,0,1,.105.4.679.679,0,0,1-.018.219l-.321,1.191-.18.666a.2.2,0,0,1-.023.051l-.007.01a.137.137,0,0,1-.035.035l.307-.177a.161.161,0,0,0,.065-.1l.5-1.857a.969.969,0,0,0-.087-.619l-.345-.765a1.973,1.973,0,0,0-.752-.885.828.828,0,0,0-.408-.124.478.478,0,0,0-.235.058",
    transform: "translate(-364.794 -267.696)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: -12.156,
    y1: 13.938,
    x2: -12.122,
    y2: 13.938,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff6e5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.131,
    stopColor: "#eb4e44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#ca3c3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511,
    stopColor: "#ca3c3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    stopColor: "#851928"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.958,
    stopColor: "#851928"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#851928"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-144"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26584",
    "data-name": "Rectangle 26584",
    className: "cls-1",
    width: 1.148,
    height: 0.538
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-145"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26585",
    "data-name": "Rectangle 26585",
    className: "cls-1",
    width: 0.793,
    height: 0.235
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-146"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26586",
    "data-name": "Rectangle 26586",
    className: "cls-1",
    width: 0.731,
    height: 0.92
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-147"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77432",
    "data-name": "Path 77432",
    className: "cls-1",
    d: "M365.665,298.464v.313a.613.613,0,0,0,.088.3l.285.493a.653.653,0,0,1,.1.4l.28.683.259-.15a.476.476,0,0,0,.205-.406,1.57,1.57,0,0,0-.6-1.206.14.14,0,0,1-.052-.1v-.3l-.3-.176Z",
    transform: "translate(-365.665 -298.314)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: -22.791,
    y1: 24.739,
    x2: -22.728,
    y2: 24.739,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#562838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402,
    stopColor: "#562838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645,
    stopColor: "#5d303e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855,
    stopColor: "#4e2132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#411928"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-148"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77433",
    "data-name": "Path 77433",
    className: "cls-1",
    d: "M361.939,302.951l-.259.15c-.015.007-.022.027-.012.059l.091.3c.013.045.023.089.032.133a1.556,1.556,0,0,0,.748,1.024.46.46,0,0,0,.439.012l-.28-.683a.607.607,0,0,1-.289-.271l-.4-.686a.077.077,0,0,0-.059-.045.029.029,0,0,0-.014,0",
    transform: "translate(-361.663 -302.948)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: -25.072,
    y1: 29.746,
    x2: -25.002,
    y2: 29.746,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#84515e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#592d3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#592d3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.553,
    stopColor: "#6e3f4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666,
    stopColor: "#84515e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84515e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-150"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26590",
    "data-name": "Rectangle 26590",
    className: "cls-1",
    width: 0.864,
    height: 1.299
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-151"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26591",
    "data-name": "Rectangle 26591",
    className: "cls-1",
    width: 0.18,
    height: 0.506
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-152"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26592",
    "data-name": "Rectangle 26592",
    className: "cls-1",
    width: 0.934,
    height: 1.597
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-153"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77438",
    "data-name": "Path 77438",
    className: "cls-1",
    d: "M366.581,148.057l-.733.423a.736.736,0,0,0-.313.678v5.822l.008,0a2.122,2.122,0,0,0,.305,1.03c.407.705,1.067,1.086,1.474.851l.733-.423a.739.739,0,0,0,.305-.678h0v-5.822h0a2.116,2.116,0,0,0-.3-1.035,1.633,1.633,0,0,0-1.2-.921.535.535,0,0,0-.271.069",
    transform: "translate(-365.535 -147.988)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: -7.057,
    y1: 9.298,
    x2: -7.037,
    y2: 9.298,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff6e5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.131,
    stopColor: "#eb4e44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#851928"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.939,
    stopColor: "#851928"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#781928"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-155"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26595",
    "data-name": "Rectangle 26595",
    className: "cls-1",
    width: 0.084,
    height: 0.301
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-156"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26596",
    "data-name": "Rectangle 26596",
    className: "cls-1",
    width: 3.191,
    height: 1.208
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-157"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77447",
    "data-name": "Path 77447",
    className: "cls-1",
    d: "M361.65,155.044l-1.177.68c-.238.137-.238.582,0,.993a1.238,1.238,0,0,0,.43.454l1.786-1.031a1.239,1.239,0,0,0-.178-.6.953.953,0,0,0-.7-.537.313.313,0,0,0-.158.04",
    transform: "translate(-360.294 -155.004)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: -15.7,
    y1: 27.686,
    x2: -15.656,
    y2: 27.686,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a88a8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#8a6c73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.858,
    stopColor: "#62404c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#62404c"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-158"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77448",
    "data-name": "Path 77448",
    className: "cls-1",
    d: "M350.8,157.171l-.733.423a.737.737,0,0,0-.313.678v5.822l.008,0a2.121,2.121,0,0,0,.305,1.03c.407.705,1.067,1.086,1.474.851l.733-.423a.739.739,0,0,0,.305-.678h0v-5.822h0a2.114,2.114,0,0,0-.305-1.035,1.632,1.632,0,0,0-1.2-.921.533.533,0,0,0-.271.07",
    transform: "translate(-349.75 -157.101)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: -6.74,
    y1: 9.16,
    x2: -6.72,
    y2: 9.16,
    xlinkHref: "#linear-gradient-49"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-160"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26600",
    "data-name": "Rectangle 26600",
    className: "cls-1",
    width: 1.287,
    height: 2.03
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-161"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26601",
    "data-name": "Rectangle 26601",
    className: "cls-1",
    width: 1.288,
    height: 2.204
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-162"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26602",
    "data-name": "Rectangle 26602",
    className: "cls-1",
    width: 0.563,
    height: 0.495
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-163"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77459",
    "data-name": "Path 77459",
    className: "cls-1",
    d: "M352.156,164.906l-.236.137c-.205.118-.205.5,0,.859s.539.548.744.429l.236-.136c.205-.119.205-.5,0-.859a.823.823,0,0,0-.607-.464.271.271,0,0,0-.137.035",
    transform: "translate(-351.766 -164.871)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: -24.702,
    y1: 40.879,
    x2: -24.631,
    y2: 40.879,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff6e5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128,
    stopColor: "#ff6e5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.439,
    stopColor: "#eb4e44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.827,
    stopColor: "#851928"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#851928"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-165"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77461",
    "data-name": "Path 77461",
    className: "cls-1",
    d: "M352.156,206.192l-.236.136c-.205.119-.205.5,0,.859s.539.548.744.429l.236-.136c.205-.119.205-.5,0-.859a.823.823,0,0,0-.607-.465.271.271,0,0,0-.137.035",
    transform: "translate(-351.766 -206.157)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: -24.702,
    y1: 38.057,
    x2: -24.632,
    y2: 38.057,
    xlinkHref: "#linear-gradient-52"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-167"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26607",
    "data-name": "Rectangle 26607",
    className: "cls-1",
    width: 0.474,
    height: 0.171
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-168"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26608",
    "data-name": "Rectangle 26608",
    className: "cls-1",
    width: 0.225,
    height: 0.065
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-169"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77466",
    "data-name": "Path 77466",
    className: "cls-1",
    d: "M356.109,270.977l-.307.177a.442.442,0,0,0-.1.079l-.345.367a.588.588,0,0,0-.087.518l.5,2.436a.613.613,0,0,0,.264.385l.838.484a.192.192,0,0,0,.192.019l.793-.458a.137.137,0,0,0,.035-.034l.007-.01a.194.194,0,0,0,.023-.051l.18-.666.322-1.191a.679.679,0,0,0,.018-.219,1.174,1.174,0,0,0-.105-.4l-.479.277-.345-.765a1.974,1.974,0,0,0-.752-.885.829.829,0,0,0-.408-.124.477.477,0,0,0-.242.062",
    transform: "translate(-355.247 -270.915)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: -9.695,
    y1: 12.527,
    x2: -9.667,
    y2: 12.527,
    xlinkHref: "#linear-gradient-46"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-172"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26612",
    "data-name": "Rectangle 26612",
    className: "cls-1",
    width: 0.768,
    height: 1.331
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-173"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77473",
    "data-name": "Path 77473",
    className: "cls-1",
    d: "M360.151,279.6l-.171.1c-.149.086-.149.365,0,.622s.39.4.539.311l.171-.1c.149-.086.149-.365,0-.622a.6.6,0,0,0-.44-.337.2.2,0,0,0-.1.025",
    transform: "translate(-359.868 -279.57)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: -34.939,
    y1: 45.538,
    x2: -34.841,
    y2: 45.538,
    xlinkHref: "#linear-gradient-52"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-175"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26617",
    "data-name": "Rectangle 26617",
    className: "cls-1",
    width: 9.888,
    height: 1.699,
    transform: "matrix(0.228, -0.974, 0.974, 0.228, 0, 9.627)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: -6.613,
    y1: 7.837,
    x2: -6.599,
    y2: 7.837,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-177"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77482",
    "data-name": "Path 77482",
    className: "cls-1",
    d: "M544.451,408.7l.716.168a.295.295,0,0,0,.107-.454l-.716-.168Z",
    transform: "translate(-544.451 -408.245)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: -85.337,
    y1: 80.001,
    x2: -85.18,
    y2: 80.001,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-178"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77483",
    "data-name": "Path 77483",
    className: "cls-1",
    d: "M541.873,390.388c-.029.125.132.27.361.324s.437,0,.467-.13h0l.058-.25.663-2.833-.827-.194Z",
    transform: "translate(-541.87 -387.305)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: -20.193,
    y1: 22.409,
    x2: -20.155,
    y2: 22.409,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d6c4bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#ecdcce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#cab6b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664,
    stopColor: "#a28283"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    stopColor: "#917172"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#917172"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-179"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77484",
    "data-name": "Path 77484",
    className: "cls-1",
    d: "M445.677,247.469l4.913,5.406c.087.1.3.045.471-.113s.244-.363.158-.458h0l-.173-.19-4.74-5.216Z",
    transform: "translate(-445.677 -246.898)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: -7.459,
    y1: 8.891,
    x2: -7.442,
    y2: 8.891,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b39998"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#dbc7bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.366,
    stopColor: "#ecdcce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.619,
    stopColor: "#dbc7bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.912,
    stopColor: "#a28283"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#917172"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-181"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26622",
    "data-name": "Rectangle 26622",
    className: "cls-1",
    width: 5.64,
    height: 4.944
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-182"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77486",
    "data-name": "Path 77486",
    className: "cls-1",
    d: "M478.247,282.969c-.347.316-.5.713-.342.887l8.182,9,1.258-1.143-8.182-9a.283.283,0,0,0-.217-.082,1.156,1.156,0,0,0-.7.337",
    transform: "translate(-477.843 -282.632)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: -4.654,
    y1: 4.944,
    x2: -4.644,
    y2: 4.944,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4e2132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261,
    stopColor: "#6e3f4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514,
    stopColor: "#84515e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#84515e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.837,
    stopColor: "#744450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5d2f3e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-184"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26625",
    "data-name": "Rectangle 26625",
    className: "cls-1",
    width: 1.539,
    height: 1.087
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-185"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26626",
    "data-name": "Rectangle 26626",
    className: "cls-1",
    width: 3.262,
    height: 4.686
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-186"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77490",
    "data-name": "Path 77490",
    className: "cls-1",
    d: "M554.2,381.19l2.079,3.2a1.633,1.633,0,0,1,.286,1.248l-3.861,13.026a.487.487,0,0,1-.218.3l2.411-1.392a.487.487,0,0,0,.218-.3l3.861-13.026a1.633,1.633,0,0,0-.286-1.248l-2.079-3.2Z",
    transform: "translate(-552.488 -379.798)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: -4.812,
    y1: 2.722,
    x2: -4.803,
    y2: 2.722,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#841928"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    stopColor: "#97212b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.244,
    stopColor: "#97212b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.336,
    stopColor: "#841928"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.983,
    stopColor: "#841928"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7c1725"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-187"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77491",
    "data-name": "Path 77491",
    className: "cls-1",
    d: "M578.3,410.662a1.633,1.633,0,0,1,.286,1.248l.573-.331a1.435,1.435,0,0,0-.739-.987l-.3-.2Z",
    transform: "translate(-578.118 -410.388)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: -48.654,
    y1: 26.926,
    x2: -48.57,
    y2: 26.926,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c33232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#841928"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-189"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26630",
    "data-name": "Rectangle 26630",
    className: "cls-1",
    width: 0.395,
    height: 2.704
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-190"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26631",
    "data-name": "Rectangle 26631",
    className: "cls-1",
    width: 3.922,
    height: 1.79
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-191"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26632",
    "data-name": "Rectangle 26632",
    className: "cls-1",
    width: 0.932,
    height: 1.652
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-192"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26633",
    "data-name": "Rectangle 26633",
    className: "cls-1",
    width: 11.511,
    height: 6.459
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-193"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77506",
    "data-name": "Path 77506",
    className: "cls-1",
    d: "M477.972,231.109l-3.865,2.231a.445.445,0,0,1,.446.045l2.551,1.473a3.294,3.294,0,0,1,1.1,1.117l9.091,14.686a2.6,2.6,0,0,1,.429,1.611l-.439,3.292a.627.627,0,0,1-.284.488h0l.728-.421h0a.626.626,0,0,0,.284-.488l.072-.538c.186-1.393,2.6-2.785,2.411-1.393l-.072.539c0,.009,0,.017,0,.025l.143.219.3-.176a.626.626,0,0,0,.285-.489l.438-3.292a2.6,2.6,0,0,0-.429-1.611l-9.091-14.686a3.294,3.294,0,0,0-1.1-1.117l-2.551-1.473a.573.573,0,0,0-.283-.086.326.326,0,0,0-.165.042",
    transform: "translate(-474.107 -231.067)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: -2.224,
    y1: 2.545,
    x2: -2.219,
    y2: 2.545,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff6b57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.018,
    stopColor: "#f3614d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.113,
    stopColor: "#f3614d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.165,
    stopColor: "#c33232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.823,
    stopColor: "#c33232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.889,
    stopColor: "#841928"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "#841928"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7c1725"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-194"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77507",
    "data-name": "Path 77507",
    className: "cls-1",
    d: "M397.241,178.722c-.117.2-.117.423,0,.491l1,.578c.117.068.307-.042.425-.245s.117-.423,0-.491l-1-.578a.153.153,0,0,0-.078-.02.47.47,0,0,0-.347.265",
    transform: "translate(-397.153 -178.457)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: -27.298,
    y1: 38.598,
    x2: -27.229,
    y2: 38.598,
    xlinkHref: "#linear-gradient-59"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-196"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26637",
    "data-name": "Rectangle 26637",
    className: "cls-1",
    width: 0.784,
    height: 1.132
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-197"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77509",
    "data-name": "Path 77509",
    className: "cls-1",
    d: "M402.7,180.563c-.235.407-.235.846,0,.981l10.536,6.083c.235.135.615-.084.85-.491s.235-.846,0-.981l-10.536-6.083a.307.307,0,0,0-.156-.04.941.941,0,0,0-.694.53",
    transform: "translate(-402.519 -180.033)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: -4.462,
    y1: 6.024,
    x2: -4.451,
    y2: 6.024,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5d2f3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#744450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433,
    stopColor: "#84515e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.513,
    stopColor: "#84515e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.798,
    stopColor: "#6e3f4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4e2132"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-199"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77513",
    "data-name": "Path 77513",
    className: "cls-1",
    d: "M777.435,407.994,775.52,409.1a.969.969,0,0,0-.438.76v5.316a.307.307,0,0,0,.13.284l.564.326,2.531-7.5-.565-.326a.226.226,0,0,0-.113-.028.4.4,0,0,0-.2.06",
    transform: "translate(-775.082 -407.934)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: -12.679,
    y1: 7.346,
    x2: -12.662,
    y2: 7.346,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#754654"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.057,
    stopColor: "#814e5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671,
    stopColor: "#814e5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e4150"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-201"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26642",
    "data-name": "Rectangle 26642",
    className: "cls-1",
    width: 0.958,
    height: 0.454
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-202"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77516",
    "data-name": "Path 77516",
    className: "cls-1",
    d: "M771.2,398.486a1.054,1.054,0,0,0-.239.1l0,0-1.623.937.03.051.029.051.043.074.043.074.043.074.043.074.041.071.041.07.041.07.041.071,1.623-.937h0a.691.691,0,0,1,.066-.03h0v0a.667.667,0,0,1,.006.072v1.246h.787v-1.247a1.082,1.082,0,0,0-.03-.254.878.878,0,0,0-.126-.295.77.77,0,0,0-.233-.22.781.781,0,0,0-.3-.1l-.066,0a.844.844,0,0,0-.258.039",
    transform: "translate(-769.335 -398.447)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-203"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26645",
    "data-name": "Rectangle 26645",
    className: "cls-1",
    width: 2.882,
    height: 2.113
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-205"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77518",
    "data-name": "Path 77518",
    className: "cls-1",
    d: "M784.191,405.624c0,.126.176.227.393.227a.521.521,0,0,0,.319-.1,3.205,3.205,0,0,1-.713-1.414Z",
    transform: "translate(-784.191 -404.342)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: -155.164,
    y1: 33.331,
    x2: -154.966,
    y2: 33.331,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#73434f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4e2132"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-207"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77520",
    "data-name": "Path 77520",
    className: "cls-1",
    d: "M463.956,580.383c-2.483-.114-4.207,1.787-4.207,5.149l4.442-2.564a6.833,6.833,0,0,1,.606-3Z",
    transform: "translate(-459.749 -579.972)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: -8.917,
    y1: 3.6,
    x2: -8.897,
    y2: 3.6,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-209"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77524",
    "data-name": "Path 77524",
    className: "cls-1",
    d: "M475.372,577.25l-4.442,2.564c-2.3,1.328-2.3,5.634,0,9.618s6.029,6.137,8.329,4.809l4.442-2.564c2.3-1.328,2.3-5.634,0-9.618-1.839-3.186-4.593-5.2-6.8-5.2a3.02,3.02,0,0,0-1.531.392",
    transform: "translate(-469.205 -576.858)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: -2.544,
    y1: 1.168,
    x2: -2.538,
    y2: 1.168,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-210"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77525",
    "data-name": "Path 77525",
    className: "cls-1",
    d: "M490.831,577.25l-3.629,2.1c1.832-1.058,6.127,1,8.456,4.736,2.457,3.938,2.487,8.182-.222,9.746l3.724-2.15c2.3-1.328,2.3-5.634,0-9.618-1.839-3.186-4.593-5.2-6.8-5.2a3.02,3.02,0,0,0-1.531.392",
    transform: "translate(-487.202 -576.858)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: -3.14,
    y1: 1.301,
    x2: -3.133,
    y2: 1.301,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-212"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77528",
    "data-name": "Path 77528",
    className: "cls-1",
    d: "M489.018,619.622c-1.261.728-1.261,3.089,0,5.274s3.306,3.365,4.567,2.637,1.261-3.089,0-5.273c-1.009-1.747-2.518-2.852-3.728-2.852a1.656,1.656,0,0,0-.839.215",
    transform: "translate(-488.072 -619.407)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: -6.319,
    y1: 1.887,
    x2: -6.306,
    y2: 1.887,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-214"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26656",
    "data-name": "Rectangle 26656",
    className: "cls-1",
    width: 5.901,
    height: 8.051
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-215"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77531",
    "data-name": "Path 77531",
    className: "cls-1",
    d: "M494.66,622.767c-.937.541-.937,2.3,0,3.918s2.456,2.5,3.393,1.959l1.528-.882a7.036,7.036,0,0,0-3.393-5.877Z",
    transform: "translate(-493.958 -621.885)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: -7.758,
    y1: 2.222,
    x2: -7.742,
    y2: 2.222,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-217"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26659",
    "data-name": "Rectangle 26659",
    className: "cls-1",
    width: 4.425,
    height: 6.471
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-218"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77534",
    "data-name": "Path 77534",
    className: "cls-1",
    d: "M508.65,632.011a.725.725,0,0,0,.328.568c.181.1.328.02.328-.189a.724.724,0,0,0-.328-.568.3.3,0,0,0-.146-.045c-.107,0-.181.086-.181.234",
    transform: "translate(-508.65 -631.777)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: -89.232,
    y1: 18.164,
    x2: -89.056,
    y2: 18.164,
    xlinkHref: "#linear-gradient-34"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-220"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77536",
    "data-name": "Path 77536",
    className: "cls-1",
    d: "M508.649,660.417a.725.725,0,0,0,.328.568c.181.1.328.02.328-.189a.724.724,0,0,0-.328-.568.3.3,0,0,0-.146-.045c-.108,0-.182.086-.182.234",
    transform: "translate(-508.649 -660.183)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: -89.217,
    y1: 14.184,
    x2: -89.041,
    y2: 14.184,
    xlinkHref: "#linear-gradient-34"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-222"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77538",
    "data-name": "Path 77538",
    className: "cls-1",
    d: "M520.95,653.315a.724.724,0,0,0,.328.568c.181.1.328.02.328-.189a.724.724,0,0,0-.328-.568.3.3,0,0,0-.146-.045c-.108,0-.181.086-.181.234",
    transform: "translate(-520.95 -653.081)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: -91.393,
    y1: 15.179,
    x2: -91.217,
    y2: 15.179,
    xlinkHref: "#linear-gradient-34"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-224"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77540",
    "data-name": "Path 77540",
    className: "cls-1",
    d: "M496.35,639.113a.724.724,0,0,0,.328.568c.181.1.328.02.328-.189a.725.725,0,0,0-.328-.568.3.3,0,0,0-.147-.045c-.108,0-.181.086-.181.234",
    transform: "translate(-496.35 -638.879)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: -87.073,
    y1: 17.169,
    x2: -86.898,
    y2: 17.169,
    xlinkHref: "#linear-gradient-34"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-226"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77542",
    "data-name": "Path 77542",
    className: "cls-1",
    d: "M517.443,640.98c-.128.074-.128.314,0,.535s.336.341.464.268.128-.314,0-.535a.514.514,0,0,0-.378-.289.168.168,0,0,0-.085.022",
    transform: "translate(-517.347 -640.958)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: -84.245,
    y1: 16.823,
    x2: -84.082,
    y2: 16.823,
    xlinkHref: "#linear-gradient-34"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-228"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77544",
    "data-name": "Path 77544",
    className: "cls-1",
    d: "M500.049,651.024c-.128.074-.128.314,0,.535s.336.342.464.268.128-.313,0-.535a.514.514,0,0,0-.378-.289.168.168,0,0,0-.085.022",
    transform: "translate(-499.953 -651.002)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: -81.412,
    y1: 15.423,
    x2: -81.249,
    y2: 15.423,
    xlinkHref: "#linear-gradient-34"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-230"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77546",
    "data-name": "Path 77546",
    className: "cls-1",
    d: "M517.443,661.066c-.128.074-.128.313,0,.535s.336.341.464.268.128-.313,0-.535a.513.513,0,0,0-.378-.289.168.168,0,0,0-.085.022",
    transform: "translate(-517.347 -661.044)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: -84.245,
    y1: 14.018,
    x2: -84.082,
    y2: 14.018,
    xlinkHref: "#linear-gradient-34"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-232"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77548",
    "data-name": "Path 77548",
    className: "cls-1",
    d: "M500.049,630.938c-.128.074-.128.314,0,.535s.336.341.464.268.128-.314,0-.535a.514.514,0,0,0-.378-.289.169.169,0,0,0-.085.022",
    transform: "translate(-499.953 -630.916)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: -81.409,
    y1: 18.225,
    x2: -81.246,
    y2: 18.225,
    xlinkHref: "#linear-gradient-34"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-234"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77550",
    "data-name": "Path 77550",
    className: "cls-1",
    d: "M504.772,640.688c-.356.206-.356.873,0,1.49s.934.951,1.29.745.356-.873,0-1.49a1.429,1.429,0,0,0-1.053-.805.468.468,0,0,0-.237.061",
    transform: "translate(-504.505 -640.627)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.491,
    cy: 1.119,
    r: 0.99,
    gradientTransform: "matrix(1.249, 0, 0, -1, 8.827, 13.579)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-235"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77551",
    "data-name": "Path 77551",
    className: "cls-1",
    d: "M474.827,534.907l7.559,4.365a13.942,13.942,0,0,1,6.307,10.925v8.3l2.72-1.57v-7.941l-2.459-1.42a14.141,14.141,0,0,0-6.027-8.609l-7.559-4.364Z",
    transform: "translate(-474.827 -534.595)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: -2.433,
    y1: 1.192,
    x2: -2.427,
    y2: 1.192,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9ba8e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#798bcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.952,
    stopColor: "#4e4479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#473d6f"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-237"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26679",
    "data-name": "Rectangle 26679",
    className: "cls-1",
    width: 0.541,
    height: 1.474
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-238"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26680",
    "data-name": "Rectangle 26680",
    className: "cls-1",
    width: 7.912,
    height: 4.408
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-242"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26684",
    "data-name": "Rectangle 26684",
    className: "cls-1",
    width: 7.371,
    height: 3.858
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-243"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26685",
    "data-name": "Rectangle 26685",
    className: "cls-1",
    width: 4.025,
    height: 9.206
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-244"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26686",
    "data-name": "Rectangle 26686",
    className: "cls-1",
    width: 4.025,
    height: 6.488
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-245"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77571",
    "data-name": "Path 77571",
    className: "cls-1",
    d: "M510.221,462.5v4.222a3.147,3.147,0,0,0,1.424,2.466l2.6,1.5v-.382L511.975,469a3.146,3.146,0,0,1-1.424-2.466v-4.222a1.128,1.128,0,0,1,.266-.8c-.361.09-.6.44-.6.992",
    transform: "translate(-510.221 -461.508)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: -8.97,
    y1: 4.267,
    x2: -8.952,
    y2: 4.267,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4e4479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597,
    stopColor: "#798bcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ba8e0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-247"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26689",
    "data-name": "Rectangle 26689",
    className: "cls-1",
    width: 0.664,
    height: 1.488
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-248"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26690",
    "data-name": "Rectangle 26690",
    className: "cls-1",
    width: 8.482,
    height: 13.905
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-249"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26691",
    "data-name": "Rectangle 26691",
    className: "cls-1",
    width: 6.893,
    height: 7.701
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-250"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77576",
    "data-name": "Path 77576",
    className: "cls-1",
    d: "M550.366,532.158l4.2,2.425a2.742,2.742,0,0,1,1.021,1.17l.38.788a2.739,2.739,0,0,0,1.021,1.17l1.337.772c.236.136.428.069.5-.127a.531.531,0,0,1-.165-.064l-1.337-.772a2.741,2.741,0,0,1-1.021-1.17l-.38-.788a2.742,2.742,0,0,0-1.021-1.17l-4.2-2.425Z",
    transform: "translate(-550.366 -531.967)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: -7.185,
    y1: 3.401,
    x2: -7.172,
    y2: 3.401,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9ba8e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.349,
    stopColor: "#6b74b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.593,
    stopColor: "#6b74b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ba8e0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-252"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26694",
    "data-name": "Rectangle 26694",
    className: "cls-1",
    width: 0.662,
    height: 0.191
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-253"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26695",
    "data-name": "Rectangle 26695",
    className: "cls-1",
    width: 3.135,
    height: 19.122
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-255"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26697",
    "data-name": "Rectangle 26697",
    className: "cls-1",
    width: 2.564,
    height: 2.961
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-256"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77588",
    "data-name": "Path 77588",
    className: "cls-1",
    d: "M614.927,646.757l.934.539h1.225l4.379-2.528-1.547-.893Z",
    transform: "translate(-614.927 -643.875)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: -11.704,
    y1: 2.873,
    x2: -11.685,
    y2: 2.873,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a4fa5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#534996"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-257"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77589",
    "data-name": "Path 77589",
    className: "cls-1",
    d: "M749.1,569.295l1.547.893,4.379-2.528v-.707l-.934-.539Z",
    transform: "translate(-749.098 -566.413)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: -14.97,
    y1: 4.602,
    x2: -14.95,
    y2: 4.602,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-259"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26701",
    "data-name": "Rectangle 26701",
    className: "cls-1",
    width: 7.409,
    height: 4.636
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-260"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77619",
    "data-name": "Path 77619",
    className: "cls-1",
    d: "M588.759,391.494v1.148a.663.663,0,0,0,.391.545l2.9,1.672a2.086,2.086,0,0,0,1.887,0l5.378-3.105a.664.664,0,0,0,.391-.547V390.06Z",
    transform: "translate(-588.759 -390.06)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: -7.587,
    y1: 10.258,
    x2: -7.574,
    y2: 10.258,
    xlinkHref: "#linear-gradient-67"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-262"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26704",
    "data-name": "Rectangle 26704",
    className: "cls-1",
    width: 0.801,
    height: 0.905
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-263"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26705",
    "data-name": "Rectangle 26705",
    className: "cls-1",
    width: 0.975,
    height: 0.221
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-264"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26706",
    "data-name": "Rectangle 26706",
    className: "cls-1",
    width: 0.801,
    height: 0.902
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-266"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26708",
    "data-name": "Rectangle 26708",
    className: "cls-1",
    width: 23.754,
    height: 23.533
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-267"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77635",
    "data-name": "Path 77635",
    className: "cls-1",
    d: "M651.181,412.887l1.92,9.646a2.194,2.194,0,0,1-.872,2.217l-19.37,11.184a.926.926,0,0,1-.749.105.883.883,0,0,0,1.08.086l19.37-11.184a2.194,2.194,0,0,0,.872-2.217l-1.988-9.989Z",
    transform: "translate(-632.11 -412.735)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: -2.713,
    y1: 1.738,
    x2: -2.708,
    y2: 1.738,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a4fa5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#473d68"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-269"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77649",
    "data-name": "Path 77649",
    className: "cls-1",
    d: "M601.564,599.855l2.155,1.244v-5.356l-2.155-1.244Z",
    transform: "translate(-601.564 -594.499)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: -39.364,
    y1: 3.558,
    x2: -39.299,
    y2: 3.558,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7082be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#798bcb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-271"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26713",
    "data-name": "Rectangle 26713",
    className: "cls-1",
    width: 2.155,
    height: 4.954
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-272"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26714",
    "data-name": "Rectangle 26714",
    className: "cls-1",
    width: 1.754,
    height: 2.9
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-273"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77655",
    "data-name": "Path 77655",
    className: "cls-1",
    d: "M548.019,552.738v2.522l.72.416a.492.492,0,0,0,.5.047l.331-.192a.5.5,0,0,0,.2-.452v-.9a1.555,1.555,0,0,0-.7-1.219l-.72-.416Z",
    transform: "translate(-548.019 -552.547)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: -24.911,
    y1: 8.02,
    x2: -24.865,
    y2: 8.02,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#814e5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226,
    stopColor: "#814e5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#73434f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652,
    stopColor: "#4e2132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891,
    stopColor: "#4e2132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#411928"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-275"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26717",
    "data-name": "Rectangle 26717",
    className: "cls-1",
    width: 1.66,
    height: 4.603
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-276"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26718",
    "data-name": "Rectangle 26718",
    className: "cls-1",
    width: 24.963,
    height: 15.357
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-277"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26719",
    "data-name": "Rectangle 26719",
    className: "cls-1",
    width: 24.517,
    height: 16.855
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-279"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77661",
    "data-name": "Path 77661",
    className: "cls-1",
    d: "M582.848,574.979h-.728v1.247a1.09,1.09,0,0,0,.03.253.872.872,0,0,0,.126.294.774.774,0,0,0,.232.22.784.784,0,0,0,.3.1.869.869,0,0,0,.324-.036,1.068,1.068,0,0,0,.239-.1l0,0,1.623-.937-.041-.071-.041-.07-.041-.07-.041-.07-.043-.074-.043-.075-.043-.074-.043-.074-.03-.051-.03-.051-1.623.937h0a.587.587,0,0,1-.066.03h0v0a.542.542,0,0,1-.006-.072v-1.245Z",
    transform: "translate(-582.12 -574.979)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-280"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26723",
    "data-name": "Rectangle 26723",
    className: "cls-1",
    width: 2.882,
    height: 2.119
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-282"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77663",
    "data-name": "Path 77663",
    className: "cls-1",
    d: "M599.27,577.361c-.109.063-.109.266,0,.454s.285.29.394.227.109-.266,0-.455a.436.436,0,0,0-.321-.246.144.144,0,0,0-.072.019",
    transform: "translate(-599.189 -577.342)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: -92.6,
    y1: 26.917,
    x2: -92.445,
    y2: 26.917,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4e2132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414,
    stopColor: "#4e2132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#73434f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73434f"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-283"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77664",
    "data-name": "Path 77664",
    className: "cls-1",
    d: "M575.364,524.66l-1.914,1.1a.97.97,0,0,0-.439.76v5.316a.307.307,0,0,0,.13.284l.564.326,2.532-7.5-.565-.326a.226.226,0,0,0-.113-.028.4.4,0,0,0-.2.06",
    transform: "translate(-573.011 -524.6)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: -9.293,
    y1: 4.892,
    x2: -9.277,
    y2: 4.892,
    xlinkHref: "#linear-gradient-66"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-285"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26727",
    "data-name": "Rectangle 26727",
    className: "cls-1",
    width: 1.55,
    height: 0.736
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-286"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77667",
    "data-name": "Path 77667",
    className: "cls-1",
    d: "M582.986,504.941l0,0a1.865,1.865,0,0,0-.862,1.494v1.247h.787v-1.245a1.091,1.091,0,0,1,.47-.814h0l1.623-.937-.041-.07-.041-.07-.041-.07-.041-.071-.043-.074-.043-.074-.043-.074-.043-.074-.03-.051-.03-.051-1.623.937",
    transform: "translate(-582.12 -504.004)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-287"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26730",
    "data-name": "Rectangle 26730",
    className: "cls-1",
    width: 2.882,
    height: 3.679
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-288"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77668",
    "data-name": "Path 77668",
    className: "cls-1",
    d: "M599.27,503.892c-.109.063-.109.266,0,.454s.285.29.394.227.109-.266,0-.454a.436.436,0,0,0-.321-.246.143.143,0,0,0-.072.018",
    transform: "translate(-599.189 -503.873)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: -92.607,
    y1: 37.644,
    x2: -92.452,
    y2: 37.644,
    xlinkHref: "#linear-gradient-90"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-289"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77669",
    "data-name": "Path 77669",
    className: "cls-1",
    d: "M582.12,528.713c0,.125.176.227.393.227s.394-.1.394-.227-.176-.227-.394-.227-.393.1-.393.227",
    transform: "translate(-582.12 -528.486)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: -104.283,
    y1: 72.157,
    x2: -104.104,
    y2: 72.157,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#73434f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#73434f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.586,
    stopColor: "#4e2132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4e2132"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-291"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77675",
    "data-name": "Path 77675",
    className: "cls-1",
    d: "M765.6,517.694l-1.755,6.241.871-.5a3.385,3.385,0,0,0,1.491-2.323l.536-4.076Z",
    transform: "translate(-763.849 -517.034)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: -17.854,
    y1: 4.667,
    x2: -17.83,
    y2: 4.667,
    xlinkHref: "#linear-gradient-87"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-293"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77680",
    "data-name": "Path 77680",
    className: "cls-1",
    d: "M636.958,598.138l.536,3.457c.12.774.751,1.028,1.491.6l.872-.5-1.755-4.215Z",
    transform: "translate(-636.958 -597.478)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: -17.403,
    y1: 3.973,
    x2: -17.375,
    y2: 3.973,
    xlinkHref: "#linear-gradient-87"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-294"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77681",
    "data-name": "Path 77681",
    className: "cls-1",
    d: "M637.6,598.086l1.639,3.938,1.169-.331-1.755-4.215Z",
    transform: "translate(-637.6 -597.478)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: -20.555,
    y1: 4.442,
    x2: -20.523,
    y2: 4.442,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#473f6d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4e4479"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-296"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77698",
    "data-name": "Path 77698",
    className: "cls-1",
    d: "M765.6,520.105l-1.755,6.241.574-.675,1.639-5.831Z",
    transform: "translate(-763.849 -519.841)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: -15.356,
    y1: 8.381,
    x2: -15.335,
    y2: 8.381,
    xlinkHref: "#linear-gradient-96"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-298"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26743",
    "data-name": "Rectangle 26743",
    className: "cls-1",
    width: 1.648,
    height: 0.906
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-299"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26744",
    "data-name": "Rectangle 26744",
    className: "cls-1",
    width: 1.396,
    height: 0.609
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-300"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26745",
    "data-name": "Rectangle 26745",
    className: "cls-1",
    width: 0.628,
    height: 0.472
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-301"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26746",
    "data-name": "Rectangle 26746",
    className: "cls-1",
    width: 2.47,
    height: 1.249
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-302"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77707",
    "data-name": "Path 77707",
    className: "cls-1",
    d: "M568.331,452.97v.459c0,.345.484.625,1.082.625s1.082-.28,1.082-.625v-.459c0-.345-.484-.625-1.082-.625s-1.082.28-1.082.625",
    transform: "translate(-568.331 -452.345)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: -37.037,
    y1: 25.477,
    x2: -36.972,
    y2: 25.477,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#73434f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.119,
    stopColor: "#73434f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668,
    stopColor: "#4e2132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4e2132"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-304"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77710",
    "data-name": "Path 77710",
    className: "cls-1",
    d: "M572.408,447.408c-.168.29-.168.6,0,.7l.192.111c.167.1.439-.06.606-.35s.167-.6,0-.7l-.192-.111a.219.219,0,0,0-.111-.029.671.671,0,0,0-.495.379",
    transform: "translate(-572.282 -447.029)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: -47.829,
    y1: 27.359,
    x2: -47.745,
    y2: 27.359,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ecdcce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    stopColor: "#f2efe2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.683,
    stopColor: "#cab6b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a87f80"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-306"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26752",
    "data-name": "Rectangle 26752",
    className: "cls-1",
    width: 1.938,
    height: 2.538
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-307"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77712",
    "data-name": "Path 77712",
    className: "cls-1",
    d: "M570.958,442.745c0,.273-.383.494-.856.494s-.856-.221-.856-.494l-.113,1.978c0,.309.434.559.969.559s.969-.25.969-.559Z",
    transform: "translate(-569.133 -442.745)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: -41.415,
    y1: 17.686,
    x2: -41.343,
    y2: 17.686,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb95f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.153,
    stopColor: "#ffaf3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335,
    stopColor: "#ffa825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#dd7300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dd7300"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-308"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26754",
    "data-name": "Rectangle 26754",
    className: "cls-1",
    width: 1.712,
    height: 0.988
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-309"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77713",
    "data-name": "Path 77713",
    className: "cls-1",
    d: "M570.79,439.241c.381,0,.689.178.689.4s-.308.4-.689.4-.689-.178-.689-.4.308-.4.689-.4c-.473,0-.856.221-.856.494s.383.494.856.494.856-.221.856-.494-.383-.494-.856-.494",
    transform: "translate(-569.934 -439.241)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: -46.951,
    y1: 45.92,
    x2: -46.868,
    y2: 45.92,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fc7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#ffaf3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589,
    stopColor: "#ffa825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e27b06"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-310"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26755",
    "data-name": "Rectangle 26755",
    className: "cls-1",
    width: 1.378,
    height: 0.795
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-311"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26756",
    "data-name": "Rectangle 26756",
    className: "cls-1",
    width: 1.409,
    height: 0.718
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-313"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77717",
    "data-name": "Path 77717",
    className: "cls-1",
    d: "M718.313,366.379v.459c0,.345.484.625,1.082.625s1.082-.28,1.082-.625v-.459c0-.345-.484-.625-1.082-.625s-1.082.279-1.082.625",
    transform: "translate(-718.313 -365.754)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: -46.811,
    y1: 32.626,
    x2: -46.746,
    y2: 32.626,
    xlinkHref: "#linear-gradient-98"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-315"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77720",
    "data-name": "Path 77720",
    className: "cls-1",
    d: "M722.39,360.815c-.168.29-.168.6,0,.7l.192.111c.167.1.439-.06.606-.35s.167-.6,0-.7l-.192-.111a.219.219,0,0,0-.112-.029.671.671,0,0,0-.495.379",
    transform: "translate(-722.264 -360.436)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: -60.409,
    y1: 34.873,
    x2: -60.325,
    y2: 34.873,
    xlinkHref: "#linear-gradient-99"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-318"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77722",
    "data-name": "Path 77722",
    className: "cls-1",
    d: "M720.94,356.153c0,.273-.383.494-.856.494s-.856-.221-.856-.494l-.113,1.978c0,.309.434.559.969.559s.969-.25.969-.559Z",
    transform: "translate(-719.115 -356.153)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: -52.33,
    y1: 22.498,
    x2: -52.257,
    y2: 22.498,
    xlinkHref: "#linear-gradient-100"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-320"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77723",
    "data-name": "Path 77723",
    className: "cls-1",
    d: "M720.773,352.649c.38,0,.689.178.689.4s-.308.4-.689.4-.689-.178-.689-.4.308-.4.689-.4c-.473,0-.856.221-.856.494s.383.494.856.494.856-.221.856-.494-.383-.494-.856-.494",
    transform: "translate(-719.917 -352.649)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: -59.311,
    y1: 58.276,
    x2: -59.229,
    y2: 58.276,
    xlinkHref: "#linear-gradient-101"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_72672",
    "data-name": "Group 72672",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71899",
    "data-name": "Group 71899",
    transform: "translate(62.785 65.102)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71898",
    "data-name": "Group 71898",
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26440",
    "data-name": "Rectangle 26440",
    className: "cls-4",
    width: 17.007,
    height: 18.758,
    transform: "translate(-4.704 8.024) rotate(-60)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_71916",
    "data-name": "Group 71916"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71915",
    "data-name": "Group 71915",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77153",
    "data-name": "Path 77153",
    className: "cls-5",
    d: "M384.427,460.9l19.7,12.158v-3.794l-19.7-12.158Z",
    transform: "translate(-330.22 -392.655)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77154",
    "data-name": "Path 77154",
    className: "cls-6",
    d: "M384.427,450.166l19.7,12.158,1.847-1.14-19.7-12.158Z",
    transform: "translate(-330.22 -385.711)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77155",
    "data-name": "Path 77155",
    className: "cls-7",
    d: "M24.113,174.687,0,189.571l1.025.633L25.138,175.32Z",
    transform: "translate(0 -150.055)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77156",
    "data-name": "Path 77156",
    className: "cls-8",
    d: "M0,280.24v4.168l1.025.633v-4.168Z",
    transform: "translate(0 -240.724)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77157",
    "data-name": "Path 77157",
    className: "cls-9",
    d: "M31.384,179.175v4.168L7.271,198.227v-4.168Z",
    transform: "translate(-6.246 -153.91)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77162",
    "data-name": "Path 77162",
    className: "cls-10",
    d: "M2.55,331.81v1.065l3.881,2.4v-1.065Z",
    transform: "translate(-2.19 -285.023)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77163",
    "data-name": "Path 77163",
    className: "cls-11",
    d: "M33.954,331.81v1.065l-3.881,2.4v-1.065Z",
    transform: "translate(-25.833 -285.023)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77164",
    "data-name": "Path 77164",
    className: "cls-12",
    d: "M6.431,314.823l-3.881,2.4,3.881,2.4,3.881-2.4Z",
    transform: "translate(-2.191 -270.431)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_71914",
    "data-name": "Group 71914",
    className: "cls-13",
    transform: "translate(4.24 45.95)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71913",
    "data-name": "Group 71913"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71912",
    "data-name": "Group 71912",
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77165",
    "data-name": "Path 77165",
    className: "cls-9",
    d: "M30.073,327.546H32.6l1.357-.837-1.357-.838H30.073Z",
    transform: "translate(-30.073 -325.871)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_77166",
    "data-name": "Path 77166",
    className: "cls-10",
    d: "M20.45,296.767v4.941l1.357.838V297.6Z",
    transform: "translate(-17.567 -254.921)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77167",
    "data-name": "Path 77167",
    className: "cls-11",
    d: "M31.43,296.767v4.941l-1.357.838V297.6Z",
    transform: "translate(-25.833 -254.921)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_71918",
    "data-name": "Group 71918",
    transform: "translate(7.719 46.579)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71917",
    "data-name": "Group 71917",
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26447",
    "data-name": "Rectangle 26447",
    className: "cls-16",
    width: 7.42,
    height: 7.277,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, -2.245, 1.296)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_71920",
    "data-name": "Group 71920",
    transform: "translate(8.973 44.938)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71919",
    "data-name": "Group 71919",
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26448",
    "data-name": "Rectangle 26448",
    className: "cls-18",
    width: 25.057,
    height: 25.782,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, -9.027, 4.9)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_71922",
    "data-name": "Group 71922",
    transform: "translate(11.358 44.938)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71921",
    "data-name": "Group 71921",
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26449",
    "data-name": "Rectangle 26449",
    className: "cls-20",
    width: 21.648,
    height: 22.803,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, -7.729, 4.462)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_71924",
    "data-name": "Group 71924"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71923",
    "data-name": "Group 71923",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77171",
    "data-name": "Path 77171",
    className: "cls-21",
    d: "M73.084,347.842c-2.162-4-5.667-6.167-7.829-4.833s-2.162,5.662,0,9.665,5.667,6.167,7.829,4.833,2.162-5.662,0-9.665",
    transform: "translate(-54.661 -294.304)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77172",
    "data-name": "Path 77172",
    className: "cls-22",
    d: "M84.221,366.139c-1.354-2.508-3.55-3.863-4.9-3.027s-1.354,3.547,0,6.055,3.55,3.863,4.9,3.027,1.354-3.547,0-6.054",
    transform: "translate(-67.26 -311.698)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_71926",
    "data-name": "Group 71926",
    transform: "translate(11.473 51.763)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71925",
    "data-name": "Group 71925",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26451",
    "data-name": "Rectangle 26451",
    className: "cls-24",
    width: 10.219,
    height: 11.037,
    transform: "translate(-4.149 2.224) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_71943",
    "data-name": "Group 71943"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71942",
    "data-name": "Group 71942",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71929",
    "data-name": "Group 71929",
    className: "cls-25",
    transform: "translate(15.22 58.951)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71928",
    "data-name": "Group 71928"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71927",
    "data-name": "Group 71927",
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77174",
    "data-name": "Path 77174",
    className: "cls-27",
    d: "M107.938,418.07a.828.828,0,0,0,.217.536,1.382,1.382,0,0,0,1.317.375,1.54,1.54,0,0,0,.271-.258,2.777,2.777,0,0,1-1.8-.653",
    transform: "translate(-107.938 -418.07)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_71932",
    "data-name": "Group 71932",
    className: "cls-28",
    transform: "translate(11.475 51.77)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71931",
    "data-name": "Group 71931"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71930",
    "data-name": "Group 71930",
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77175",
    "data-name": "Path 77175",
    className: "cls-27",
    d: "M83.441,372.381c-.051-.086-.1-.172-.149-.262-1.046-1.936-1.168-4.01-.37-4.974a1.453,1.453,0,0,0-.654.21c-.8.493-1.057,1.729-.78,3.153a5.725,5.725,0,0,0,1.953,1.873",
    transform: "translate(-81.38 -367.145)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_77176",
    "data-name": "Path 77176",
    className: "cls-30",
    d: "M89.149,367.112c-.8.965-.676,3.038.37,4.974.986,1.826,2.481,2.953,3.639,2.859.8-.965.676-3.038-.37-4.974-.986-1.826-2.481-2.953-3.639-2.859",
    transform: "translate(-76.132 -315.342)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_71935",
    "data-name": "Group 71935",
    className: "cls-31",
    transform: "translate(17.368 56.804)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71934",
    "data-name": "Group 71934"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71933",
    "data-name": "Group 71933",
    className: "cls-32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77177",
    "data-name": "Path 77177",
    className: "cls-33",
    d: "M123.249,402.844h-.075l.155.6a5.9,5.9,0,0,0-.081-.6",
    transform: "translate(-123.174 -402.844)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_71938",
    "data-name": "Group 71938",
    className: "cls-31",
    transform: "translate(13.757 56.421)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71937",
    "data-name": "Group 71937"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71936",
    "data-name": "Group 71936",
    className: "cls-34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77178",
    "data-name": "Path 77178",
    className: "cls-33",
    d: "M98.4,401.029l-.233-.9h-.6l.211.811a.864.864,0,0,0,.075.188c.131.243.344.375.475.294.1-.06.122-.218.076-.394",
    transform: "translate(-97.564 -400.131)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_71941",
    "data-name": "Group 71941",
    className: "cls-31",
    transform: "translate(12.497 51.764)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71940",
    "data-name": "Group 71940"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71939",
    "data-name": "Group 71939",
    className: "cls-35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77179",
    "data-name": "Path 77179",
    className: "cls-33",
    d: "M92.949,371.009a5.067,5.067,0,0,1,.424.342,7.931,7.931,0,0,0-.585-1.38c-.986-1.826-2.481-2.953-3.639-2.859-.8.965-.676,3.038.37,4.974.048.089.1.176.149.262a2.265,2.265,0,0,1,.745-1.648l.939,3.6a2.772,2.772,0,0,0,1.8.65,2.446,2.446,0,0,0,.488-1.275Z",
    transform: "translate(-88.63 -367.107)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_71945",
    "data-name": "Group 71945",
    transform: "translate(13.457 55.877)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71944",
    "data-name": "Group 71944",
    className: "cls-36"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26458",
    "data-name": "Rectangle 26458",
    className: "cls-37",
    width: 1.418,
    height: 1.475,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, -0.525, 0.284)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_71947",
    "data-name": "Group 71947"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71946",
    "data-name": "Group 71946",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77181",
    "data-name": "Path 77181",
    className: "cls-21",
    d: "M96.01,397.658c-.131-.243-.344-.375-.475-.294s-.131.344,0,.587.344.374.475.293.131-.344,0-.587",
    transform: "translate(-81.979 -341.313)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_71949",
    "data-name": "Group 71949",
    transform: "translate(12.838 53.648)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71948",
    "data-name": "Group 71948",
    className: "cls-38"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26460",
    "data-name": "Rectangle 26460",
    className: "cls-39",
    width: 1.418,
    height: 1.475,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, -0.525, 0.284)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_71951",
    "data-name": "Group 71951"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71950",
    "data-name": "Group 71950",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77183",
    "data-name": "Path 77183",
    className: "cls-40",
    d: "M91.616,381.849c-.131-.243-.344-.375-.475-.294s-.131.344,0,.587.344.374.475.293.131-.344,0-.587",
    transform: "translate(-78.204 -327.733)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_71953",
    "data-name": "Group 71953",
    transform: "translate(14.953 57.565)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71952",
    "data-name": "Group 71952",
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26462",
    "data-name": "Rectangle 26462",
    className: "cls-42",
    width: 1.418,
    height: 1.475,
    transform: "translate(-0.525 0.284) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_71955",
    "data-name": "Group 71955"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71954",
    "data-name": "Group 71954",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77185",
    "data-name": "Path 77185",
    className: "cls-40",
    d: "M106.618,409.63c-.131-.243-.344-.375-.475-.294s-.131.344,0,.587.344.375.475.293.131-.344,0-.587",
    transform: "translate(-91.091 -351.597)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_71957",
    "data-name": "Group 71957",
    transform: "translate(13.143 53.457)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71956",
    "data-name": "Group 71956",
    className: "cls-43"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26464",
    "data-name": "Rectangle 26464",
    className: "cls-44",
    width: 5.763,
    height: 5.992,
    transform: "translate(-2.132 1.154) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_71959",
    "data-name": "Group 71959",
    transform: "translate(14.093 53.457)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71958",
    "data-name": "Group 71958",
    className: "cls-45"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26465",
    "data-name": "Rectangle 26465",
    className: "cls-46",
    width: 2.712,
    height: 2.2,
    transform: "translate(0 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_71961",
    "data-name": "Group 71961"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71960",
    "data-name": "Group 71960",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77188",
    "data-name": "Path 77188",
    className: "cls-21",
    d: "M95.538,384.732c-.534-.988-1.4-1.522-1.932-1.193s-.534,1.4,0,2.385,1.4,1.522,1.932,1.193.534-1.4,0-2.385",
    transform: "translate(-80.063 -329.374)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_71963",
    "data-name": "Group 71963",
    transform: "translate(13.457 52.184)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71962",
    "data-name": "Group 71962",
    className: "cls-47"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26467",
    "data-name": "Rectangle 26467",
    className: "cls-48",
    width: 1.418,
    height: 1.475,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, -0.525, 0.284)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_71965",
    "data-name": "Group 71965"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71964",
    "data-name": "Group 71964",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77190",
    "data-name": "Path 77190",
    className: "cls-40",
    d: "M96.01,371.466c-.131-.243-.344-.374-.475-.293s-.131.344,0,.587.344.374.475.294.131-.344,0-.587",
    transform: "translate(-81.979 -318.814)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77191",
    "data-name": "Path 77191",
    className: "cls-49",
    d: "M106.622,373.615l.2-.123a5.916,5.916,0,0,0-.723-.71.56.56,0,0,0,.048.539c.131.243.344.375.476.294",
    transform: "translate(-91.095 -320.217)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77192",
    "data-name": "Path 77192",
    className: "cls-40",
    d: "M106.622,373.615a.265.265,0,0,0,.1-.239,5.8,5.8,0,0,0-.622-.594.56.56,0,0,0,.048.539c.131.243.344.375.476.294",
    transform: "translate(-91.095 -320.217)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77193",
    "data-name": "Path 77193",
    className: "cls-40",
    d: "M116.862,385.454q-.09-.166-.185-.323a.636.636,0,0,0,.077.486.585.585,0,0,0,.342.31c-.073-.158-.149-.316-.234-.473",
    transform: "translate(-100.207 -330.825)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_71967",
    "data-name": "Group 71967",
    transform: "translate(17.068 56.331)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71966",
    "data-name": "Group 71966",
    className: "cls-50"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26469",
    "data-name": "Rectangle 26469",
    className: "cls-51",
    width: 0.918,
    height: 1.109,
    transform: "translate(-0.467 0.251) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_71969",
    "data-name": "Group 71969"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71968",
    "data-name": "Group 71968",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77195",
    "data-name": "Path 77195",
    className: "cls-21",
    d: "M121.341,400.086a.2.2,0,0,0-.2,0c-.131.081-.131.344,0,.587a.576.576,0,0,0,.35.312,6.2,6.2,0,0,0-.154-.9",
    transform: "translate(-103.978 -343.648)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_71971",
    "data-name": "Group 71971",
    transform: "translate(16.449 57.724)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71970",
    "data-name": "Group 71970",
    className: "cls-52"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26471",
    "data-name": "Rectangle 26471",
    className: "cls-53",
    width: 1.418,
    height: 1.475,
    transform: "translate(-0.525 0.284) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_71973",
    "data-name": "Group 71973"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71972",
    "data-name": "Group 71972",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77197",
    "data-name": "Path 77197",
    className: "cls-40",
    d: "M117.226,410.754c-.131-.243-.344-.375-.475-.294s-.131.344,0,.587.344.374.475.293.131-.344,0-.587",
    transform: "translate(-100.203 -352.562)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_71975",
    "data-name": "Group 71975",
    transform: "translate(20.874 52.284)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71974",
    "data-name": "Group 71974",
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26473",
    "data-name": "Rectangle 26473",
    className: "cls-55",
    width: 25.057,
    height: 25.782,
    transform: "translate(-9.027 4.9) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_71977",
    "data-name": "Group 71977",
    transform: "translate(23.259 52.284)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71976",
    "data-name": "Group 71976",
    className: "cls-56"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26474",
    "data-name": "Rectangle 26474",
    className: "cls-57",
    width: 21.648,
    height: 22.803,
    transform: "translate(-7.729 4.462) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_71979",
    "data-name": "Group 71979"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71978",
    "data-name": "Group 71978",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77200",
    "data-name": "Path 77200",
    className: "cls-21",
    d: "M157.485,399.939c-2.162-4-5.667-6.167-7.829-4.833s-2.162,5.662,0,9.665,5.667,6.167,7.829,4.833,2.162-5.662,0-9.665",
    transform: "translate(-127.16 -339.055)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77201",
    "data-name": "Path 77201",
    className: "cls-22",
    d: "M168.622,418.236c-1.354-2.508-3.55-3.863-4.9-3.027s-1.354,3.547,0,6.055,3.55,3.863,4.9,3.027,1.354-3.547,0-6.054",
    transform: "translate(-139.76 -356.45)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_71981",
    "data-name": "Group 71981",
    transform: "translate(23.374 59.109)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71980",
    "data-name": "Group 71980",
    className: "cls-58"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26476",
    "data-name": "Rectangle 26476",
    className: "cls-59",
    width: 10.22,
    height: 11.037,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, -4.149, 2.224)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_71998",
    "data-name": "Group 71998"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71997",
    "data-name": "Group 71997",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71984",
    "data-name": "Group 71984",
    className: "cls-25",
    transform: "translate(27.121 66.297)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71983",
    "data-name": "Group 71983"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71982",
    "data-name": "Group 71982",
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77203",
    "data-name": "Path 77203",
    className: "cls-27",
    d: "M192.339,470.167a.828.828,0,0,0,.217.536,1.382,1.382,0,0,0,1.317.375,1.544,1.544,0,0,0,.271-.258,2.777,2.777,0,0,1-1.8-.653",
    transform: "translate(-192.339 -470.167)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_71987",
    "data-name": "Group 71987",
    className: "cls-28",
    transform: "translate(23.376 59.116)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71986",
    "data-name": "Group 71986"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71985",
    "data-name": "Group 71985",
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77204",
    "data-name": "Path 77204",
    className: "cls-27",
    d: "M167.842,424.478c-.051-.086-.1-.172-.149-.262-1.046-1.936-1.168-4.009-.37-4.974a1.453,1.453,0,0,0-.654.21c-.8.492-1.057,1.729-.78,3.153a5.726,5.726,0,0,0,1.953,1.873",
    transform: "translate(-165.781 -419.242)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_77205",
    "data-name": "Path 77205",
    className: "cls-30",
    d: "M173.55,419.209c-.8.965-.676,3.038.37,4.974.986,1.826,2.481,2.953,3.639,2.859.8-.965.676-3.038-.37-4.974-.986-1.826-2.481-2.953-3.639-2.859",
    transform: "translate(-148.632 -360.093)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_71990",
    "data-name": "Group 71990",
    className: "cls-31",
    transform: "translate(29.269 64.15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71989",
    "data-name": "Group 71989"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71988",
    "data-name": "Group 71988",
    className: "cls-32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77206",
    "data-name": "Path 77206",
    className: "cls-33",
    d: "M207.65,454.941h-.075l.155.6a5.9,5.9,0,0,0-.081-.6",
    transform: "translate(-207.575 -454.941)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_71993",
    "data-name": "Group 71993",
    className: "cls-31",
    transform: "translate(25.658 63.767)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71992",
    "data-name": "Group 71992"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71991",
    "data-name": "Group 71991",
    className: "cls-34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77207",
    "data-name": "Path 77207",
    className: "cls-33",
    d: "M182.8,453.127l-.233-.9h-.6l.211.811a.864.864,0,0,0,.075.188c.131.243.344.375.475.294.1-.06.122-.218.076-.394",
    transform: "translate(-181.965 -452.229)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_71996",
    "data-name": "Group 71996",
    className: "cls-31",
    transform: "translate(24.399 59.111)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71995",
    "data-name": "Group 71995"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71994",
    "data-name": "Group 71994",
    className: "cls-35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77208",
    "data-name": "Path 77208",
    className: "cls-33",
    d: "M177.35,423.106a5.086,5.086,0,0,1,.424.342,7.937,7.937,0,0,0-.585-1.38c-.986-1.826-2.481-2.953-3.639-2.859-.8.965-.676,3.038.37,4.974.048.089.1.176.149.262a2.266,2.266,0,0,1,.745-1.648l.939,3.6a2.772,2.772,0,0,0,1.8.65,2.446,2.446,0,0,0,.488-1.275Z",
    transform: "translate(-173.031 -419.204)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72000",
    "data-name": "Group 72000",
    transform: "translate(25.358 63.223)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71999",
    "data-name": "Group 71999",
    className: "cls-60"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26483",
    "data-name": "Rectangle 26483",
    className: "cls-61",
    width: 1.418,
    height: 1.475,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, -0.525, 0.284)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72002",
    "data-name": "Group 72002"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72001",
    "data-name": "Group 72001",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77210",
    "data-name": "Path 77210",
    className: "cls-21",
    d: "M180.411,449.755c-.131-.243-.344-.375-.475-.294s-.131.344,0,.587.344.375.475.293.131-.344,0-.587",
    transform: "translate(-154.479 -386.064)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72004",
    "data-name": "Group 72004",
    transform: "translate(24.739 60.994)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72003",
    "data-name": "Group 72003",
    className: "cls-62"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26485",
    "data-name": "Rectangle 26485",
    className: "cls-63",
    width: 1.418,
    height: 1.475,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, -0.525, 0.284)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72006",
    "data-name": "Group 72006"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72005",
    "data-name": "Group 72005",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77212",
    "data-name": "Path 77212",
    className: "cls-40",
    d: "M176.017,433.946c-.131-.243-.344-.375-.475-.294s-.131.344,0,.587.344.375.475.293.131-.344,0-.587",
    transform: "translate(-150.704 -372.484)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72008",
    "data-name": "Group 72008",
    transform: "translate(26.854 64.911)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72007",
    "data-name": "Group 72007",
    className: "cls-64"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26487",
    "data-name": "Rectangle 26487",
    className: "cls-65",
    width: 1.418,
    height: 1.475,
    transform: "translate(-0.525 0.284) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72010",
    "data-name": "Group 72010"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72009",
    "data-name": "Group 72009",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77214",
    "data-name": "Path 77214",
    className: "cls-40",
    d: "M191.019,461.727c-.131-.243-.344-.375-.475-.294s-.131.344,0,.587.344.375.475.294.131-.344,0-.587",
    transform: "translate(-163.591 -396.348)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72012",
    "data-name": "Group 72012",
    transform: "translate(25.044 60.803)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72011",
    "data-name": "Group 72011",
    className: "cls-66"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26489",
    "data-name": "Rectangle 26489",
    className: "cls-67",
    width: 5.763,
    height: 5.992,
    transform: "translate(-2.132 1.154) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72014",
    "data-name": "Group 72014",
    transform: "translate(25.994 60.803)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72013",
    "data-name": "Group 72013",
    className: "cls-68"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26490",
    "data-name": "Rectangle 26490",
    className: "cls-69",
    width: 2.712,
    height: 2.2,
    transform: "translate(0 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72016",
    "data-name": "Group 72016"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72015",
    "data-name": "Group 72015",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77217",
    "data-name": "Path 77217",
    className: "cls-21",
    d: "M179.939,436.829c-.534-.988-1.4-1.522-1.932-1.193s-.534,1.4,0,2.385,1.4,1.522,1.932,1.193.534-1.4,0-2.385",
    transform: "translate(-152.563 -374.125)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72018",
    "data-name": "Group 72018",
    transform: "translate(25.358 59.53)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72017",
    "data-name": "Group 72017",
    className: "cls-70"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26492",
    "data-name": "Rectangle 26492",
    className: "cls-71",
    width: 1.418,
    height: 1.475,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, -0.525, 0.284)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72020",
    "data-name": "Group 72020"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72019",
    "data-name": "Group 72019",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77219",
    "data-name": "Path 77219",
    className: "cls-40",
    d: "M180.411,423.563c-.131-.243-.344-.375-.475-.294s-.131.344,0,.587.344.375.475.293.131-.344,0-.587",
    transform: "translate(-154.479 -363.565)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77220",
    "data-name": "Path 77220",
    className: "cls-49",
    d: "M191.022,425.712l.2-.123a5.915,5.915,0,0,0-.723-.71.56.56,0,0,0,.048.539c.131.243.344.375.476.294",
    transform: "translate(-163.594 -364.968)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77221",
    "data-name": "Path 77221",
    className: "cls-40",
    d: "M191.022,425.712a.265.265,0,0,0,.1-.239,5.793,5.793,0,0,0-.622-.594.56.56,0,0,0,.048.539c.131.243.344.375.476.294",
    transform: "translate(-163.594 -364.968)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77222",
    "data-name": "Path 77222",
    className: "cls-40",
    d: "M201.264,437.551q-.089-.165-.184-.323a.636.636,0,0,0,.077.486.585.585,0,0,0,.342.311c-.073-.158-.149-.316-.234-.473",
    transform: "translate(-172.708 -375.576)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72022",
    "data-name": "Group 72022",
    transform: "translate(28.969 63.677)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72021",
    "data-name": "Group 72021",
    className: "cls-72"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26494",
    "data-name": "Rectangle 26494",
    className: "cls-73",
    width: 0.918,
    height: 1.109,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, -0.467, 0.251)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72024",
    "data-name": "Group 72024"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72023",
    "data-name": "Group 72023",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77224",
    "data-name": "Path 77224",
    className: "cls-21",
    d: "M205.742,452.183a.2.2,0,0,0-.2,0c-.131.081-.131.344,0,.587a.576.576,0,0,0,.35.312,6.216,6.216,0,0,0-.154-.9",
    transform: "translate(-176.478 -388.399)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72026",
    "data-name": "Group 72026",
    transform: "translate(28.35 65.07)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72025",
    "data-name": "Group 72025",
    className: "cls-74"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26496",
    "data-name": "Rectangle 26496",
    className: "cls-75",
    width: 1.418,
    height: 1.475,
    transform: "translate(-0.525 0.284) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72028",
    "data-name": "Group 72028"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72027",
    "data-name": "Group 72027",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77226",
    "data-name": "Path 77226",
    className: "cls-40",
    d: "M201.628,462.851c-.131-.243-.344-.375-.475-.294s-.131.344,0,.587.344.375.475.293.131-.344,0-.587",
    transform: "translate(-172.704 -397.313)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77227",
    "data-name": "Path 77227",
    className: "cls-8",
    d: "M73.6,322.433a4.9,4.9,0,0,0-1.742-2.133l-6.785-4.188a2.21,2.21,0,0,0-2-.335l-.764.32-.764-1.263a6.388,6.388,0,0,0-2-2.13l-6.785-4.188a1.363,1.363,0,0,0-1.742-.018l-1.845,1.817a1.9,1.9,0,0,0-.457,1.375v4.287l.849.524c0-4.629,3.04-6.505,6.789-4.191a14.284,14.284,0,0,1,4.651,5.149l2.6,1.6c1.215-.662,2.851-.519,4.651.593,3.75,2.315,6.789,7.943,6.789,12.572l.849.524v-4.287a4.851,4.851,0,0,0-.457-1.939Z",
    transform: "translate(-41.851 -264.738)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72030",
    "data-name": "Group 72030",
    transform: "translate(20.459 47.549)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72029",
    "data-name": "Group 72029",
    className: "cls-76"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26498",
    "data-name": "Rectangle 26498",
    className: "cls-77",
    width: 26.696,
    height: 27.222,
    transform: "translate(-8.814 5.034) rotate(-29.73)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72035",
    "data-name": "Group 72035"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72034",
    "data-name": "Group 72034",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72033",
    "data-name": "Group 72033",
    className: "cls-78",
    transform: "translate(21.475 47.549)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72032",
    "data-name": "Group 72032"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72031",
    "data-name": "Group 72031",
    className: "cls-79"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77229",
    "data-name": "Path 77229",
    className: "cls-9",
    d: "M169.879,348.077l-1.845-4.094a4.906,4.906,0,0,0-1.742-2.133l-6.786-4.189a2.21,2.21,0,0,0-2-.334l-.764.32-4.449,2.746.437-.119c.32-.087.871.213,1.532.622l6.785,4.188a11.341,11.341,0,0,1,2.2,1.851l3.155,3.286a4.134,4.134,0,0,1,1.013,1.6l1.5,3.362,1.418-.876v-4.287a4.851,4.851,0,0,0-.457-1.939",
    transform: "translate(-152.298 -337.209)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72037",
    "data-name": "Group 72037",
    transform: "translate(9.345 40.085)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72036",
    "data-name": "Group 72036",
    className: "cls-80"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26501",
    "data-name": "Rectangle 26501",
    className: "cls-81",
    width: 19.995,
    height: 18.054,
    transform: "translate(-4.882 2.819) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72051",
    "data-name": "Group 72051"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72050",
    "data-name": "Group 72050",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72040",
    "data-name": "Group 72040",
    className: "cls-78",
    transform: "translate(10.033 40.085)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72039",
    "data-name": "Group 72039"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72038",
    "data-name": "Group 72038",
    className: "cls-82"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77231",
    "data-name": "Path 77231",
    className: "cls-9",
    d: "M86.283,290.914a6.389,6.389,0,0,0-2-2.13L77.5,284.6a1.46,1.46,0,0,0-1.57-.155h0l-4.775,2.948c.319-.086.445.035,1.105.443l6.785,4.188a15.788,15.788,0,0,1,2.243,1.734l1.308,1.171,4.449-2.746Z",
    transform: "translate(-71.156 -284.276)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_77232",
    "data-name": "Path 77232",
    className: "cls-83",
    d: "M30.073,264.02v5.387l2.877-1.776v-5.387Z",
    transform: "translate(-25.833 -225.266)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77233",
    "data-name": "Path 77233",
    className: "cls-83",
    d: "M134.172,287.505v5.749l2.877-1.776V285.73Z",
    transform: "translate(-115.253 -245.44)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77234",
    "data-name": "Path 77234",
    className: "cls-84",
    d: "M27.228,221.493,9.673,210.657l2.877-1.776L30.1,219.718Z",
    transform: "translate(-8.309 -179.428)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72043",
    "data-name": "Group 72043",
    className: "cls-85",
    transform: "translate(1.927 29.627)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72042",
    "data-name": "Group 72042"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72041",
    "data-name": "Group 72041",
    className: "cls-86"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77235",
    "data-name": "Path 77235",
    className: "cls-87",
    d: "M30.939,222.378l2.6-1.6L16.26,210.114l-2.6,1.6Z",
    transform: "translate(-13.665 -210.114)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_77236",
    "data-name": "Path 77236",
    className: "cls-88",
    d: "M9.673,221.474V232.61l2.877,1.776V229l14.679,9.06V232.31Z",
    transform: "translate(-8.309 -190.245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77237",
    "data-name": "Path 77237",
    className: "cls-22",
    d: "M28.82,236.029l-16.93-10.45v4.977l16.93,10.45Z",
    transform: "translate(-10.213 -193.77)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77238",
    "data-name": "Path 77238",
    className: "cls-89",
    d: "M122.132,322.861V320.87l-1.612,1Z",
    transform: "translate(-103.526 -275.626)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77239",
    "data-name": "Path 77239",
    className: "cls-89",
    d: "M99.262,299.647l3.225-1.991v-1l-.806-.5-4.032,2.488Z",
    transform: "translate(-83.881 -254.403)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77240",
    "data-name": "Path 77240",
    className: "cls-89",
    d: "M74.78,284.536l1.612,1,4.032-2.489-1.613-1Z",
    transform: "translate(-64.235 -242.277)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77241",
    "data-name": "Path 77241",
    className: "cls-89",
    d: "M51.909,270.418l1.612,1,4.032-2.489-1.613-1Z",
    transform: "translate(-44.59 -230.15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77242",
    "data-name": "Path 77242",
    className: "cls-89",
    d: "M29.039,256.3l1.612,1,4.032-2.489-1.612-1Z",
    transform: "translate(-24.944 -218.024)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77243",
    "data-name": "Path 77243",
    className: "cls-89",
    d: "M11.89,241.686v1l.806.5,4.032-2.488-1.612-1Z",
    transform: "translate(-10.213 -205.897)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77244",
    "data-name": "Path 77244",
    className: "cls-89",
    d: "M13.5,226.575l-1.612-1v1.991Z",
    transform: "translate(-10.213 -193.771)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77245",
    "data-name": "Path 77245",
    className: "cls-83",
    d: "M246.126,356.61v5.749L249,360.583v-5.749Z",
    transform: "translate(-211.42 -304.8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77246",
    "data-name": "Path 77246",
    className: "cls-88",
    d: "M142.155,303.25V309l14.66,9.049V312.3Z",
    transform: "translate(-122.11 -260.49)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77247",
    "data-name": "Path 77247",
    className: "cls-84",
    d: "M142.155,292.433l2.877-1.776,14.661,9.049-2.877,1.776Z",
    transform: "translate(-122.11 -249.672)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72046",
    "data-name": "Group 72046",
    className: "cls-85",
    transform: "translate(20.326 40.985)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72045",
    "data-name": "Group 72045"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72044",
    "data-name": "Group 72044",
    className: "cls-90"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77248",
    "data-name": "Path 77248",
    className: "cls-87",
    d: "M144.152,292.259l14.66,9.049,2.6-1.6-14.66-9.049Z",
    transform: "translate(-144.152 -290.657)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72049",
    "data-name": "Group 72049",
    className: "cls-31",
    transform: "translate(22.92 46.186)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72048",
    "data-name": "Group 72048"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72047",
    "data-name": "Group 72047",
    className: "cls-91"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77249",
    "data-name": "Path 77249",
    className: "cls-33",
    d: "M163.706,328.737h0l-.128-.49v0a.485.485,0,0,0-.189-.274l-.639-.394c-.113-.07-.2-.013-.2.126v.537a.4.4,0,0,0,.015.1h0l.128.49v0a.485.485,0,0,0,.189.274l.639.394c.113.07.2.013.2-.126v-.537a.4.4,0,0,0-.015-.1",
    transform: "translate(-162.545 -327.545)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72053",
    "data-name": "Group 72053",
    transform: "translate(22.852 46.186)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72052",
    "data-name": "Group 72052",
    className: "cls-92"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26507",
    "data-name": "Rectangle 26507",
    className: "cls-93",
    width: 1.744,
    height: 1.908,
    transform: "translate(-0.673 0.386) rotate(-29.838)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72058",
    "data-name": "Group 72058"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72057",
    "data-name": "Group 72057",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77251",
    "data-name": "Path 77251",
    className: "cls-21",
    d: "M161.835,328.138l.639.394a.49.49,0,0,1,.2.378v.537c0,.139-.091.2-.2.126l-.639-.394a.49.49,0,0,1-.2-.378v-.537c0-.139.092-.2.2-.126",
    transform: "translate(-138.84 -281.843)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72056",
    "data-name": "Group 72056",
    className: "cls-31",
    transform: "translate(30.783 51.04)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72055",
    "data-name": "Group 72055"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72054",
    "data-name": "Group 72054",
    className: "cls-91"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77252",
    "data-name": "Path 77252",
    className: "cls-33",
    d: "M219.471,363.158h0l-.128-.49v0a.485.485,0,0,0-.189-.274l-.639-.394c-.113-.07-.2-.013-.2.126v.537a.4.4,0,0,0,.015.1h0l.128.49v0a.485.485,0,0,0,.189.274l.639.394c.113.07.2.013.2-.126v-.537a.4.4,0,0,0-.015-.1",
    transform: "translate(-218.31 -361.967)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72060",
    "data-name": "Group 72060",
    transform: "translate(30.715 51.04)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72059",
    "data-name": "Group 72059",
    className: "cls-94"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26510",
    "data-name": "Rectangle 26510",
    className: "cls-95",
    width: 1.744,
    height: 1.908,
    transform: "matrix(0.867, -0.498, 0.498, 0.867, -0.673, 0.386)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72068",
    "data-name": "Group 72068"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72067",
    "data-name": "Group 72067",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77254",
    "data-name": "Path 77254",
    className: "cls-21",
    d: "M217.6,362.56l.639.394a.49.49,0,0,1,.2.378v.537c0,.139-.091.2-.2.126l-.639-.394a.49.49,0,0,1-.2-.378v-.537c0-.139.092-.2.2-.126",
    transform: "translate(-186.742 -311.411)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77255",
    "data-name": "Path 77255",
    className: "cls-10",
    d: "M246.986,482.69v1.065l3.881,2.4v-1.065Z",
    transform: "translate(-212.159 -414.628)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77256",
    "data-name": "Path 77256",
    className: "cls-11",
    d: "M278.391,482.69v1.065l-3.881,2.4v-1.065Z",
    transform: "translate(-235.802 -414.628)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77257",
    "data-name": "Path 77257",
    className: "cls-12",
    d: "M250.867,465.7l-3.881,2.4,3.881,2.4,3.881-2.4Z",
    transform: "translate(-212.16 -400.035)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72063",
    "data-name": "Group 72063",
    className: "cls-13",
    transform: "translate(38.708 67.225)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72062",
    "data-name": "Group 72062"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72061",
    "data-name": "Group 72061",
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77258",
    "data-name": "Path 77258",
    className: "cls-9",
    d: "M274.509,478.426h2.524l1.357-.837-1.357-.838h-2.524Z",
    transform: "translate(-274.509 -476.751)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_77259",
    "data-name": "Path 77259",
    className: "cls-10",
    d: "M264.887,447.647v4.941l1.357.838v-4.941Z",
    transform: "translate(-227.536 -384.526)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77260",
    "data-name": "Path 77260",
    className: "cls-11",
    d: "M275.866,447.647v4.941l-1.357.838v-4.941Z",
    transform: "translate(-235.802 -384.526)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77261",
    "data-name": "Path 77261",
    className: "cls-83",
    d: "M274.51,414.9v5.387l2.877-1.776v-5.387Z",
    transform: "translate(-235.802 -354.871)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77262",
    "data-name": "Path 77262",
    className: "cls-8",
    d: "M288.271,460.123v6.593l6.4,3.95v-6.593Z",
    transform: "translate(-247.623 -395.243)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77263",
    "data-name": "Path 77263",
    className: "cls-96",
    d: "M307.8,472.177v6.593l.892.551v-6.593Z",
    transform: "translate(-264.398 -405.597)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77264",
    "data-name": "Path 77264",
    className: "cls-97",
    d: "M288.271,449.861l.91-1.685,6.4,3.95-.91,1.685Z",
    transform: "translate(-247.623 -384.98)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77265",
    "data-name": "Path 77265",
    className: "cls-98",
    d: "M307.8,461.914l.91-1.685.892.551-.91,1.685Z",
    transform: "translate(-264.398 -395.334)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77266",
    "data-name": "Path 77266",
    className: "cls-7",
    d: "M297.609,435.542l-2.886,1.781,6.4,3.95,2.886-1.781Z",
    transform: "translate(-253.165 -374.128)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77267",
    "data-name": "Path 77267",
    className: "cls-30",
    d: "M317.137,447.6l-2.886,1.782.892.551,2.886-1.781Z",
    transform: "translate(-269.939 -384.481)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77268",
    "data-name": "Path 77268",
    className: "cls-9",
    d: "M337.449,463.554l-2.886,1.781-.91,1.685v6.593l.91.561,2.886-1.782.91-1.685v-6.593Z",
    transform: "translate(-286.606 -398.189)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72066",
    "data-name": "Group 72066",
    className: "cls-78",
    transform: "translate(41.796 61.414)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72065",
    "data-name": "Group 72065"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72064",
    "data-name": "Group 72064",
    className: "cls-99"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77269",
    "data-name": "Path 77269",
    className: "cls-9",
    d: "M299.061,435.542l-2.648,1.634,6.4,3.95,2.648-1.634Z",
    transform: "translate(-296.413 -435.542)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72070",
    "data-name": "Group 72070",
    transform: "translate(48.633 71.833)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72069",
    "data-name": "Group 72069",
    className: "cls-100"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26514",
    "data-name": "Rectangle 26514",
    className: "cls-101",
    width: 7.421,
    height: 7.278,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, -2.245, 1.296)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72072",
    "data-name": "Group 72072",
    transform: "translate(49.886 70.988)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72071",
    "data-name": "Group 72071",
    className: "cls-102"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26515",
    "data-name": "Rectangle 26515",
    className: "cls-103",
    width: 23.542,
    height: 24.448,
    transform: "translate(-8.683 4.701) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72074",
    "data-name": "Group 72074",
    transform: "translate(52.271 70.988)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72073",
    "data-name": "Group 72073",
    className: "cls-104"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26516",
    "data-name": "Rectangle 26516",
    className: "cls-105",
    width: 20.133,
    height: 21.469,
    transform: "translate(-7.384 4.263) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72076",
    "data-name": "Group 72076"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72075",
    "data-name": "Group 72075",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77273",
    "data-name": "Path 77273",
    className: "cls-106",
    d: "M363.235,526.939c-2.162-4-5.667-6.167-7.829-4.833s-2.162,5.662,0,9.665,5.667,6.167,7.829,4.833,2.162-5.662,0-9.665",
    transform: "translate(-303.898 -448.148)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77274",
    "data-name": "Path 77274",
    className: "cls-22",
    d: "M374.372,545.236c-1.354-2.508-3.55-3.863-4.9-3.027s-1.354,3.547,0,6.055,3.55,3.863,4.9,3.027,1.354-3.547,0-6.054",
    transform: "translate(-316.498 -465.542)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72078",
    "data-name": "Group 72078",
    transform: "translate(52.387 77.017)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72077",
    "data-name": "Group 72077",
    className: "cls-107"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26518",
    "data-name": "Rectangle 26518",
    className: "cls-108",
    width: 10.22,
    height: 11.037,
    transform: "translate(-4.149 2.224) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72083",
    "data-name": "Group 72083"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72082",
    "data-name": "Group 72082",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72081",
    "data-name": "Group 72081",
    className: "cls-109",
    transform: "translate(52.387 77.024)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72080",
    "data-name": "Group 72080"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72079",
    "data-name": "Group 72079",
    className: "cls-110"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77276",
    "data-name": "Path 77276",
    className: "cls-27",
    d: "M373.433,551.217c-1.045-1.935-1.168-4.008-.371-4.973h0a1.451,1.451,0,0,0-.654.21c-.8.492-1.057,1.729-.781,3.153a6.133,6.133,0,0,0,1.589,1.649,6.831,6.831,0,0,0,.311.66c.788,1.46,1.962,2.391,2.914,2.419a1.631,1.631,0,0,0,.433-.058,1.572,1.572,0,0,0,.194-.2c-1.157.09-2.65-1.036-3.635-2.859",
    transform: "translate(-371.521 -546.243)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_77277",
    "data-name": "Path 77277",
    className: "cls-111",
    d: "M379.3,546.21c-.8.965-.676,3.038.37,4.974.986,1.826,2.481,2.953,3.639,2.859.8-.965.676-3.038-.37-4.974-.986-1.826-2.481-2.953-3.639-2.859",
    transform: "translate(-325.37 -469.186)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72085",
    "data-name": "Group 72085",
    transform: "translate(53.167 77.368)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72084",
    "data-name": "Group 72084",
    className: "cls-112"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26521",
    "data-name": "Rectangle 26521",
    className: "cls-113",
    width: 8.474,
    height: 9.128,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, -3.397, 1.834)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72090",
    "data-name": "Group 72090"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72089",
    "data-name": "Group 72089",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72088",
    "data-name": "Group 72088",
    className: "cls-109",
    transform: "translate(54.298 77.368)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72087",
    "data-name": "Group 72087"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72086",
    "data-name": "Group 72086",
    className: "cls-114"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77279",
    "data-name": "Path 77279",
    className: "cls-27",
    d: "M388.342,551.2a6.263,6.263,0,0,0-2.3-2.515l-.966.6c.881-.544,2.309.338,3.19,1.969s.88,3.394,0,3.937l.966-.6a6.8,6.8,0,0,0-.885-3.391",
    transform: "translate(-385.071 -548.686)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_77280",
    "data-name": "Path 77280",
    className: "cls-22",
    d: "M380.9,555.964c-.881-1.631-2.309-2.512-3.189-1.969s-.881,2.306,0,3.937,2.309,2.512,3.189,1.969.881-2.307,0-3.937",
    transform: "translate(-323.884 -475.74)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72092",
    "data-name": "Group 72092",
    transform: "translate(55.114 78.77)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72091",
    "data-name": "Group 72091",
    className: "cls-115"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26524",
    "data-name": "Rectangle 26524",
    className: "cls-116",
    width: 0.765,
    height: 1.004,
    transform: "translate(-0.156 0.027) rotate(-10)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72094",
    "data-name": "Group 72094"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72093",
    "data-name": "Group 72093",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77282",
    "data-name": "Path 77282",
    className: "cls-117",
    d: "M392.6,558.755a.331.331,0,0,0-.065-.031.394.394,0,0,0-.007.076.74.74,0,0,0,.308.57.332.332,0,0,0,.065.031.394.394,0,0,0,.007-.076.739.739,0,0,0-.308-.57",
    transform: "translate(-337.182 -479.94)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72096",
    "data-name": "Group 72096",
    transform: "translate(55.114 82.795)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72095",
    "data-name": "Group 72095",
    className: "cls-118"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26526",
    "data-name": "Rectangle 26526",
    className: "cls-119",
    width: 0.765,
    height: 1.004,
    transform: "matrix(0.985, -0.174, 0.174, 0.985, -0.156, 0.027)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72098",
    "data-name": "Group 72098"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72097",
    "data-name": "Group 72097",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77284",
    "data-name": "Path 77284",
    className: "cls-117",
    d: "M392.6,587.3a.331.331,0,0,0-.065-.031.392.392,0,0,0-.007.076.74.74,0,0,0,.308.571.335.335,0,0,0,.065.031.393.393,0,0,0,.007-.076.739.739,0,0,0-.308-.571",
    transform: "translate(-337.182 -504.46)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72100",
    "data-name": "Group 72100",
    transform: "translate(56.744 81.789)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72099",
    "data-name": "Group 72099",
    className: "cls-120"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26528",
    "data-name": "Rectangle 26528",
    className: "cls-121",
    width: 0.765,
    height: 1.004,
    transform: "matrix(0.985, -0.174, 0.174, 0.985, -0.156, 0.027)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72102",
    "data-name": "Group 72102"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72101",
    "data-name": "Group 72101",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77286",
    "data-name": "Path 77286",
    className: "cls-117",
    d: "M404.165,580.164a.329.329,0,0,0-.065-.031.389.389,0,0,0-.007.076.739.739,0,0,0,.308.57.337.337,0,0,0,.065.031.4.4,0,0,0,.007-.076.739.739,0,0,0-.308-.57",
    transform: "translate(-347.113 -498.33)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72104",
    "data-name": "Group 72104",
    transform: "translate(53.484 79.776)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72103",
    "data-name": "Group 72103",
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26530",
    "data-name": "Rectangle 26530",
    className: "cls-123",
    width: 0.765,
    height: 1.004,
    transform: "translate(-0.156 0.027) rotate(-10)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72106",
    "data-name": "Group 72106"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72105",
    "data-name": "Group 72105",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77288",
    "data-name": "Path 77288",
    className: "cls-117",
    d: "M381.043,565.892a.334.334,0,0,0-.065-.031.381.381,0,0,0-.007.076.74.74,0,0,0,.308.57.341.341,0,0,0,.065.031.386.386,0,0,0,.007-.076.739.739,0,0,0-.308-.57",
    transform: "translate(-327.251 -486.071)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72108",
    "data-name": "Group 72108",
    transform: "translate(56.267 80.071)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72107",
    "data-name": "Group 72107",
    className: "cls-124"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26532",
    "data-name": "Rectangle 26532",
    className: "cls-125",
    width: 0.823,
    height: 1.007,
    transform: "matrix(0.985, -0.174, 0.174, 0.985, -0.185, 0.027)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72110",
    "data-name": "Group 72110"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72109",
    "data-name": "Group 72109",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77290",
    "data-name": "Path 77290",
    className: "cls-117",
    d: "M400.716,567.953a.636.636,0,0,0,.083.4.577.577,0,0,0,.283.277.635.635,0,0,0-.083-.4.576.576,0,0,0-.283-.277",
    transform: "translate(-344.207 -487.868)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72112",
    "data-name": "Group 72112",
    transform: "translate(53.961 81.494)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72111",
    "data-name": "Group 72111",
    className: "cls-126"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26534",
    "data-name": "Rectangle 26534",
    className: "cls-127",
    width: 0.823,
    height: 1.007,
    transform: "matrix(0.985, -0.174, 0.174, 0.985, -0.184, 0.027)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72114",
    "data-name": "Group 72114"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72113",
    "data-name": "Group 72113",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77292",
    "data-name": "Path 77292",
    className: "cls-117",
    d: "M384.366,578.046a.635.635,0,0,0,.083.4.577.577,0,0,0,.283.277.634.634,0,0,0-.083-.4.576.576,0,0,0-.283-.277",
    transform: "translate(-330.162 -496.538)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72116",
    "data-name": "Group 72116",
    transform: "translate(56.267 82.917)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72115",
    "data-name": "Group 72115",
    className: "cls-128"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26536",
    "data-name": "Rectangle 26536",
    className: "cls-129",
    width: 0.823,
    height: 1.007,
    transform: "matrix(0.985, -0.174, 0.174, 0.985, -0.185, 0.027)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72118",
    "data-name": "Group 72118"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72117",
    "data-name": "Group 72117",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77294",
    "data-name": "Path 77294",
    className: "cls-117",
    d: "M400.716,588.138a.635.635,0,0,0,.083.4.577.577,0,0,0,.283.277.634.634,0,0,0-.083-.4.576.576,0,0,0-.283-.277",
    transform: "translate(-344.207 -505.207)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72120",
    "data-name": "Group 72120",
    transform: "translate(53.961 78.648)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72119",
    "data-name": "Group 72119",
    className: "cls-130"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26538",
    "data-name": "Rectangle 26538",
    className: "cls-131",
    width: 0.823,
    height: 1.007,
    transform: "matrix(0.985, -0.174, 0.174, 0.985, -0.184, 0.027)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72122",
    "data-name": "Group 72122"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72121",
    "data-name": "Group 72121",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77296",
    "data-name": "Path 77296",
    className: "cls-117",
    d: "M384.366,557.861a.635.635,0,0,0,.083.4.576.576,0,0,0,.283.277.634.634,0,0,0-.083-.4.575.575,0,0,0-.283-.277",
    transform: "translate(-330.162 -479.199)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72124",
    "data-name": "Group 72124",
    transform: "translate(54.565 80.024)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72123",
    "data-name": "Group 72123",
    className: "cls-132"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26540",
    "data-name": "Rectangle 26540",
    className: "cls-133",
    width: 1.882,
    height: 2.513,
    transform: "translate(-0.084)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72126",
    "data-name": "Group 72126",
    transform: "translate(50.258 65.339)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72125",
    "data-name": "Group 72125",
    className: "cls-134"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26541",
    "data-name": "Rectangle 26541",
    className: "cls-135",
    width: 26.112,
    height: 26.96,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, -8.913, 5.146)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72134",
    "data-name": "Group 72134"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72133",
    "data-name": "Group 72133",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72129",
    "data-name": "Group 72129",
    className: "cls-78",
    transform: "translate(50.838 65.339)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72128",
    "data-name": "Group 72128"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72127",
    "data-name": "Group 72127",
    className: "cls-136"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77299",
    "data-name": "Path 77299",
    className: "cls-9",
    d: "M378.225,476.3a4.852,4.852,0,0,0-.457-1.939l-1.845-4.094a4.907,4.907,0,0,0-1.742-2.133l-7.19-4.438a1.459,1.459,0,0,0-1.569-.155h0l-4.883,3.015h0c.288-.183.957.217,1.618.625l1.567.967h4.149l.487.3-1.254.774c-.22.141.028.49.691.9a6.567,6.567,0,0,0,2.768.966.637.637,0,0,0,.331-.066l.815-.5.7.43-1.2.738c-.222.143.036.722.491,1.642a6.644,6.644,0,0,0,2.089,2.634.309.309,0,0,0,.3.02l2.419-1.493.39.407a4.134,4.134,0,0,1,1.013,1.6l.312,1.078Z",
    transform: "translate(-360.538 -463.374)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_77300",
    "data-name": "Path 77300",
    className: "cls-8",
    d: "M353.692,498.279l-1.845-4.094a4.9,4.9,0,0,0-1.742-2.133l-7.19-4.438a1.363,1.363,0,0,0-1.742-.017l-1.845,1.817a1.9,1.9,0,0,0-.457,1.375v4.287l.85.524c0-4.629,3.04-6.505,6.789-4.191s6.789,7.943,6.789,12.572l.849.524v-4.287a4.851,4.851,0,0,0-.457-1.939",
    transform: "translate(-291.089 -418.582)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77301",
    "data-name": "Path 77301",
    className: "cls-83",
    d: "M378.608,438.384v5.749l2.876-1.775v-5.749Z",
    transform: "translate(-325.222 -375.044)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77302",
    "data-name": "Path 77302",
    className: "cls-84",
    d: "M271.664,372.373l-17.555-10.836,2.877-1.776L274.541,370.6Z",
    transform: "translate(-218.278 -309.033)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72132",
    "data-name": "Group 72132",
    className: "cls-85",
    transform: "translate(36.112 50.729)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72131",
    "data-name": "Group 72131"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72130",
    "data-name": "Group 72130",
    className: "cls-137"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77303",
    "data-name": "Path 77303",
    className: "cls-87",
    d: "M256.105,361.364,273.661,372.2l2.6-1.6L258.7,359.762Z",
    transform: "translate(-256.105 -359.762)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_77304",
    "data-name": "Path 77304",
    className: "cls-88",
    d: "M254.109,372.354V383.49l2.877,1.776v-5.387l14.679,9.06V383.19Z",
    transform: "translate(-218.278 -319.85)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77305",
    "data-name": "Path 77305",
    className: "cls-22",
    d: "M273.256,386.909l-16.93-10.45v4.977l16.93,10.45Z",
    transform: "translate(-220.183 -323.375)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77306",
    "data-name": "Path 77306",
    className: "cls-89",
    d: "M366.569,473.741V471.75l-1.612,1Z",
    transform: "translate(-313.495 -405.23)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77307",
    "data-name": "Path 77307",
    className: "cls-89",
    d: "M343.7,450.527l3.225-1.991v-1l-.806-.5-4.031,2.488Z",
    transform: "translate(-293.85 -384.007)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77308",
    "data-name": "Path 77308",
    className: "cls-89",
    d: "M319.216,435.415l1.612,1,4.032-2.489-1.613-1Z",
    transform: "translate(-274.204 -371.881)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77309",
    "data-name": "Path 77309",
    className: "cls-89",
    d: "M296.346,421.3l1.612,1,4.032-2.489-1.613-1Z",
    transform: "translate(-254.559 -359.755)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77310",
    "data-name": "Path 77310",
    className: "cls-89",
    d: "M273.475,407.181l1.612,1,4.032-2.489-1.612-1Z",
    transform: "translate(-234.913 -347.628)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77311",
    "data-name": "Path 77311",
    className: "cls-89",
    d: "M256.326,392.566v1l.806.5,4.032-2.488-1.612-1Z",
    transform: "translate(-220.182 -335.502)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77312",
    "data-name": "Path 77312",
    className: "cls-89",
    d: "M257.938,377.454l-1.612-1v1.991Z",
    transform: "translate(-220.182 -323.376)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72136",
    "data-name": "Group 72136",
    transform: "translate(55.422 62.892)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72135",
    "data-name": "Group 72135",
    className: "cls-138"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26545",
    "data-name": "Rectangle 26545",
    className: "cls-139",
    width: 11.308,
    height: 11.009,
    transform: "translate(-3.513 1.94) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72141",
    "data-name": "Group 72141"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72140",
    "data-name": "Group 72140",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72139",
    "data-name": "Group 72139",
    className: "cls-28",
    transform: "translate(56.263 62.892)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72138",
    "data-name": "Group 72138"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72137",
    "data-name": "Group 72137",
    className: "cls-140"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77314",
    "data-name": "Path 77314",
    className: "cls-141",
    d: "M403.768,446.132l-4.759,2.938c.759-.468,1.957.023,2.675,1.1a2.126,2.126,0,0,1,.106,2.651l4.191-2.587c.611-.377.611-1.6,0-2.732s-1.6-1.743-2.213-1.366",
    transform: "translate(-399.009 -446.021)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_77315",
    "data-name": "Path 77315",
    className: "cls-142",
    d: "M395.716,470.009c-.611-1.131-1.6-1.743-2.213-1.366s-.611,1.6,0,2.732,1.6,1.743,2.213,1.366.611-1.6,0-2.732",
    transform: "translate(-337.623 -402.466)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72143",
    "data-name": "Group 72143",
    transform: "translate(59.472 65.392)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72142",
    "data-name": "Group 72142",
    className: "cls-143"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26548",
    "data-name": "Rectangle 26548",
    className: "cls-144",
    width: 11.308,
    height: 11.009,
    transform: "translate(-3.513 1.94) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72232",
    "data-name": "Group 72232"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72231",
    "data-name": "Group 72231",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72146",
    "data-name": "Group 72146",
    className: "cls-28",
    transform: "translate(60.313 65.392)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72145",
    "data-name": "Group 72145"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72144",
    "data-name": "Group 72144",
    className: "cls-140"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77317",
    "data-name": "Path 77317",
    className: "cls-141",
    d: "M432.492,463.862l-4.759,2.938c.759-.467,1.957.023,2.675,1.1a2.126,2.126,0,0,1,.106,2.651l4.191-2.587c.611-.377.611-1.6,0-2.732s-1.6-1.743-2.213-1.366",
    transform: "translate(-427.733 -463.751)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_77318",
    "data-name": "Path 77318",
    className: "cls-142",
    d: "M424.44,487.739c-.611-1.131-1.6-1.743-2.213-1.366s-.611,1.6,0,2.732,1.6,1.743,2.213,1.366.611-1.6,0-2.732",
    transform: "translate(-362.297 -417.696)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77319",
    "data-name": "Path 77319",
    className: "cls-145",
    d: "M72.447,244.826,9.656,206.068v1.266l62.791,38.758Z",
    transform: "translate(-8.294 -177.011)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77320",
    "data-name": "Path 77320",
    className: "cls-146",
    d: "M72.447,156.495,9.656,117.737l23.491-14.5L95.937,142Z",
    transform: "translate(-8.294 -88.68)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77321",
    "data-name": "Path 77321",
    className: "cls-147",
    d: "M454.961,392.606v1.266l23.491-14.5v-1.266Z",
    transform: "translate(-390.808 -324.791)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77322",
    "data-name": "Path 77322",
    className: "cls-142",
    d: "M382.637,286.266l24.3,15h.557l-24.3-15Z",
    transform: "translate(-328.683 -245.901)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72149",
    "data-name": "Group 72149",
    className: "cls-148",
    transform: "translate(53.954 40.365)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72148",
    "data-name": "Group 72148"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72147",
    "data-name": "Group 72147",
    className: "cls-149"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77323",
    "data-name": "Path 77323",
    className: "cls-142",
    d: "M382.637,286.266l24.3,15h.557l-24.3-15Z",
    transform: "translate(-382.637 -286.266)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_77324",
    "data-name": "Path 77324",
    className: "cls-142",
    d: "M551.022,393.328h1.114l-.557-.688Z",
    transform: "translate(-473.324 -337.276)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72152",
    "data-name": "Group 72152",
    className: "cls-148",
    transform: "translate(77.698 55.365)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72151",
    "data-name": "Group 72151"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72150",
    "data-name": "Group 72150",
    className: "cls-150"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77325",
    "data-name": "Path 77325",
    className: "cls-142",
    d: "M551.022,393.328h1.114l-.557-.688Z",
    transform: "translate(-551.022 -392.641)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_77326",
    "data-name": "Path 77326",
    className: "cls-151",
    d: "M555.529,392.641v.688l-.557-.688Z",
    transform: "translate(-476.717 -337.276)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72155",
    "data-name": "Group 72155",
    className: "cls-148",
    transform: "translate(78.255 55.365)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72154",
    "data-name": "Group 72154"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72153",
    "data-name": "Group 72153",
    className: "cls-152"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77327",
    "data-name": "Path 77327",
    className: "cls-151",
    d: "M555.529,392.641v.688l-.557-.688Z",
    transform: "translate(-554.972 -392.641)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_77328",
    "data-name": "Path 77328",
    className: "cls-153",
    d: "M379.243,286.266l-.557.688,24.3,15,.557-.688Z",
    transform: "translate(-325.289 -245.901)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72158",
    "data-name": "Group 72158",
    className: "cls-148",
    transform: "translate(53.397 40.365)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72157",
    "data-name": "Group 72157"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72156",
    "data-name": "Group 72156",
    className: "cls-154"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77329",
    "data-name": "Path 77329",
    className: "cls-153",
    d: "M379.243,286.266l-.557.688,24.3,15,.557-.688Z",
    transform: "translate(-378.686 -286.266)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_77330",
    "data-name": "Path 77330",
    className: "cls-142",
    d: "M358.467,301.185l24.3,15h.557l-24.3-15Z",
    transform: "translate(-307.921 -258.716)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72161",
    "data-name": "Group 72161",
    className: "cls-148",
    transform: "translate(50.546 42.469)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72160",
    "data-name": "Group 72160"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72159",
    "data-name": "Group 72159",
    className: "cls-149"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77331",
    "data-name": "Path 77331",
    className: "cls-142",
    d: "M358.467,301.185l24.3,15h.557l-24.3-15Z",
    transform: "translate(-358.467 -301.185)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_77332",
    "data-name": "Path 77332",
    className: "cls-142",
    d: "M526.851,408.248h1.114l-.557-.688Z",
    transform: "translate(-452.562 -350.091)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72164",
    "data-name": "Group 72164",
    className: "cls-148",
    transform: "translate(74.289 57.469)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72163",
    "data-name": "Group 72163"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72162",
    "data-name": "Group 72162",
    className: "cls-150"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77333",
    "data-name": "Path 77333",
    className: "cls-142",
    d: "M526.851,408.248h1.114l-.557-.688Z",
    transform: "translate(-526.851 -407.56)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_77334",
    "data-name": "Path 77334",
    className: "cls-151",
    d: "M531.358,407.56v.688l-.557-.688Z",
    transform: "translate(-455.955 -350.091)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72167",
    "data-name": "Group 72167",
    className: "cls-148",
    transform: "translate(74.847 57.469)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72166",
    "data-name": "Group 72166"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72165",
    "data-name": "Group 72165",
    className: "cls-152"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77335",
    "data-name": "Path 77335",
    className: "cls-151",
    d: "M531.358,407.56v.688l-.557-.688Z",
    transform: "translate(-530.801 -407.56)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_77336",
    "data-name": "Path 77336",
    className: "cls-153",
    d: "M355.074,301.185l-.557.688,24.3,15,.557-.688Z",
    transform: "translate(-304.528 -258.716)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72170",
    "data-name": "Group 72170",
    className: "cls-148",
    transform: "translate(49.989 42.469)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72169",
    "data-name": "Group 72169"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72168",
    "data-name": "Group 72168",
    className: "cls-154"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77337",
    "data-name": "Path 77337",
    className: "cls-153",
    d: "M355.074,301.185l-.557.688,24.3,15,.557-.688Z",
    transform: "translate(-354.517 -301.185)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_77338",
    "data-name": "Path 77338",
    className: "cls-142",
    d: "M334.3,316.1l24.3,15h.557l-24.3-15Z",
    transform: "translate(-287.159 -271.532)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77339",
    "data-name": "Path 77339",
    className: "cls-142",
    d: "M502.681,423.167h1.114l-.557-.688Z",
    transform: "translate(-431.799 -362.907)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77340",
    "data-name": "Path 77340",
    className: "cls-151",
    d: "M507.188,422.479v.688l-.557-.688Z",
    transform: "translate(-435.193 -362.907)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77341",
    "data-name": "Path 77341",
    className: "cls-153",
    d: "M330.9,316.1l-.557.688,24.3,15,.557-.688Z",
    transform: "translate(-283.765 -271.532)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77342",
    "data-name": "Path 77342",
    className: "cls-142",
    d: "M406.808,271.347l24.3,15h.557l-24.3-15Z",
    transform: "translate(-349.445 -233.085)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77343",
    "data-name": "Path 77343",
    className: "cls-142",
    d: "M575.192,378.409h1.114l-.557-.688Z",
    transform: "translate(-494.086 -324.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77344",
    "data-name": "Path 77344",
    className: "cls-151",
    d: "M579.7,377.721v.688l-.557-.688Z",
    transform: "translate(-497.48 -324.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77345",
    "data-name": "Path 77345",
    className: "cls-153",
    d: "M403.414,271.347l-.557.688,24.3,15,.557-.688Z",
    transform: "translate(-346.051 -233.085)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77346",
    "data-name": "Path 77346",
    className: "cls-142",
    d: "M285.956,345.943l24.3,15h.557l-24.3-15Z",
    transform: "translate(-245.634 -297.163)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77347",
    "data-name": "Path 77347",
    className: "cls-142",
    d: "M454.34,453.006h1.114l-.557-.688Z",
    transform: "translate(-390.275 -388.538)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77348",
    "data-name": "Path 77348",
    className: "cls-151",
    d: "M458.847,452.318v.688l-.557-.688Z",
    transform: "translate(-393.668 -388.538)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77349",
    "data-name": "Path 77349",
    className: "cls-153",
    d: "M282.562,345.943l-.557.688,24.3,15,.557-.688Z",
    transform: "translate(-242.24 -297.163)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77350",
    "data-name": "Path 77350",
    className: "cls-142",
    d: "M310.126,331.024l24.3,15h.557l-24.3-15Z",
    transform: "translate(-266.396 -284.347)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77351",
    "data-name": "Path 77351",
    className: "cls-142",
    d: "M478.51,438.086h1.114l-.557-.688Z",
    transform: "translate(-411.037 -375.722)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77352",
    "data-name": "Path 77352",
    className: "cls-151",
    d: "M483.018,437.4v.688l-.557-.688Z",
    transform: "translate(-414.431 -375.723)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77353",
    "data-name": "Path 77353",
    className: "cls-153",
    d: "M306.732,331.024l-.557.688,24.3,15,.557-.688Z",
    transform: "translate(-263.002 -284.347)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77354",
    "data-name": "Path 77354",
    className: "cls-8",
    d: "M199.463,57.834l-.3,10.116,1.1.678.3-10.116Z",
    transform: "translate(-171.081 -49.679)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72173",
    "data-name": "Group 72173",
    className: "cls-85",
    transform: "translate(29.122 10.647)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72172",
    "data-name": "Group 72172"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72171",
    "data-name": "Group 72171",
    className: "cls-155"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77355",
    "data-name": "Path 77355",
    className: "cls-33",
    d: "M206.824,75.873l-.091-.368-.2,6.852.1.059Z",
    transform: "translate(-206.531 -75.505)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_77356",
    "data-name": "Path 77356",
    className: "cls-9",
    d: "M208.386,58.3l-.3,10.116-1.136.612.3-10.116Z",
    transform: "translate(-177.77 -50.081)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77357",
    "data-name": "Path 77357",
    className: "cls-7",
    d: "M202.418,53.495l-1.136.612,1.1.678,1.136-.612Z",
    transform: "translate(-172.9 -45.952)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77358",
    "data-name": "Path 77358",
    className: "cls-156",
    d: "M209.412,72.5l21.529,13.291.928-.5L210.34,72Z",
    transform: "translate(-179.884 -61.848)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77359",
    "data-name": "Path 77359",
    className: "cls-142",
    d: "M208.193,75.548l-.2,6.782L229.522,95.62l.2-6.782Z",
    transform: "translate(-178.665 -64.895)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77360",
    "data-name": "Path 77360",
    className: "cls-8",
    d: "M359.927,156.9l-.3,10.116,1.1.678.3-10.116Z",
    transform: "translate(-308.918 -134.776)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77361",
    "data-name": "Path 77361",
    className: "cls-9",
    d: "M368.85,157.367l-.3,10.116-1.136.612.3-10.116Z",
    transform: "translate(-315.607 -135.177)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77362",
    "data-name": "Path 77362",
    className: "cls-7",
    d: "M362.882,152.56l-1.136.612,1.1.678,1.136-.612Z",
    transform: "translate(-310.737 -131.048)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77363",
    "data-name": "Path 77363",
    className: "cls-156",
    d: "M369.876,171.566,391.4,184.857l.928-.5L370.8,171.066Z",
    transform: "translate(-317.721 -146.945)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72176",
    "data-name": "Group 72176",
    className: "cls-157",
    transform: "translate(52.155 24.121)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72175",
    "data-name": "Group 72175"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72174",
    "data-name": "Group 72174",
    className: "cls-158"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77364",
    "data-name": "Path 77364",
    className: "cls-33",
    d: "M370.8,171.066l-.928.5.1.062,1.041.031.4-.215Z",
    transform: "translate(-369.876 -171.066)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_77365",
    "data-name": "Path 77365",
    className: "cls-142",
    d: "M368.657,174.613l-.2,6.782,21.529,13.291.2-6.782Z",
    transform: "translate(-316.502 -149.991)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72179",
    "data-name": "Group 72179",
    className: "cls-157",
    transform: "translate(29.528 10.153)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72178",
    "data-name": "Group 72178"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72177",
    "data-name": "Group 72177",
    className: "cls-158"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77366",
    "data-name": "Path 77366",
    className: "cls-33",
    d: "M210.34,72l-.928.5.1.062,1.041.031.4-.215Z",
    transform: "translate(-209.412 -72.001)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_77367",
    "data-name": "Path 77367",
    className: "cls-156",
    d: "M72.306,71.576,51.081,83.009l.9.554L73.2,72.13Z",
    transform: "translate(-43.879 -61.484)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72182",
    "data-name": "Group 72182",
    className: "cls-148",
    transform: "translate(7.203 21.47)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72181",
    "data-name": "Group 72181"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72180",
    "data-name": "Group 72180",
    className: "cls-159"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77368",
    "data-name": "Path 77368",
    className: "cls-33",
    d: "M51.979,152.869l-.9-.554.1-.056,1.041.031.386.238Z",
    transform: "translate(-51.082 -152.259)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_77369",
    "data-name": "Path 77369",
    className: "cls-147",
    d: "M56.709,86.994l5.773,3.564,15.355-8.271.2-6.782Z",
    transform: "translate(-48.713 -64.859)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72185",
    "data-name": "Group 72185",
    className: "cls-160",
    transform: "translate(51.955 24.622)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72184",
    "data-name": "Group 72184"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72183",
    "data-name": "Group 72183",
    className: "cls-161"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77370",
    "data-name": "Path 77370",
    className: "cls-33",
    d: "M368.657,174.613l-.2,6.782.1.062.2-6.782Z",
    transform: "translate(-368.457 -174.613)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_77371",
    "data-name": "Path 77371",
    className: "cls-8",
    d: "M520.391,255.965l-.3,10.116,1.1.678.3-10.116Z",
    transform: "translate(-446.756 -219.873)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72188",
    "data-name": "Group 72188",
    className: "cls-85",
    transform: "translate(74.334 38.584)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72187",
    "data-name": "Group 72187"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72186",
    "data-name": "Group 72186",
    className: "cls-162"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77372",
    "data-name": "Path 77372",
    className: "cls-33",
    d: "M527.5,274l-.091-.368-.243,8.243.1.059Z",
    transform: "translate(-527.167 -273.636)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_77373",
    "data-name": "Path 77373",
    className: "cls-9",
    d: "M529.314,256.433l-.3,10.116-1.136.612.3-10.116Z",
    transform: "translate(-453.445 -220.274)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77374",
    "data-name": "Path 77374",
    className: "cls-7",
    d: "M523.346,251.626l-1.136.612,1.1.678,1.136-.612Z",
    transform: "translate(-448.575 -216.145)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77375",
    "data-name": "Path 77375",
    className: "cls-163",
    d: "M135.837,137.575l-.1.056-1.1-.678,0-.118-21.428-13.229-.1.056-.1-.062-15.355,8.271,39.8,24.569,14.244-9.077Z",
    transform: "translate(-83.883 -106.172)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72191",
    "data-name": "Group 72191",
    className: "cls-157",
    transform: "translate(51.851 31.403)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72190",
    "data-name": "Group 72190"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72189",
    "data-name": "Group 72189",
    className: "cls-164"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77376",
    "data-name": "Path 77376",
    className: "cls-33",
    d: "M367.721,222.764l.2.006-.1-.062Z",
    transform: "translate(-367.721 -222.708)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_77377",
    "data-name": "Path 77377",
    className: "cls-147",
    d: "M376.892,285.068l-.243,8.24,21.224-11.433.243-8.24Z",
    transform: "translate(-323.539 -235.051)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77378",
    "data-name": "Path 77378",
    className: "cls-165",
    d: "M385.492,298.316l.069-2.345,19.168-10.325-.069,2.346Z",
    transform: "translate(-331.136 -245.368)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77379",
    "data-name": "Path 77379",
    className: "cls-166",
    d: "M519.213,287.589l.313.4.069-2.346-.33.178Z",
    transform: "translate(-446.001 -245.368)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77380",
    "data-name": "Path 77380",
    className: "cls-167",
    d: "M404.348,299.424l.313.4-19.169,10.325.017-.58Z",
    transform: "translate(-331.135 -257.203)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77381",
    "data-name": "Path 77381",
    className: "cls-165",
    d: "M403.992,310.669l-.069,2.346L384.754,323.34l.069-2.345Z",
    transform: "translate(-330.502 -266.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77382",
    "data-name": "Path 77382",
    className: "cls-166",
    d: "M518.475,312.613l.313.4.069-2.345-.33.178Z",
    transform: "translate(-445.367 -266.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77383",
    "data-name": "Path 77383",
    className: "cls-167",
    d: "M403.609,324.448l.313.4-19.169,10.325.017-.58Z",
    transform: "translate(-330.501 -278.699)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77384",
    "data-name": "Path 77384",
    className: "cls-156",
    d: "M372.009,281.14l.9.554,21.224-11.433-.9-.554Z",
    transform: "translate(-319.554 -231.677)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72194",
    "data-name": "Group 72194",
    className: "cls-148",
    transform: "translate(52.456 49.407)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72193",
    "data-name": "Group 72193"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72192",
    "data-name": "Group 72192",
    className: "cls-159"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77385",
    "data-name": "Path 77385",
    className: "cls-33",
    d: "M372.907,351l-.9-.554.1-.056,1.041.031.386.238Z",
    transform: "translate(-372.01 -350.39)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_77386",
    "data-name": "Path 77386",
    className: "cls-8",
    d: "M40.888,143.253l-.3,10.116,1.1.678.3-10.116Z",
    transform: "translate(-34.866 -123.053)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77387",
    "data-name": "Path 77387",
    className: "cls-7",
    d: "M43.843,138.913l-1.136.612,1.1.678,1.136-.612Z",
    transform: "translate(-36.685 -119.325)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77388",
    "data-name": "Path 77388",
    className: "cls-9",
    d: "M49.811,143.72l-.3,10.116-1.136.612.3-10.116Z",
    transform: "translate(-41.555 -123.455)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77389",
    "data-name": "Path 77389",
    className: "cls-156",
    d: "M50.836,157.919,72.365,171.21l.928-.5L51.765,157.419Z",
    transform: "translate(-43.668 -135.222)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72197",
    "data-name": "Group 72197",
    className: "cls-148",
    transform: "translate(7.168 22.197)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72196",
    "data-name": "Group 72196"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72195",
    "data-name": "Group 72195",
    className: "cls-158"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77390",
    "data-name": "Path 77390",
    className: "cls-33",
    d: "M51.765,157.42l-.928.5.1.062,1.041.031.4-.215Z",
    transform: "translate(-50.836 -157.419)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_77391",
    "data-name": "Path 77391",
    className: "cls-142",
    d: "M49.355,160.966l-.243,8.24L70.641,182.5l.243-8.24Z",
    transform: "translate(-42.187 -138.269)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72200",
    "data-name": "Group 72200",
    className: "cls-168",
    transform: "translate(6.925 22.697)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72199",
    "data-name": "Group 72199"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72198",
    "data-name": "Group 72198",
    className: "cls-169"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77392",
    "data-name": "Path 77392",
    className: "cls-33",
    d: "M49.355,160.966l-.243,8.24.1.062.243-8.24Z",
    transform: "translate(-49.112 -160.966)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_77393",
    "data-name": "Path 77393",
    className: "cls-170",
    d: "M57.024,199.069l-.069,2.346L76.5,213.479l.069-2.345Z",
    transform: "translate(-48.924 -170.999)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77394",
    "data-name": "Path 77394",
    className: "cls-147",
    d: "M57.291,201.031l-.336.384.069-2.346.319.2Z",
    transform: "translate(-48.924 -170.999)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77395",
    "data-name": "Path 77395",
    className: "cls-170",
    d: "M77.235,188.455l.069-2.346L57.762,174.045l-.069,2.346Z",
    transform: "translate(-49.558 -149.504)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77396",
    "data-name": "Path 77396",
    className: "cls-147",
    d: "M58.029,176.007l-.336.384.069-2.346.319.2Z",
    transform: "translate(-49.558 -149.504)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77397",
    "data-name": "Path 77397",
    className: "cls-156",
    d: "M58.029,187.959l-.336.384,19.542,12.064.017-.58Z",
    transform: "translate(-49.558 -161.456)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72203",
    "data-name": "Group 72203",
    className: "cls-168",
    transform: "translate(8.135 26.503)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72202",
    "data-name": "Group 72202"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72201",
    "data-name": "Group 72201",
    className: "cls-171"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77398",
    "data-name": "Path 77398",
    className: "cls-33",
    d: "M57.693,188.343l.655-.187-.319-.2Z",
    transform: "translate(-57.693 -187.959)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72206",
    "data-name": "Group 72206",
    className: "cls-172",
    transform: "translate(8.471 24.738)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72205",
    "data-name": "Group 72205"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72204",
    "data-name": "Group 72204",
    className: "cls-173"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77399",
    "data-name": "Path 77399",
    className: "cls-33",
    d: "M60.13,175.442l-.052,1.765.319.2.034-1.166,18.9,11.67.018-.6Z",
    transform: "translate(-60.078 -175.442)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72209",
    "data-name": "Group 72209",
    className: "cls-172",
    transform: "translate(8.367 28.267)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72208",
    "data-name": "Group 72208"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72207",
    "data-name": "Group 72207",
    className: "cls-173"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77400",
    "data-name": "Path 77400",
    className: "cls-33",
    d: "M59.392,200.465l-.052,1.765.319.2.034-1.166,18.9,11.671.018-.6Z",
    transform: "translate(-59.339 -200.466)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_77401",
    "data-name": "Path 77401",
    className: "cls-156",
    d: "M57.291,212.983l-.336.384L76.5,225.431l.017-.58Z",
    transform: "translate(-48.924 -182.951)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72212",
    "data-name": "Group 72212",
    className: "cls-168",
    transform: "translate(8.031 30.032)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72211",
    "data-name": "Group 72211"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72210",
    "data-name": "Group 72210",
    className: "cls-171"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77402",
    "data-name": "Path 77402",
    className: "cls-33",
    d: "M56.955,213.366l.655-.187-.319-.2Z",
    transform: "translate(-56.955 -212.983)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_77403",
    "data-name": "Path 77403",
    className: "cls-8",
    d: "M201.352,242.318l-.3,10.116,1.1.678.3-10.116Z",
    transform: "translate(-172.703 -208.15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77404",
    "data-name": "Path 77404",
    className: "cls-9",
    d: "M210.274,242.786l-.3,10.116-1.136.612.3-10.116Z",
    transform: "translate(-179.392 -208.551)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77405",
    "data-name": "Path 77405",
    className: "cls-7",
    d: "M204.306,237.979l-1.136.612,1.1.678,1.136-.612Z",
    transform: "translate(-174.522 -204.422)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77406",
    "data-name": "Path 77406",
    className: "cls-156",
    d: "M211.3,256.985l21.529,13.291.928-.5-21.529-13.291Z",
    transform: "translate(-181.506 -220.319)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72215",
    "data-name": "Group 72215",
    className: "cls-148",
    transform: "translate(29.795 36.166)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72214",
    "data-name": "Group 72214"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72213",
    "data-name": "Group 72213",
    className: "cls-158"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77407",
    "data-name": "Path 77407",
    className: "cls-33",
    d: "M212.229,256.485l-.928.5.1.062,1.041.031.4-.215Z",
    transform: "translate(-211.3 -256.485)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_77408",
    "data-name": "Path 77408",
    className: "cls-142",
    d: "M209.819,260.031l-.243,8.24L231.1,281.563l.243-8.24Z",
    transform: "translate(-180.025 -223.365)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72218",
    "data-name": "Group 72218",
    className: "cls-168",
    transform: "translate(29.552 36.666)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72217",
    "data-name": "Group 72217"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72216",
    "data-name": "Group 72216",
    className: "cls-174"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77409",
    "data-name": "Path 77409",
    className: "cls-33",
    d: "M209.82,260.031l-.243,8.24.1.062.243-8.24Z",
    transform: "translate(-209.577 -260.032)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_77410",
    "data-name": "Path 77410",
    className: "cls-170",
    d: "M236.6,286.842l.069-2.345-19.542-12.064-.069,2.346Z",
    transform: "translate(-186.45 -234.017)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77411",
    "data-name": "Path 77411",
    className: "cls-147",
    d: "M217.393,274.394l-.336.384.069-2.346.319.2Z",
    transform: "translate(-186.451 -234.017)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77412",
    "data-name": "Path 77412",
    className: "cls-156",
    d: "M217.393,286.346l-.336.384L236.6,298.794l.017-.58Z",
    transform: "translate(-186.451 -245.969)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72221",
    "data-name": "Group 72221",
    className: "cls-168",
    transform: "translate(30.606 40.377)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72220",
    "data-name": "Group 72220"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72219",
    "data-name": "Group 72219",
    className: "cls-171"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77413",
    "data-name": "Path 77413",
    className: "cls-33",
    d: "M217.057,286.729l.655-.187-.319-.2Z",
    transform: "translate(-217.057 -286.346)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72224",
    "data-name": "Group 72224",
    className: "cls-172",
    transform: "translate(30.943 38.612)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72223",
    "data-name": "Group 72223"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72222",
    "data-name": "Group 72222",
    className: "cls-173"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77414",
    "data-name": "Path 77414",
    className: "cls-33",
    d: "M219.494,273.828l-.052,1.765.319.2.034-1.166,18.9,11.671.018-.6Z",
    transform: "translate(-219.442 -273.828)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_77415",
    "data-name": "Path 77415",
    className: "cls-170",
    d: "M216.388,297.455l-.069,2.346,19.542,12.064.069-2.345Z",
    transform: "translate(-185.816 -255.512)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77416",
    "data-name": "Path 77416",
    className: "cls-147",
    d: "M216.655,299.417l-.336.384.069-2.346.319.2Z",
    transform: "translate(-185.817 -255.512)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72227",
    "data-name": "Group 72227",
    className: "cls-172",
    transform: "translate(30.839 42.14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72226",
    "data-name": "Group 72226"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72225",
    "data-name": "Group 72225",
    className: "cls-173"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77417",
    "data-name": "Path 77417",
    className: "cls-33",
    d: "M218.756,298.852l-.052,1.765.319.2.034-1.166,18.9,11.671.018-.6Z",
    transform: "translate(-218.704 -298.852)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_77418",
    "data-name": "Path 77418",
    className: "cls-156",
    d: "M216.655,311.369l-.336.384,19.542,12.064.017-.58Z",
    transform: "translate(-185.817 -267.464)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72230",
    "data-name": "Group 72230",
    className: "cls-168",
    transform: "translate(30.502 43.905)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72229",
    "data-name": "Group 72229"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72228",
    "data-name": "Group 72228",
    className: "cls-171"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77419",
    "data-name": "Path 77419",
    className: "cls-33",
    d: "M216.319,311.753l.655-.187-.319-.2Z",
    transform: "translate(-216.319 -311.369)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_77420",
    "data-name": "Path 77420",
    className: "cls-8",
    d: "M361.816,341.384l-.3,10.116,1.1.678.3-10.116Z",
    transform: "translate(-310.541 -293.246)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77421",
    "data-name": "Path 77421",
    className: "cls-9",
    d: "M370.738,341.851l-.3,10.116-1.136.612.3-10.116Z",
    transform: "translate(-317.23 -293.648)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77422",
    "data-name": "Path 77422",
    className: "cls-7",
    d: "M364.77,337.044l-1.136.612,1.1.678,1.136-.612Z",
    transform: "translate(-312.36 -289.519)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72234",
    "data-name": "Group 72234",
    transform: "translate(50.878 37.923)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72233",
    "data-name": "Group 72233",
    className: "cls-175"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26579",
    "data-name": "Rectangle 26579",
    className: "cls-176",
    width: 5.043,
    height: 4.331,
    transform: "translate(-1.932 3.303) rotate(-60)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72242",
    "data-name": "Group 72242"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72241",
    "data-name": "Group 72241",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72237",
    "data-name": "Group 72237",
    className: "cls-177",
    transform: "translate(51.362 37.941)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72236",
    "data-name": "Group 72236"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72235",
    "data-name": "Group 72235",
    className: "cls-178"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77424",
    "data-name": "Path 77424",
    className: "cls-179",
    d: "M364.431,269.072a.437.437,0,0,0-.18.1v.819h.18Z",
    transform: "translate(-364.251 -269.072)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72240",
    "data-name": "Group 72240",
    className: "cls-177",
    transform: "translate(51.849 37.949)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72239",
    "data-name": "Group 72239"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72238",
    "data-name": "Group 72238",
    className: "cls-180"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77425",
    "data-name": "Path 77425",
    className: "cls-179",
    d: "M367.888,269.2a.963.963,0,0,0-.18-.072v.908h.18Z",
    transform: "translate(-367.708 -269.131)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72244",
    "data-name": "Group 72244",
    transform: "translate(51.438 37.747)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72243",
    "data-name": "Group 72243",
    className: "cls-181"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26583",
    "data-name": "Rectangle 26583",
    className: "cls-182",
    width: 4.151,
    height: 5.008,
    transform: "translate(-1.959 1.131) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72255",
    "data-name": "Group 72255"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72254",
    "data-name": "Group 72254",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72247",
    "data-name": "Group 72247",
    className: "cls-78",
    transform: "translate(51.849 37.949)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72246",
    "data-name": "Group 72246"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72245",
    "data-name": "Group 72245",
    className: "cls-183"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77427",
    "data-name": "Path 77427",
    className: "cls-179",
    d: "M368.856,269.669a2.131,2.131,0,0,0-.262-.337,1.955,1.955,0,0,0-.887-.2h0a.933.933,0,0,1,.183.072,2.465,2.465,0,0,1,.966.465",
    transform: "translate(-367.707 -269.131)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72250",
    "data-name": "Group 72250",
    className: "cls-184",
    transform: "translate(51.438 37.747)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72249",
    "data-name": "Group 72249"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72248",
    "data-name": "Group 72248",
    className: "cls-185"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77428",
    "data-name": "Path 77428",
    className: "cls-179",
    d: "M365.1,267.757l-.309.175v0a.452.452,0,0,1,.1-.038l.007,0a1.639,1.639,0,0,1,.689-.145.572.572,0,0,0-.484.009",
    transform: "translate(-364.794 -267.7)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72253",
    "data-name": "Group 72253",
    className: "cls-186",
    transform: "translate(52.86 38.99)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72252",
    "data-name": "Group 72252"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72251",
    "data-name": "Group 72251",
    className: "cls-187"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77429",
    "data-name": "Path 77429",
    className: "cls-179",
    d: "M375.13,277.074l.476.355a1.179,1.179,0,0,0-.1-.388l-.044-.1-.583-.435Z",
    transform: "translate(-374.875 -276.509)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_77430",
    "data-name": "Path 77430",
    className: "cls-188",
    d: "M363.332,210.428a.084.084,0,0,1-.084-.084V200.273a.084.084,0,1,1,.169,0v10.071a.084.084,0,0,1-.084.084",
    transform: "translate(-312.028 -171.961)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77431",
    "data-name": "Path 77431",
    className: "cls-188",
    d: "M359.814,212.173a.084.084,0,0,1-.084-.084V202.3a.084.084,0,1,1,.169,0v9.784a.084.084,0,0,1-.084.084",
    transform: "translate(-309.006 -173.706)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72257",
    "data-name": "Group 72257",
    transform: "translate(51.561 42.064)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72256",
    "data-name": "Group 72256",
    className: "cls-189"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26588",
    "data-name": "Rectangle 26588",
    className: "cls-190",
    width: 2.24,
    height: 2.644,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, -1.013, 0.585)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72259",
    "data-name": "Group 72259",
    transform: "translate(50.997 42.718)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72258",
    "data-name": "Group 72258",
    className: "cls-191"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26589",
    "data-name": "Rectangle 26589",
    className: "cls-192",
    width: 2.02,
    height: 2.179,
    transform: "translate(-0.765 0.439) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72270",
    "data-name": "Group 72270"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72269",
    "data-name": "Group 72269",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77434",
    "data-name": "Path 77434",
    className: "cls-106",
    d: "M362.531,299.851v-.3l-.3-.176v.313a.616.616,0,0,0,.088.3l.285.493c.12.209.14.446.031.535-.125.1-.348-.018-.483-.251l-.4-.687c-.04-.07-.107-.057-.085.017l.091.3c.013.045.023.089.032.133a1.554,1.554,0,0,0,.747,1.024.417.417,0,0,0,.645-.394,1.57,1.57,0,0,0-.6-1.206.14.14,0,0,1-.052-.1",
    transform: "translate(-310.665 -257.162)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72262",
    "data-name": "Group 72262",
    className: "cls-193",
    transform: "translate(51.561 42.214)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72261",
    "data-name": "Group 72261"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72260",
    "data-name": "Group 72260",
    className: "cls-194"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77435",
    "data-name": "Path 77435",
    className: "cls-9",
    d: "M366.022,299.952a.14.14,0,0,1-.052-.1v-.3l-.3-.176v.313a.615.615,0,0,0,.088.3l.278.481.3.173a.188.188,0,0,0,.2.015,1.629,1.629,0,0,0-.508-.7",
    transform: "translate(-365.665 -299.375)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72265",
    "data-name": "Group 72265",
    className: "cls-177",
    transform: "translate(52.934 39.155)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72264",
    "data-name": "Group 72264"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72263",
    "data-name": "Group 72263",
    className: "cls-195"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77436",
    "data-name": "Path 77436",
    className: "cls-179",
    d: "M375.583,278.08l-.18-.4v.506h.18Z",
    transform: "translate(-375.403 -277.681)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72268",
    "data-name": "Group 72268",
    className: "cls-196",
    transform: "translate(50.915 39.421)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72267",
    "data-name": "Group 72267"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72266",
    "data-name": "Group 72266",
    className: "cls-197"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77437",
    "data-name": "Path 77437",
    className: "cls-87",
    d: "M361.99,280.716h0l-.17-.608a.885.885,0,0,0-.085-.2c-.149-.258-.39-.4-.539-.311-.111.064-.139.236-.084.426h0l.17.608a.886.886,0,0,0,.086.2c.149.258.39.4.539.311.111-.064.139-.236.084-.426",
    transform: "translate(-361.083 -279.57)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72272",
    "data-name": "Group 72272",
    transform: "translate(51.543 20.867)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72271",
    "data-name": "Group 72271",
    className: "cls-198"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26594",
    "data-name": "Rectangle 26594",
    className: "cls-199",
    width: 7.007,
    height: 9.307,
    transform: "translate(-3.948 2.278) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72280",
    "data-name": "Group 72280"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72279",
    "data-name": "Group 72279",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77439",
    "data-name": "Path 77439",
    className: "cls-200",
    d: "M365.534,197.575a2.313,2.313,0,0,0,1.047,1.813c.578.334,1.047.063,1.047-.6Z",
    transform: "translate(-313.991 -169.716)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77440",
    "data-name": "Path 77440",
    className: "cls-188",
    d: "M374.484,217.274a.084.084,0,0,1-.084-.084V206.711a.084.084,0,0,1,.169,0V217.19a.084.084,0,0,1-.084.084",
    transform: "translate(-321.607 -177.491)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77441",
    "data-name": "Path 77441",
    className: "cls-188",
    d: "M370.966,219.358a.084.084,0,0,1-.084-.084V208.742a.084.084,0,1,1,.169,0v10.531a.084.084,0,0,1-.084.084",
    transform: "translate(-318.585 -179.236)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77442",
    "data-name": "Path 77442",
    className: "cls-89",
    d: "M366.581,151.133h0c-.578-.334-1.047-.063-1.047.6l2.093,1.208a2.314,2.314,0,0,0-1.047-1.813",
    transform: "translate(-313.991 -129.7)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72275",
    "data-name": "Group 72275",
    className: "cls-177",
    transform: "translate(53.157 22.718)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72274",
    "data-name": "Group 72274"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72273",
    "data-name": "Group 72273",
    className: "cls-201"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77443",
    "data-name": "Path 77443",
    className: "cls-179",
    d: "M377.068,161.412l-.084-.3.04.275Z",
    transform: "translate(-376.984 -161.111)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_77444",
    "data-name": "Path 77444",
    className: "cls-179",
    d: "M370.606,164.312l-1.76,1.016v5.821l1.76-1.016Z",
    transform: "translate(-316.836 -141.143)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77445",
    "data-name": "Path 77445",
    className: "cls-202",
    d: "M356.44,156.289l-1.493.862,2.093,1.208,1.493-.862Z",
    transform: "translate(-304.897 -134.251)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72278",
    "data-name": "Group 72278",
    className: "cls-184",
    transform: "translate(50.05 22.899)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72277",
    "data-name": "Group 72277"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72276",
    "data-name": "Group 72276",
    className: "cls-203"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77446",
    "data-name": "Path 77446",
    className: "cls-179",
    d: "M357.035,163.156l1.1-.637-.044-.025-1.1.634c-.058-.04-.123-.081-.2-.124a4.6,4.6,0,0,0-1.852-.6l1.655.955h0l.035.02.4.233.269-.155a.678.678,0,0,0-.274-.3",
    transform: "translate(-354.947 -162.4)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72282",
    "data-name": "Group 72282",
    transform: "translate(50.804 21.857)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72281",
    "data-name": "Group 72281",
    className: "cls-204"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26598",
    "data-name": "Rectangle 26598",
    className: "cls-205",
    width: 3.208,
    height: 3.103,
    transform: "translate(-0.998 0.542) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72284",
    "data-name": "Group 72284",
    transform: "translate(49.317 22.152)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72283",
    "data-name": "Group 72283",
    className: "cls-206"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26599",
    "data-name": "Rectangle 26599",
    className: "cls-207",
    width: 7.007,
    height: 9.307,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, -3.948, 2.278)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72295",
    "data-name": "Group 72295"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72294",
    "data-name": "Group 72294",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77449",
    "data-name": "Path 77449",
    className: "cls-111",
    d: "M365.381,173.769h0l-.787,1.364v.909l1.48-2.563,1.48.854v-.909l-.787-.454Z",
    transform: "translate(-313.184 -148.58)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77450",
    "data-name": "Path 77450",
    className: "cls-111",
    d: "M370.87,195.926l-.692,1.2,1.384-.8Z",
    transform: "translate(-317.98 -168.299)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77451",
    "data-name": "Path 77451",
    className: "cls-111",
    d: "M366.074,183.031h0l-1.48,2.563v.909l1.48-2.563,1.48.854v-.909Z",
    transform: "translate(-313.184 -157.222)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77452",
    "data-name": "Path 77452",
    className: "cls-89",
    d: "M349.75,160.85v5.822a2.313,2.313,0,0,0,1.047,1.813c.578.334,1.047.063,1.047-.6v-5.822a2.313,2.313,0,0,0-1.047-1.813c-.578-.334-1.047-.063-1.047.6",
    transform: "translate(-300.433 -137.528)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72287",
    "data-name": "Group 72287",
    className: "cls-177",
    transform: "translate(49.838 29.069)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72286",
    "data-name": "Group 72286"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72285",
    "data-name": "Group 72285",
    className: "cls-208"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77453",
    "data-name": "Path 77453",
    className: "cls-179",
    d: "M354.693,207.737h0l-.235-.839a1.222,1.222,0,0,0-.118-.277c-.205-.356-.538-.548-.744-.429-.153.089-.192.325-.116.588l.235.84a1.221,1.221,0,0,0,.118.277,1.243,1.243,0,0,0,.069.106c.022.014.044.029.067.042a.729.729,0,0,0,.748.068.774.774,0,0,0-.024-.375",
    transform: "translate(-353.443 -206.157)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72290",
    "data-name": "Group 72290",
    className: "cls-177",
    transform: "translate(49.838 23.248)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72289",
    "data-name": "Group 72289"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72288",
    "data-name": "Group 72288",
    className: "cls-209"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77454",
    "data-name": "Path 77454",
    className: "cls-179",
    d: "M354.693,166.451h0l-.235-.839a1.221,1.221,0,0,0-.118-.277c-.205-.356-.538-.548-.744-.429-.153.089-.192.325-.116.588l.235.84a1.221,1.221,0,0,0,.118.277c.205.356.538.548.744.429.153-.089.192-.325.116-.588",
    transform: "translate(-353.443 -164.871)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_77455",
    "data-name": "Path 77455",
    className: "cls-22",
    d: "M353.426,181.861v.909L355,185.5v-.909Z",
    transform: "translate(-303.591 -156.218)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77456",
    "data-name": "Path 77456",
    className: "cls-22",
    d: "M353.426,194.757v.909l.787.455Z",
    transform: "translate(-303.591 -167.295)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77457",
    "data-name": "Path 77457",
    className: "cls-22",
    d: "M354.214,175.868l-.787-.455L355,178.141v-.909Z",
    transform: "translate(-303.591 -150.679)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72293",
    "data-name": "Group 72293",
    className: "cls-31",
    transform: "translate(50.208 24.95)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72292",
    "data-name": "Group 72292"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72291",
    "data-name": "Group 72291",
    className: "cls-210"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77458",
    "data-name": "Path 77458",
    className: "cls-33",
    d: "M356.482,177.179l-.415-.24.02.038a.9.9,0,0,0,.542.458Z",
    transform: "translate(-356.067 -176.939)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72297",
    "data-name": "Group 72297",
    transform: "translate(49.601 23.248)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72296",
    "data-name": "Group 72296",
    className: "cls-211"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26604",
    "data-name": "Rectangle 26604",
    className: "cls-212",
    width: 1.994,
    height: 2.062,
    transform: "translate(-0.735 0.395) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72299",
    "data-name": "Group 72299"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72298",
    "data-name": "Group 72298",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77460",
    "data-name": "Path 77460",
    className: "cls-213",
    d: "M352.665,166.3c-.205-.356-.538-.548-.744-.429s-.205.5,0,.859.538.548.744.43.205-.5,0-.859",
    transform: "translate(-302.166 -142.454)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72301",
    "data-name": "Group 72301",
    transform: "translate(49.601 29.069)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72300",
    "data-name": "Group 72300",
    className: "cls-214"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26606",
    "data-name": "Rectangle 26606",
    className: "cls-215",
    width: 1.994,
    height: 2.062,
    transform: "translate(-0.735 0.395) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72309",
    "data-name": "Group 72309"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72308",
    "data-name": "Group 72308",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77462",
    "data-name": "Path 77462",
    className: "cls-213",
    d: "M352.665,207.589c-.205-.356-.538-.548-.744-.429s-.205.5,0,.859.538.548.744.429.205-.5,0-.859",
    transform: "translate(-302.166 -177.919)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77463",
    "data-name": "Path 77463",
    className: "cls-202",
    d: "M372.486,281.086l.177.1.479-.277-.177-.1Z",
    transform: "translate(-319.963 -241.214)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72304",
    "data-name": "Group 72304",
    className: "cls-184",
    transform: "translate(52.523 39.804)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72303",
    "data-name": "Group 72303"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72302",
    "data-name": "Group 72302",
    className: "cls-216"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77464",
    "data-name": "Path 77464",
    className: "cls-179",
    d: "M372.606,282.282h0l-.119.069.177.1.3-.171Z",
    transform: "translate(-372.486 -282.282)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72307",
    "data-name": "Group 72307",
    className: "cls-184",
    transform: "translate(52.889 39.596)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72306",
    "data-name": "Group 72306"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72305",
    "data-name": "Group 72305",
    className: "cls-217"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77465",
    "data-name": "Path 77465",
    className: "cls-179",
    d: "M375.085,280.875h.225l-.113-.065Z",
    transform: "translate(-375.085 -280.81)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72311",
    "data-name": "Group 72311",
    transform: "translate(50.092 38.201)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72310",
    "data-name": "Group 72310",
    className: "cls-218"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26610",
    "data-name": "Rectangle 26610",
    className: "cls-219",
    width: 5.069,
    height: 5.557,
    transform: "translate(-1.998 1.139) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72319",
    "data-name": "Group 72319"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72318",
    "data-name": "Group 72318",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77467",
    "data-name": "Path 77467",
    className: "cls-89",
    d: "M356.451,272.29h0a.587.587,0,0,0-.752.017l-.345.367a.587.587,0,0,0-.087.518l.5,2.436a.613.613,0,0,0,.264.386l.838.484c.123.071.232.038.264-.081l.5-1.858a.967.967,0,0,0-.087-.619l-.345-.765a1.973,1.973,0,0,0-.752-.885",
    transform: "translate(-305.155 -233.788)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72314",
    "data-name": "Group 72314",
    className: "cls-177",
    transform: "translate(50.915 39.421)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72313",
    "data-name": "Group 72313"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72312",
    "data-name": "Group 72312",
    className: "cls-197"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77468",
    "data-name": "Path 77468",
    className: "cls-179",
    d: "M361.99,280.716h0l-.17-.608a.885.885,0,0,0-.085-.2c-.149-.258-.39-.4-.539-.311-.111.064-.139.236-.084.426h0l.17.608a.886.886,0,0,0,.086.2c.149.258.39.4.539.311.111-.064.139-.236.084-.426",
    transform: "translate(-361.083 -279.57)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_77469",
    "data-name": "Path 77469",
    className: "cls-22",
    d: "M358.633,290.062l.173.842a.557.557,0,0,0,.24.351l.413.238Z",
    transform: "translate(-308.063 -249.161)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77470",
    "data-name": "Path 77470",
    className: "cls-22",
    d: "M358.274,281.136l-1.129-1.955-.651-.376a.8.8,0,0,0,.012.179l1.6,2.772Z",
    transform: "translate(-306.226 -239.492)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72317",
    "data-name": "Group 72317",
    className: "cls-31",
    transform: "translate(50.916 39.687)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72316",
    "data-name": "Group 72316"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72315",
    "data-name": "Group 72315",
    className: "cls-220"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77471",
    "data-name": "Path 77471",
    className: "cls-33",
    d: "M361.092,281.456l0,0a.645.645,0,0,0,.026.186l.17.608a.884.884,0,0,0,.086.2c.132.229.338.364.486.331Z",
    transform: "translate(-361.088 -281.454)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_77472",
    "data-name": "Path 77472",
    className: "cls-22",
    d: "M367.209,285.574l.09-.335a.612.612,0,0,0,.017-.19l-.616-.356Z",
    transform: "translate(-314.993 -244.549)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72321",
    "data-name": "Group 72321",
    transform: "translate(50.744 39.421)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72320",
    "data-name": "Group 72320",
    className: "cls-221"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26614",
    "data-name": "Rectangle 26614",
    className: "cls-222",
    width: 1.445,
    height: 1.495,
    transform: "translate(-0.533 0.286) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72323",
    "data-name": "Group 72323"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72322",
    "data-name": "Group 72322",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77474",
    "data-name": "Path 77474",
    className: "cls-213",
    d: "M360.519,280.607c-.149-.258-.39-.4-.539-.311s-.149.365,0,.622.39.4.539.311.149-.365,0-.622",
    transform: "translate(-309.124 -240.751)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77475",
    "data-name": "Path 77475",
    className: "cls-9",
    d: "M373.258,172.487v4.373l2.411-1.392v-4.373Z",
    transform: "translate(-320.626 -146.969)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77476",
    "data-name": "Path 77476",
    className: "cls-21",
    d: "M368.453,178.191v4.373l-.789-.455v-4.373Z",
    transform: "translate(-315.822 -152.674)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77477",
    "data-name": "Path 77477",
    className: "cls-7",
    d: "M368.453,169.713l2.411-1.392-.789-.455-2.411,1.392Z",
    transform: "translate(-315.822 -144.196)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77478",
    "data-name": "Path 77478",
    className: "cls-9",
    d: "M382,172.622v5.065l2.41-1.392V171.23Z",
    transform: "translate(-328.133 -147.085)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77479",
    "data-name": "Path 77479",
    className: "cls-21",
    d: "M377.192,178.326v5.065l-.789-.455v-5.065Z",
    transform: "translate(-323.328 -152.79)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77480",
    "data-name": "Path 77480",
    className: "cls-7",
    d: "M377.192,169.848l2.41-1.392-.789-.455-2.411,1.392Z",
    transform: "translate(-323.328 -144.312)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72325",
    "data-name": "Group 72325",
    transform: "translate(73.743 57.599)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72324",
    "data-name": "Group 72324",
    className: "cls-223",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26616",
    "data-name": "Rectangle 26616",
    className: "cls-224",
    width: 10.643,
    height: 6.094,
    transform: "translate(-2.228 9.491) rotate(-76.786)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72327",
    "data-name": "Group 72327"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72326",
    "data-name": "Group 72326",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77481",
    "data-name": "Path 77481",
    className: "cls-7",
    d: "M540.573,407.04c.059-.251-.264-.541-.721-.648s-.875.01-.933.261.264.541.721.648.875-.01.934-.261",
    transform: "translate(-462.922 -349.054)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72329",
    "data-name": "Group 72329",
    transform: "translate(76.771 57.565)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72328",
    "data-name": "Group 72328",
    className: "cls-225"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26619",
    "data-name": "Rectangle 26619",
    className: "cls-226",
    width: 0.9,
    height: 0.622,
    transform: "translate(0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72331",
    "data-name": "Group 72331",
    transform: "translate(76.407 54.613)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72330",
    "data-name": "Group 72330",
    className: "cls-227"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26620",
    "data-name": "Rectangle 26620",
    className: "cls-228",
    width: 3.729,
    height: 2.327,
    transform: "translate(-0.795 3.28) rotate(-76.8)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72333",
    "data-name": "Group 72333",
    transform: "translate(62.843 34.814)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72332",
    "data-name": "Group 72332",
    className: "cls-229"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26621",
    "data-name": "Rectangle 26621",
    className: "cls-230",
    width: 8.249,
    height: 8.279,
    transform: "translate(-3.022 2.744) rotate(-42.233)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72338",
    "data-name": "Group 72338"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72337",
    "data-name": "Group 72337",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72336",
    "data-name": "Group 72336",
    className: "cls-28",
    transform: "translate(62.708 35.236)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72335",
    "data-name": "Group 72335"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72334",
    "data-name": "Group 72334",
    className: "cls-231"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77485",
    "data-name": "Path 77485",
    className: "cls-232",
    d: "M444.716,249.891l4.227,4.652c-.22-.242-.081-.372.309-.292a2.382,2.382,0,0,1,1.1.583l-4.227-4.651Z",
    transform: "translate(-444.716 -249.891)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72340",
    "data-name": "Group 72340",
    transform: "translate(67.379 39.853)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72339",
    "data-name": "Group 72339",
    className: "cls-233"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26624",
    "data-name": "Rectangle 26624",
    className: "cls-234",
    width: 13.987,
    height: 14.026,
    transform: "translate(-5.191 4.668) rotate(-42.5)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72348",
    "data-name": "Group 72348"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72347",
    "data-name": "Group 72347",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72343",
    "data-name": "Group 72343",
    className: "cls-25",
    transform: "translate(68.075 39.854)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72342",
    "data-name": "Group 72342"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72341",
    "data-name": "Group 72341",
    className: "cls-235"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77487",
    "data-name": "Path 77487",
    className: "cls-49",
    d: "M483.405,282.718c-.115-.127-.364-.1-.624.045a4.432,4.432,0,0,1,1.539.961Z",
    transform: "translate(-482.781 -282.637)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_77488",
    "data-name": "Path 77488",
    className: "cls-89",
    d: "M525.109,407.137l3.861-13.026a1.634,1.634,0,0,0-.286-1.248l-2.079-3.2-6.06,11.932a1.939,1.939,0,0,0-.184.876v1.834a1.534,1.534,0,0,0,.694,1.2l3.229,1.864c.382.221.718.124.825-.238",
    transform: "translate(-446.987 -334.721)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72346",
    "data-name": "Group 72346",
    className: "cls-184",
    transform: "translate(78.256 54.946)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72345",
    "data-name": "Group 72345"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72344",
    "data-name": "Group 72344",
    className: "cls-236"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77489",
    "data-name": "Path 77489",
    className: "cls-179",
    d: "M556.287,393.786l.846.453c.482.258.882.073.95-.439l.161-1.21-1.9-2.922-1.361,2.68a3.336,3.336,0,0,0,1.3,1.438",
    transform: "translate(-554.983 -389.668)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72350",
    "data-name": "Group 72350",
    transform: "translate(77.904 53.554)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72349",
    "data-name": "Group 72349",
    className: "cls-237"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26628",
    "data-name": "Rectangle 26628",
    className: "cls-238",
    width: 15.286,
    height: 19.886,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, -8.296, 4.79)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72352",
    "data-name": "Group 72352",
    transform: "translate(81.518 57.867)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72351",
    "data-name": "Group 72351",
    className: "cls-239"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26629",
    "data-name": "Rectangle 26629",
    className: "cls-240",
    width: 1.669,
    height: 1.843,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, -0.659, 0.381)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72366",
    "data-name": "Group 72366"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72365",
    "data-name": "Group 72365",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77492",
    "data-name": "Path 77492",
    className: "cls-9",
    d: "M390.735,172.756v5.758l2.411-1.392v-5.758Z",
    transform: "translate(-335.639 -147.201)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77493",
    "data-name": "Path 77493",
    className: "cls-21",
    d: "M385.931,178.461v5.758l-.789-.455v-5.758Z",
    transform: "translate(-330.835 -152.906)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77494",
    "data-name": "Path 77494",
    className: "cls-7",
    d: "M385.931,169.983l2.411-1.392-.789-.455-2.411,1.392Z",
    transform: "translate(-330.835 -144.427)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77495",
    "data-name": "Path 77495",
    className: "cls-21",
    d: "M397.476,200.219v2.476l-3.936-2.273v-2.476Z",
    transform: "translate(-338.048 -170.034)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72355",
    "data-name": "Group 72355",
    className: "cls-177",
    transform: "translate(55.492 27.912)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72354",
    "data-name": "Group 72354"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72353",
    "data-name": "Group 72353",
    className: "cls-241"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77496",
    "data-name": "Path 77496",
    className: "cls-9",
    d: "M393.54,197.947v2.476l.4.228v-2.476Z",
    transform: "translate(-393.54 -197.947)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_77497",
    "data-name": "Path 77497",
    className: "cls-7",
    d: "M395.159,191.316l-1.62.935,2.3,1.329,1.619-.935Z",
    transform: "translate(-338.048 -164.339)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72358",
    "data-name": "Group 72358",
    className: "cls-242",
    transform: "translate(55.492 26.977)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72357",
    "data-name": "Group 72357"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72356",
    "data-name": "Group 72356",
    className: "cls-243"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77498",
    "data-name": "Path 77498",
    className: "cls-9",
    d: "M395.159,191.315l-1.62.935.4.228h.932l.627-.362.548.317c-.151.1-.165.217-.008.308l.63.364.8-.46Z",
    transform: "translate(-393.539 -191.315)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_77499",
    "data-name": "Path 77499",
    className: "cls-179",
    d: "M486.688,238.759l-2.411,1.392v3.87l2.411-1.392Z",
    transform: "translate(-415.991 -205.092)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77500",
    "data-name": "Path 77500",
    className: "cls-244",
    d: "M410.4,210.336l-10.888-6.286v.908a1.435,1.435,0,0,1-.229.842l-1.01,1.4,12.127,7Z",
    transform: "translate(-342.116 -175.278)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72361",
    "data-name": "Group 72361",
    className: "cls-184",
    transform: "translate(67.354 37.277)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72360",
    "data-name": "Group 72360"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72359",
    "data-name": "Group 72359",
    className: "cls-245"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77501",
    "data-name": "Path 77501",
    className: "cls-179",
    d: "M477.667,264.362l.371,1.328.561.324V264.9Z",
    transform: "translate(-477.667 -264.362)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_77502",
    "data-name": "Path 77502",
    className: "cls-202",
    d: "M409.475,194.18l-2.411,1.392,10.888,6.286,2.411-1.392Z",
    transform: "translate(-349.666 -166.799)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72364",
    "data-name": "Group 72364",
    className: "cls-177",
    transform: "translate(58.305 27.623)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72363",
    "data-name": "Group 72363"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72362",
    "data-name": "Group 72362",
    className: "cls-246"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77503",
    "data-name": "Path 77503",
    className: "cls-179",
    d: "M413.493,196.524l9.9,5.713a1.882,1.882,0,0,0,1.177.054c.415-.106.562-.3.327-.437L414.577,195.9Z",
    transform: "translate(-413.493 -195.898)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_77504",
    "data-name": "Path 77504",
    className: "cls-89",
    d: "M486.145,269.164l.439-3.293a2.6,2.6,0,0,0-.429-1.611l-9.091-14.686a3.294,3.294,0,0,0-1.1-1.118l-2.551-1.473c-.349-.2-.633-.038-.633.365v1.537a1.4,1.4,0,0,0,.633,1.1l2.047,1.182a2.927,2.927,0,0,1,1.057,1.169l5.8,11.092a3,3,0,0,1,.366,1.346v1.566a3.53,3.53,0,0,0,1.665,2.814l.846.453c.482.258.882.073.95-.439",
    transform: "translate(-406.119 -212.083)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77505",
    "data-name": "Path 77505",
    className: "cls-247",
    d: "M585.646,384.629c.077-.577-.293-.675-.764-.494l.688,1.057c0-.009,0-.016,0-.025l.072-.539",
    transform: "translate(-502.41 -329.899)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72368",
    "data-name": "Group 72368",
    transform: "translate(66.852 32.582)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72367",
    "data-name": "Group 72367",
    className: "cls-248"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26635",
    "data-name": "Rectangle 26635",
    className: "cls-249",
    width: 27.76,
    height: 30.427,
    transform: "translate(-10.892 6.373) rotate(-30.333)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72370",
    "data-name": "Group 72370",
    transform: "translate(56.001 25.164)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72369",
    "data-name": "Group 72369",
    className: "cls-250"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26636",
    "data-name": "Rectangle 26636",
    className: "cls-251",
    width: 2.043,
    height: 2.138,
    transform: "matrix(0.5, -0.866, 0.866, 0.5, -0.636, 1.051)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72375",
    "data-name": "Group 72375"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72374",
    "data-name": "Group 72374",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72373",
    "data-name": "Group 72373",
    className: "cls-28",
    transform: "translate(56.001 25.164)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72372",
    "data-name": "Group 72372"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72371",
    "data-name": "Group 72371",
    className: "cls-252"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77508",
    "data-name": "Path 77508",
    className: "cls-232",
    d: "M397.937,178.633l-.272-.157c-.117-.068-.308.042-.425.245s-.117.422,0,.49l.653.377a.83.83,0,0,1-.359-.7c.012-.264.193-.379.4-.257",
    transform: "translate(-397.153 -178.456)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72377",
    "data-name": "Group 72377",
    transform: "translate(56.758 25.386)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72376",
    "data-name": "Group 72376",
    className: "cls-253"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26639",
    "data-name": "Rectangle 26639",
    className: "cls-254",
    width: 12.622,
    height: 14.132,
    transform: "translate(-3.406 5.798) rotate(-60)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72379",
    "data-name": "Group 72379"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72378",
    "data-name": "Group 72378",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77510",
    "data-name": "Path 77510",
    className: "cls-9",
    d: "M477.415,223.7c.235-.406.615-.626.85-.491s.235.575,0,.981-.615.626-.85.491-.235-.575,0-.981",
    transform: "translate(-409.945 -191.703)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77511",
    "data-name": "Path 77511",
    className: "cls-255",
    d: "M488.983,573.151l-3.163-1.826v2.93l3.163,1.826Z",
    transform: "translate(-417.317 -490.764)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77512",
    "data-name": "Path 77512",
    className: "cls-9",
    d: "M769.73,461.992l-.393-.682,1.624-.937a1.092,1.092,0,0,0,.471-.816v-1.245h.787v1.245a1.858,1.858,0,0,1-.865,1.5Z",
    transform: "translate(-660.855 -393.688)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72381",
    "data-name": "Group 72381",
    transform: "translate(109.292 57.521)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72380",
    "data-name": "Group 72380",
    className: "cls-256"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26641",
    "data-name": "Rectangle 26641",
    className: "cls-257",
    width: 8.415,
    height: 6.704,
    transform: "matrix(0.498, -0.867, 0.867, 0.498, -3.388, 5.907)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72386",
    "data-name": "Group 72386"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72385",
    "data-name": "Group 72385",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72384",
    "data-name": "Group 72384",
    className: "cls-148",
    transform: "translate(110.97 58.069)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72383",
    "data-name": "Group 72383"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72382",
    "data-name": "Group 72382",
    className: "cls-258"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77514",
    "data-name": "Path 77514",
    className: "cls-259",
    d: "M787.94,411.821h-.958v.454h.171Z",
    transform: "translate(-786.982 -411.821)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_77515",
    "data-name": "Path 77515",
    className: "cls-9",
    d: "M781.439,410.3l-1.914,1.105a.969.969,0,0,0-.439.759v5.316c0,.28.2.393.439.253l1.914-1.105a.97.97,0,0,0,.439-.76v-5.316c0-.28-.2-.393-.439-.253",
    transform: "translate(-669.23 -352.398)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72391",
    "data-name": "Group 72391",
    transform: "translate(108.481 56.184)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72390",
    "data-name": "Group 72390",
    className: "cls-260"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72389",
    "data-name": "Group 72389",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72388",
    "data-name": "Group 72388"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72387",
    "data-name": "Group 72387",
    className: "cls-261"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_26644",
    "data-name": "Rectangle 26644",
    width: 2.978,
    height: 2.166,
    transform: "translate(-0.053 -0.039)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAgCAIAAADmJA0tAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAALKADAAQAAAABAAAAIAAAAAAaViiYAAADs0lEQVRYCb2VPW8TQRCG7yvOD4GCwihIiUT+ANDTkBSARAGCJki0lKFBUCAKBA0SEpASGgpERxMkXASlhd+BfV88s3O3e7c+22cnZDGb3fXsvO+8MzsOy7IM/sP4fXTMxzo+tzHkY7feIvH2J9x+fXfgwTcdXr21w1bn5nl4WkoAz6fpWtdFUURR1DxHkvvP95snp0DCgycqgPOiCIIwYF2WYRBEMf+i0AzgPR4nIoHyqr+GBTzYjMkkY+awNCzCKIQBI0mStSSGicdjdRKvHj22pafRp1mepgKf53mW54Cxpu5jpRBFMFhfHyRxxYPi0PpYhYSnP0hpxhBg5jwXEsyihDy9Mgwj5TEYoEQyGKwxqx7Pvn3CbLnXQegIwDUdwCuwwYZEAReChwELyYXURCBChCHIegteMcMkhXgQoy+JjvTnTgANvRZDeAgeMph44SqymMEBwmAZrclKE9qLhJd+qg9U0o8vkwsRX05EEAvH45ACtIPvSIqYFjGpS0xp9CIxJ/24Q3szSzWI87IIeZazB2ZkRkzzGMLxQPoHEDOV8NJPdnHBTcKlCegad2kqYvAfd/MZYCA0S1uwjmwHien0V5pnWVrVv2hgohcGph3NE8ChsTLlKg/XlC1lwZlPwtOfWDVohaQT5DU8otIaTel1MBhe3tzZu3v8Y3Tw4o0lIa+FhpabN2PY+CQ8eCKkylPkrlHJhVAxW4X3Ss+C7X94fXF7iy0k7GG9UFxJnr0uSkzrX8Vtyl3KSLJg9OcL8/5qT7Xn+i/R7+7dq3fdf7lrXrD7NmkKIFpJ9CZgkA22mav6xwAXHeoHAfo/+eiUdwj+yiMgX0f21x34SZr9HY8nMtJ0kvE7xGI8TplhgXUnAeDRvx8DTUHFwwYj6bhy88aXt+9pPWDpkK5j3qHZEr3LnzBvDJv+xtm8Jc+Yl0EXbxpJu7h2e5f4iZhB0CJDCiGZodK2d3dJ/+c/Iy1Ad7p41ZUOvfXw5VNygf6pkMjGbBbpv7AAZ/FBCY9I1ScubF06vzH8dfgTbKqP+7PSjwDLR9/iY6Rt0XDN6vqDO6Pvhy3z9qbP82vf6NgBTngtCrwOa6g9zm6bC03/yvo3XZlMVPmwVBwJTKdh9PlNn7f8LrfRbFsCctmlQ10RtO32yz6/hWRIBAMzna29T4Kgjw9Hw+3NU43ewumvZ02CneHkk8C8b++znnsvDAWstSZcv2rVRG9vqxtqNsx9VxZnTQJ4eHjt6qxJuPAbap41iQa0W/4DBFlFZHAjB+QAAAAASUVORK5CYII="
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72393",
    "data-name": "Group 72393"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72392",
    "data-name": "Group 72392",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_26646",
    "data-name": "Rectangle 26646",
    width: 2.961,
    height: 2.256,
    transform: "translate(108.434 56.127)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAQCAYAAAD52jQlAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAFaADAAQAAAABAAAAEAAAAADjM79EAAABAklEQVQ4EbWTzQ3CMAyFm/JzgEMPcAABqssIIMoWwHbMwSCsgLpJeI7iKKRt0h6w9GQ7sT85TaO01tkYux/P1FX/+rwbWVdDoX0wC1rAlxAB/syFHvMRoEJfBdXQ1fosOmkEhv5sA5npAl9OeTe0BKxAPUE+UOIVs36gCdgc9QQJgL3Ee8TOHDQBPKCDIIH4wJmj2UDdqhMX99kaGwS1YLjlAoPorkY3abC5RE5W/lQlYHxBUQuhE1TLVGRjAwWsipK8zRzFjc238P7/drF5PQbILDMpg/F9HsgJkuPyUc0vgrVR5h+fpzRHB2w3ihIUR19UUNtK+25/0Ntv0RILf4F+AQOEOwFRH943AAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77517",
    "data-name": "Path 77517",
    className: "cls-9",
    d: "M784.585,411.821c-.217,0-.393.1-.393.227s.176.227.393.227.394-.1.394-.227-.176-.227-.394-.227",
    transform: "translate(-673.615 -353.752)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72395",
    "data-name": "Group 72395",
    transform: "translate(110.576 57.015)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72394",
    "data-name": "Group 72394",
    className: "cls-262"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26648",
    "data-name": "Rectangle 26648",
    className: "cls-263",
    width: 0.713,
    height: 1.509
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72397",
    "data-name": "Group 72397"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72396",
    "data-name": "Group 72396",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77519",
    "data-name": "Path 77519",
    className: "cls-9",
    d: "M522.721,353.824l-2.46-12.364-18.019-10.4-23.579,13.613v12.2l20.761,11.987,23.3-13.451Zm-2.41-1.536-1.337-.772a2.739,2.739,0,0,1-1.021-1.17l-.38-.788a2.741,2.741,0,0,0-1.021-1.17l-4.2-2.425v-7.51l5.656,3.265a2.613,2.613,0,0,1,1.128,1.659l1.681,8.446c.086.432-.164.66-.506.463",
    transform: "translate(-411.168 -284.376)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72399",
    "data-name": "Group 72399",
    transform: "translate(64.828 81.78)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72398",
    "data-name": "Group 72398",
    className: "cls-264"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26650",
    "data-name": "Rectangle 26650",
    className: "cls-265",
    width: 7.152,
    height: 7.34,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, -2.408, 1.39)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72401",
    "data-name": "Group 72401"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72400",
    "data-name": "Group 72400",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77521",
    "data-name": "Path 77521",
    className: "cls-8",
    d: "M455.039,563.684l3.37,1.946v.762c-2.483-.114-4.207,1.787-4.207,5.149l-.91-.526v-5.764Z",
    transform: "translate(-389.375 -484.201)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77522",
    "data-name": "Path 77522",
    className: "cls-7",
    d: "M465.684,559.149l1.289-.744v1.489Z",
    transform: "translate(-400.019 -479.666)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77523",
    "data-name": "Path 77523",
    className: "cls-9",
    d: "M489.585,578.245l.715-.349-.715-.413Z",
    transform: "translate(-420.55 -496.054)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72403",
    "data-name": "Group 72403",
    transform: "translate(66.161 81.341)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72402",
    "data-name": "Group 72402",
    className: "cls-266"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26652",
    "data-name": "Rectangle 26652",
    className: "cls-267",
    width: 24.399,
    height: 24.89,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, -8.677, 4.678)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72405",
    "data-name": "Group 72405",
    transform: "translate(68.699 81.341)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72404",
    "data-name": "Group 72404",
    className: "cls-268"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26653",
    "data-name": "Rectangle 26653",
    className: "cls-269",
    width: 20.833,
    height: 21.825,
    transform: "translate(-7.348 4.242) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72407",
    "data-name": "Group 72407"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72406",
    "data-name": "Group 72406",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77526",
    "data-name": "Path 77526",
    className: "cls-106",
    d: "M479.26,600.245c-2.3-3.984-6.029-6.137-8.329-4.809s-2.3,5.634,0,9.618,6.029,6.137,8.329,4.809,2.3-5.634,0-9.618",
    transform: "translate(-403.045 -511.139)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77527",
    "data-name": "Path 77527",
    className: "cls-22",
    d: "M491.108,618.452c-1.441-2.5-3.777-3.844-5.218-3.012s-1.441,3.529,0,6.025,3.777,3.844,5.218,3.012,1.441-3.529,0-6.025",
    transform: "translate(-416.448 -528.448)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72409",
    "data-name": "Group 72409",
    transform: "translate(68.821 87.34)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72408",
    "data-name": "Group 72408",
    className: "cls-270"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26655",
    "data-name": "Rectangle 26655",
    className: "cls-271",
    width: 10.566,
    height: 11.212,
    transform: "translate(-4.149 2.213) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72414",
    "data-name": "Group 72414"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72413",
    "data-name": "Group 72413",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72412",
    "data-name": "Group 72412",
    className: "cls-109",
    transform: "translate(68.822 87.347)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72411",
    "data-name": "Group 72411"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72410",
    "data-name": "Group 72410",
    className: "cls-272"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77529",
    "data-name": "Path 77529",
    className: "cls-27",
    d: "M490.109,624.4c-1.112-1.926-1.243-3.988-.394-4.948h0a1.619,1.619,0,0,0-.7.209c-.849.49-1.124,1.72-.83,3.138a6.305,6.305,0,0,0,1.69,1.641,6.59,6.59,0,0,0,.331.656,4.327,4.327,0,0,0,3.1,2.408,1.849,1.849,0,0,0,.46-.057,1.6,1.6,0,0,0,.207-.2c-1.231.09-2.819-1.031-3.866-2.845",
    transform: "translate(-488.075 -619.453)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_77530",
    "data-name": "Path 77530",
    className: "cls-111",
    d: "M496.351,619.421c-.85.96-.719,3.023.393,4.95,1.049,1.817,2.64,2.938,3.871,2.845.85-.96.719-3.023-.393-4.95-1.049-1.817-2.64-2.938-3.871-2.845",
    transform: "translate(-425.888 -532.074)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72416",
    "data-name": "Group 72416",
    transform: "translate(69.651 87.69)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72415",
    "data-name": "Group 72415",
    className: "cls-273"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26658",
    "data-name": "Rectangle 26658",
    className: "cls-274",
    width: 8.764,
    height: 9.275,
    transform: "translate(-3.395 1.825) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72421",
    "data-name": "Group 72421"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72420",
    "data-name": "Group 72420",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72419",
    "data-name": "Group 72419",
    className: "cls-109",
    transform: "translate(70.854 87.69)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72418",
    "data-name": "Group 72418"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72417",
    "data-name": "Group 72417",
    className: "cls-275"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77532",
    "data-name": "Path 77532",
    className: "cls-27",
    d: "M505.971,624.387a6.418,6.418,0,0,0-2.452-2.5l-1.028.593c.937-.541,2.456.336,3.393,1.959s.937,3.377,0,3.918l1.028-.594a6.418,6.418,0,0,0-.941-3.375",
    transform: "translate(-502.491 -621.885)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_77533",
    "data-name": "Path 77533",
    className: "cls-22",
    d: "M498.055,629.127c-.937-1.623-2.456-2.5-3.393-1.959s-.937,2.3,0,3.918,2.456,2.5,3.393,1.959.937-2.3,0-3.918",
    transform: "translate(-424.307 -538.596)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72423",
    "data-name": "Group 72423",
    transform: "translate(71.723 89.085)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72422",
    "data-name": "Group 72422",
    className: "cls-276"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26661",
    "data-name": "Rectangle 26661",
    className: "cls-277",
    width: 0.803,
    height: 1.006,
    transform: "translate(-0.155 0.027) rotate(-10)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72425",
    "data-name": "Group 72425"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72424",
    "data-name": "Group 72424",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77535",
    "data-name": "Path 77535",
    className: "cls-117",
    d: "M510.5,631.905a.359.359,0,0,0-.069-.031.363.363,0,0,0-.008.076.725.725,0,0,0,.328.568.381.381,0,0,0,.07.031.375.375,0,0,0,.008-.076.725.725,0,0,0-.328-.568",
    transform: "translate(-438.453 -542.776)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72427",
    "data-name": "Group 72427",
    transform: "translate(71.723 93.09)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72426",
    "data-name": "Group 72426",
    className: "cls-278"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26663",
    "data-name": "Rectangle 26663",
    className: "cls-279",
    width: 0.803,
    height: 1.006,
    transform: "translate(-0.155 0.027) rotate(-10)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72429",
    "data-name": "Group 72429"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72428",
    "data-name": "Group 72428",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77537",
    "data-name": "Path 77537",
    className: "cls-117",
    d: "M510.5,660.31a.365.365,0,0,0-.07-.031.374.374,0,0,0-.008.076.725.725,0,0,0,.328.568.047.047,0,1,0,.077-.045.724.724,0,0,0-.328-.568",
    transform: "translate(-438.453 -567.175)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72431",
    "data-name": "Group 72431",
    transform: "translate(73.457 92.089)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72430",
    "data-name": "Group 72430",
    className: "cls-280"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26665",
    "data-name": "Rectangle 26665",
    className: "cls-281",
    width: 0.803,
    height: 1.006,
    transform: "translate(-0.155 0.027) rotate(-10)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72433",
    "data-name": "Group 72433"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72432",
    "data-name": "Group 72432",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77539",
    "data-name": "Path 77539",
    className: "cls-117",
    d: "M522.8,653.209a.356.356,0,0,0-.069-.031.348.348,0,0,0-.008.076.724.724,0,0,0,.328.568.374.374,0,0,0,.069.031.368.368,0,0,0,.008-.076.724.724,0,0,0-.328-.568",
    transform: "translate(-449.019 -561.076)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72435",
    "data-name": "Group 72435",
    transform: "translate(69.989 90.086)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72434",
    "data-name": "Group 72434",
    className: "cls-282"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26667",
    "data-name": "Rectangle 26667",
    className: "cls-283",
    width: 0.803,
    height: 1.006,
    transform: "translate(-0.155 0.027) rotate(-10)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72437",
    "data-name": "Group 72437"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72436",
    "data-name": "Group 72436",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77541",
    "data-name": "Path 77541",
    className: "cls-117",
    d: "M498.2,639.006a.37.37,0,0,0-.07-.031.374.374,0,0,0-.008.076.724.724,0,0,0,.328.568.365.365,0,0,0,.069.031.374.374,0,0,0,.008-.076.724.724,0,0,0-.328-.568",
    transform: "translate(-427.888 -548.875)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72439",
    "data-name": "Group 72439",
    transform: "translate(72.949 90.379)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72438",
    "data-name": "Group 72438",
    className: "cls-284"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26669",
    "data-name": "Rectangle 26669",
    className: "cls-285",
    width: 0.865,
    height: 1.01,
    transform: "translate(-0.186 0.027) rotate(-10)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72441",
    "data-name": "Group 72441"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72440",
    "data-name": "Group 72440",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77543",
    "data-name": "Path 77543",
    className: "cls-117",
    d: "M519.135,641.058a.677.677,0,1,0,.3.276.6.6,0,0,0-.3-.276",
    transform: "translate(-445.928 -550.665)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72443",
    "data-name": "Group 72443",
    transform: "translate(70.497 91.796)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72442",
    "data-name": "Group 72442",
    className: "cls-286"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26671",
    "data-name": "Rectangle 26671",
    className: "cls-287",
    width: 0.865,
    height: 1.01,
    transform: "translate(-0.186 0.027) rotate(-10)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72445",
    "data-name": "Group 72445"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72444",
    "data-name": "Group 72444",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77545",
    "data-name": "Path 77545",
    className: "cls-117",
    d: "M501.74,651.1a.677.677,0,1,0,.3.275.6.6,0,0,0-.3-.275",
    transform: "translate(-430.985 -559.292)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72447",
    "data-name": "Group 72447",
    transform: "translate(72.949 93.212)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72446",
    "data-name": "Group 72446",
    className: "cls-288"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26673",
    "data-name": "Rectangle 26673",
    className: "cls-289",
    width: 0.865,
    height: 1.01,
    transform: "translate(-0.186 0.027) rotate(-10)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72449",
    "data-name": "Group 72449"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72448",
    "data-name": "Group 72448",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77547",
    "data-name": "Path 77547",
    className: "cls-117",
    d: "M519.135,661.143a.676.676,0,1,0,.3.275.6.6,0,0,0-.3-.275",
    transform: "translate(-445.928 -567.918)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72451",
    "data-name": "Group 72451",
    transform: "translate(70.497 88.963)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72450",
    "data-name": "Group 72450",
    className: "cls-290"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26675",
    "data-name": "Rectangle 26675",
    className: "cls-291",
    width: 0.865,
    height: 1.01,
    transform: "matrix(0.985, -0.174, 0.174, 0.985, -0.186, 0.027)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72453",
    "data-name": "Group 72453"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72452",
    "data-name": "Group 72452",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77549",
    "data-name": "Path 77549",
    className: "cls-117",
    d: "M501.74,631.015a.677.677,0,1,0,.3.275.6.6,0,0,0-.3-.275",
    transform: "translate(-430.985 -542.038)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72455",
    "data-name": "Group 72455",
    transform: "translate(71.138 90.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72454",
    "data-name": "Group 72454",
    className: "cls-292"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26677",
    "data-name": "Rectangle 26677",
    className: "cls-293",
    width: 2.003,
    height: 2.501,
    transform: "translate(-0.089 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72457",
    "data-name": "Group 72457",
    transform: "translate(66.954 75.381)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72456",
    "data-name": "Group 72456",
    className: "cls-294"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26678",
    "data-name": "Rectangle 26678",
    className: "cls-295",
    width: 25.658,
    height: 28.836,
    transform: "translate(-9.697 4.965) rotate(-27.112)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72483",
    "data-name": "Group 72483"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72482",
    "data-name": "Group 72482",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77552",
    "data-name": "Path 77552",
    className: "cls-10",
    d: "M577.005,693.662v1.162l5.347,3.087v-1.162Z",
    transform: "translate(-495.644 -595.851)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72460",
    "data-name": "Group 72460",
    className: "cls-31",
    transform: "translate(81.361 97.811)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72459",
    "data-name": "Group 72459"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72458",
    "data-name": "Group 72458",
    className: "cls-296"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77553",
    "data-name": "Path 77553",
    className: "cls-297",
    d: "M577.005,693.662v1.162l.541.312v-1.162Z",
    transform: "translate(-577.005 -693.662)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_77554",
    "data-name": "Path 77554",
    className: "cls-12",
    d: "M577.005,684.643l2.564-1.481,5.347,3.087-2.564,1.481Z",
    transform: "translate(-495.644 -586.832)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72463",
    "data-name": "Group 72463",
    className: "cls-148",
    transform: "translate(81.361 96.33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72462",
    "data-name": "Group 72462"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72461",
    "data-name": "Group 72461",
    className: "cls-298"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77555",
    "data-name": "Path 77555",
    className: "cls-297",
    d: "M577.546,684.955h.552l4.53,2.615,2.288-1.321-5.347-3.087-2.565,1.481Z",
    transform: "translate(-577.005 -683.162)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_77556",
    "data-name": "Path 77556",
    className: "cls-10",
    d: "M577.005,668.04V669.2l5.347,3.087v-1.162Z",
    transform: "translate(-495.644 -573.842)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72466",
    "data-name": "Group 72466",
    className: "cls-31",
    transform: "translate(81.361 94.198)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72465",
    "data-name": "Group 72465"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72464",
    "data-name": "Group 72464",
    className: "cls-296"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77557",
    "data-name": "Path 77557",
    className: "cls-297",
    d: "M577.005,668.04V669.2l.541.312v-1.162Z",
    transform: "translate(-577.005 -668.04)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_77558",
    "data-name": "Path 77558",
    className: "cls-12",
    d: "M577.005,659.02l2.564-1.481,5.347,3.087-2.564,1.481Z",
    transform: "translate(-495.644 -564.822)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72469",
    "data-name": "Group 72469",
    className: "cls-148",
    transform: "translate(81.361 92.717)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72468",
    "data-name": "Group 72468"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72467",
    "data-name": "Group 72467",
    className: "cls-298"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77559",
    "data-name": "Path 77559",
    className: "cls-297",
    d: "M577.546,659.332h.552l4.53,2.615,2.288-1.321-5.347-3.087-2.565,1.481Z",
    transform: "translate(-577.005 -657.539)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_77560",
    "data-name": "Path 77560",
    className: "cls-10",
    d: "M577.005,642.417v1.162l5.347,3.087V645.5Z",
    transform: "translate(-495.644 -551.832)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72472",
    "data-name": "Group 72472",
    className: "cls-31",
    transform: "translate(81.361 90.585)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72471",
    "data-name": "Group 72471"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72470",
    "data-name": "Group 72470",
    className: "cls-296"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77561",
    "data-name": "Path 77561",
    className: "cls-297",
    d: "M577.005,642.417v1.162l.541.312v-1.162Z",
    transform: "translate(-577.005 -642.417)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_77562",
    "data-name": "Path 77562",
    className: "cls-12",
    d: "M577.005,633.4l2.564-1.481L584.917,635l-2.564,1.481Z",
    transform: "translate(-495.644 -542.813)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72475",
    "data-name": "Group 72475",
    className: "cls-148",
    transform: "translate(81.361 89.417)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72474",
    "data-name": "Group 72474"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72473",
    "data-name": "Group 72473",
    className: "cls-299"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77563",
    "data-name": "Path 77563",
    className: "cls-297",
    d: "M584.376,637.219l-5.347-3.087-2.024,1.168.541.312h1.379l4.117,2.377Z",
    transform: "translate(-577.005 -634.131)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_77564",
    "data-name": "Path 77564",
    className: "cls-300",
    d: "M645.919,487.69l-10.611.533v1.865a.663.663,0,0,0,.391.545l3.51,2.027a2.087,2.087,0,0,0,1.887,0l4.433-2.559a.663.663,0,0,0,.391-.547Z",
    transform: "translate(-545.725 -418.922)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77565",
    "data-name": "Path 77565",
    className: "cls-301",
    d: "M645.529,470.109l-3.51-2.026a2.086,2.086,0,0,0-1.887,0l-4.433,2.559a.575.575,0,0,0,0,1.09l3.51,2.026a2.085,2.085,0,0,0,1.887,0l4.433-2.559a.575.575,0,0,0,0-1.089",
    transform: "translate(-545.726 -401.886)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77566",
    "data-name": "Path 77566",
    className: "cls-300",
    d: "M568.776,532.229l-10.611.533v1.865a.663.663,0,0,0,.391.545l3.51,2.027a2.088,2.088,0,0,0,1.887,0l4.433-2.559a.664.664,0,0,0,.391-.547Z",
    transform: "translate(-479.46 -457.181)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77567",
    "data-name": "Path 77567",
    className: "cls-301",
    d: "M568.385,514.647l-3.51-2.026a2.086,2.086,0,0,0-1.887,0l-4.433,2.559a.575.575,0,0,0,0,1.09l3.51,2.026a2.085,2.085,0,0,0,1.887,0l4.433-2.559a.575.575,0,0,0,0-1.089",
    transform: "translate(-479.46 -440.144)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77568",
    "data-name": "Path 77568",
    className: "cls-300",
    d: "M560.566,462c0-.6-.423-.846-.943-.545l-4.433,2.559a2.086,2.086,0,0,0-.944,1.634v5.119c0,.6.422.846.943.545l4.433-2.559a2.086,2.086,0,0,0,.943-1.634Z",
    transform: "translate(-476.094 -396.279)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72478",
    "data-name": "Group 72478",
    className: "cls-31",
    transform: "translate(72.275 64.86)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72477",
    "data-name": "Group 72477"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72476",
    "data-name": "Group 72476",
    className: "cls-302"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77569",
    "data-name": "Path 77569",
    className: "cls-303",
    d: "M516.593,469.186l-2.6-1.5a3.147,3.147,0,0,1-1.424-2.466V461c0-.908.637-1.276,1.424-.822l2.6,1.5Z",
    transform: "translate(-512.568 -459.98)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72481",
    "data-name": "Group 72481",
    className: "cls-304",
    transform: "translate(72.275 64.86)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72480",
    "data-name": "Group 72480"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72479",
    "data-name": "Group 72479",
    className: "cls-305"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77570",
    "data-name": "Path 77570",
    className: "cls-297",
    d: "M512.567,461v4.222a2.821,2.821,0,0,0,.334,1.249c0-.022,0-.044,0-.066V462.18c0-.908.637-1.276,1.424-.822l2.27,1.311v-.993l-2.6-1.5c-.786-.454-1.424-.086-1.424.822",
    transform: "translate(-512.567 -459.98)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72485",
    "data-name": "Group 72485",
    transform: "translate(71.944 65.076)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72484",
    "data-name": "Group 72484",
    className: "cls-306"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26688",
    "data-name": "Rectangle 26688",
    className: "cls-307",
    width: 7.809,
    height: 10.002,
    transform: "translate(-3.76 1.957) rotate(-27.499)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72496",
    "data-name": "Group 72496"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72495",
    "data-name": "Group 72495",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72488",
    "data-name": "Group 72488",
    className: "cls-28",
    transform: "translate(71.944 69.86)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72487",
    "data-name": "Group 72487"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72486",
    "data-name": "Group 72486",
    className: "cls-308"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77572",
    "data-name": "Path 77572",
    className: "cls-309",
    d: "M510.885,496.926a2.821,2.821,0,0,1-.334-1.249v-.239h-.331v.43a2.4,2.4,0,0,0,.664,1.058Z",
    transform: "translate(-510.221 -495.438)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72491",
    "data-name": "Group 72491",
    className: "cls-31",
    transform: "translate(77.936 67.501)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72490",
    "data-name": "Group 72490"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72489",
    "data-name": "Group 72489",
    className: "cls-310"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77573",
    "data-name": "Path 77573",
    className: "cls-303",
    d: "M560.671,492.542l-1.336-.772a2.74,2.74,0,0,1-1.021-1.17l-.38-.788a2.741,2.741,0,0,0-1.021-1.17l-4.2-2.425v-7.51l5.656,3.265a2.613,2.613,0,0,1,1.128,1.659l1.681,8.446c.086.432-.164.66-.506.463",
    transform: "translate(-552.712 -478.708)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72494",
    "data-name": "Group 72494",
    className: "cls-304",
    transform: "translate(77.936 67.501)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72493",
    "data-name": "Group 72493"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72492",
    "data-name": "Group 72492",
    className: "cls-311"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77574",
    "data-name": "Path 77574",
    className: "cls-297",
    d: "M553.043,479.891l5.656,3.265a2.464,2.464,0,0,1,.906,1.024l-.109-.548a2.614,2.614,0,0,0-1.128-1.659l-5.656-3.266v7.51l.331.191Z",
    transform: "translate(-552.712 -478.707)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_77575",
    "data-name": "Path 77575",
    className: "cls-309",
    d: "M550.366,480.062v7.51l.331-.191v-7.128Z",
    transform: "translate(-472.761 -412.37)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72498",
    "data-name": "Group 72498",
    transform: "translate(77.605 75.011)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72497",
    "data-name": "Group 72497",
    className: "cls-312"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26693",
    "data-name": "Rectangle 26693",
    className: "cls-313",
    width: 10.648,
    height: 9.988,
    transform: "translate(-2.88 1.663) rotate(-29.999)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72512",
    "data-name": "Group 72512"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72511",
    "data-name": "Group 72511",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72501",
    "data-name": "Group 72501",
    className: "cls-148",
    transform: "translate(77.605 75.011)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72500",
    "data-name": "Group 72500"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72499",
    "data-name": "Group 72499",
    className: "cls-314"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77577",
    "data-name": "Path 77577",
    className: "cls-315",
    d: "M550.7,531.967l-.331.191h.662Z",
    transform: "translate(-550.366 -531.967)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_77578",
    "data-name": "Path 77578",
    className: "cls-316",
    d: "M496.68,438.006l-18.019-10.4V442.69l7.559,4.364a14.14,14.14,0,0,1,6.027,8.608l6.562,3.789V448.707Zm-9.544,3.559-2.6-1.5a3.146,3.146,0,0,1-1.424-2.466v-4.222c0-.908.637-1.276,1.424-.822l2.6,1.5Zm9.6,7.268-1.337-.772a2.741,2.741,0,0,1-1.021-1.17l-.38-.788a2.74,2.74,0,0,0-1.021-1.17l-4.2-2.425V435l5.656,3.265a2.614,2.614,0,0,1,1.128,1.659l1.681,8.446c.086.432-.164.66-.506.463",
    transform: "translate(-411.167 -367.308)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72504",
    "data-name": "Group 72504",
    className: "cls-317",
    transform: "translate(84.508 71.375)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72503",
    "data-name": "Group 72503"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72502",
    "data-name": "Group 72502",
    className: "cls-318"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77579",
    "data-name": "Path 77579",
    className: "cls-319",
    d: "M602.455,516.2l-.414-2.081-2.2-7.876-.52-.068,1.637,5.856-.123-.072c-.032-.019-.084.006-.084.135v3.1l.132.664a.452.452,0,0,1-.132.5v.623a14.772,14.772,0,0,0,.438,2.75l.442,1.94v1.29q-.09-.281-.195-.651l-1.6-5.71-.52-.068,1.651,5.908c.479,1.713.687,1.883.849,1.883a.453.453,0,0,0,.06-.005c.054-.008.232-.053.232-.325v-.2l.343,1.505Z",
    transform: "translate(-599.32 -506.179)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_77580",
    "data-name": "Path 77580",
    className: "cls-320",
    d: "M717.587,435.612l4.2,2.425a2.742,2.742,0,0,1,1.021,1.17l.38.788a2.74,2.74,0,0,0,1.021,1.17l1.337.772c.236.136.428.07.5-.127a.533.533,0,0,1-.165-.064l-1.337-.772a2.74,2.74,0,0,1-1.021-1.17l-.38-.788a2.741,2.741,0,0,0-1.021-1.17l-4.2-2.425Z",
    transform: "translate(-616.403 -374.024)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72507",
    "data-name": "Group 72507",
    className: "cls-31",
    transform: "translate(101.184 54.078)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72506",
    "data-name": "Group 72506"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72505",
    "data-name": "Group 72505",
    className: "cls-310"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77581",
    "data-name": "Path 77581",
    className: "cls-321",
    d: "M725.546,397.351l-1.336-.772a2.74,2.74,0,0,1-1.021-1.17l-.38-.788a2.742,2.742,0,0,0-1.021-1.169l-4.2-2.425v-7.51l5.656,3.265a2.614,2.614,0,0,1,1.128,1.659l1.681,8.446c.086.432-.164.661-.506.463",
    transform: "translate(-717.587 -383.517)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_77582",
    "data-name": "Path 77582",
    className: "cls-322",
    d: "M496.681,425.452l-18.019-10.4.546-2.061,15.143,8.743Z",
    transform: "translate(-411.167 -354.754)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77583",
    "data-name": "Path 77583",
    className: "cls-316",
    d: "M487.148,554.438a11.452,11.452,0,0,0-5.181-8.974l-7.139-4.122v-4.534l7.559,4.364a13.942,13.942,0,0,1,6.308,10.925v8.3l-1.547-.893Z",
    transform: "translate(-407.874 -461.115)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77584",
    "data-name": "Path 77584",
    className: "cls-12",
    d: "M768.873,557.394l-2.564-1.481v2.961Z",
    transform: "translate(-658.254 -477.526)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72510",
    "data-name": "Group 72510",
    className: "cls-148",
    transform: "translate(108.054 78.387)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72509",
    "data-name": "Group 72509"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72508",
    "data-name": "Group 72508",
    className: "cls-323"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77585",
    "data-name": "Path 77585",
    className: "cls-297",
    d: "M768.873,557.394l-2.564-1.481v2.961Z",
    transform: "translate(-766.308 -555.913)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_77586",
    "data-name": "Path 77586",
    className: "cls-324",
    d: "M589.928,394.737l2.33,3.721,23.91-13.8-3.421-3.091Z",
    transform: "translate(-506.744 -327.76)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77587",
    "data-name": "Path 77587",
    className: "cls-316",
    d: "M615.862,664.85l-.934-.54V672.7l.934.54Z",
    transform: "translate(-528.219 -570.638)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72514",
    "data-name": "Group 72514",
    transform: "translate(86.709 90.791)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72513",
    "data-name": "Group 72513",
    className: "cls-325"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26699",
    "data-name": "Rectangle 26699",
    className: "cls-326",
    width: 7.373,
    height: 6.235,
    transform: "matrix(0.866, -0.501, 0.501, 0.866, -1.483, 0.857)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72516",
    "data-name": "Group 72516",
    transform: "translate(105.628 79.868)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72515",
    "data-name": "Group 72515",
    className: "cls-327"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26700",
    "data-name": "Rectangle 26700",
    className: "cls-328",
    width: 7.019,
    height: 6.234,
    transform: "translate(-1.636 0.946) rotate(-30.039)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72521",
    "data-name": "Group 72521"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72520",
    "data-name": "Group 72520",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77590",
    "data-name": "Path 77590",
    className: "cls-329",
    d: "M615.617,661.488l-.69.4.934.539h1.225l.077-.044Z",
    transform: "translate(-528.218 -568.214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77591",
    "data-name": "Path 77591",
    className: "cls-329",
    d: "M482.534,332.732l22.818-13.174L520.5,328.3l-22.818,13.174Z",
    transform: "translate(-414.493 -274.498)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72519",
    "data-name": "Group 72519",
    className: "cls-148",
    transform: "translate(87.318 55.39)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72518",
    "data-name": "Group 72518"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72517",
    "data-name": "Group 72517",
    className: "cls-330"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77592",
    "data-name": "Path 77592",
    className: "cls-319",
    d: "M626.266,393.03l-.373-.215-6.645,4.636h.694a1.93,1.93,0,0,0,.946-.226l5.378-3.105a.575.575,0,0,0,0-1.09",
    transform: "translate(-619.248 -392.815)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_77593",
    "data-name": "Path 77593",
    className: "cls-322",
    d: "M559.965,376.683l5.327,3.076h.593l-5.327-3.076Z",
    transform: "translate(-481.006 -323.568)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77594",
    "data-name": "Path 77594",
    className: "cls-331",
    d: "M556.354,376.683l-.593.684,5.327,3.076.593-.684Z",
    transform: "translate(-477.396 -323.568)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77595",
    "data-name": "Path 77595",
    className: "cls-332",
    d: "M555.762,377.367v-.684h.593Z",
    transform: "translate(-477.396 -323.568)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77596",
    "data-name": "Path 77596",
    className: "cls-322",
    d: "M585.679,361.837l5.327,3.076h.593l-5.327-3.076Z",
    transform: "translate(-503.094 -310.816)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77597",
    "data-name": "Path 77597",
    className: "cls-331",
    d: "M582.069,361.837l-.593.684L586.8,365.6l.593-.684Z",
    transform: "translate(-499.484 -310.816)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77598",
    "data-name": "Path 77598",
    className: "cls-332",
    d: "M581.476,362.521v-.684h.593Z",
    transform: "translate(-499.484 -310.815)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77599",
    "data-name": "Path 77599",
    className: "cls-322",
    d: "M508.536,406.375l11.971,6.912h.593l-11.971-6.912Z",
    transform: "translate(-436.829 -349.074)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77600",
    "data-name": "Path 77600",
    className: "cls-322",
    d: "M589.231,456.076h1.185l-.593-.684Z",
    transform: "translate(-506.146 -391.178)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77601",
    "data-name": "Path 77601",
    className: "cls-316",
    d: "M594.026,455.391v.684l-.593-.684Z",
    transform: "translate(-509.756 -391.178)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77602",
    "data-name": "Path 77602",
    className: "cls-331",
    d: "M504.926,406.375l-.593.684,11.971,6.912.593-.684Z",
    transform: "translate(-433.219 -349.074)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77603",
    "data-name": "Path 77603",
    className: "cls-332",
    d: "M504.333,407.06v-.684h.592Z",
    transform: "translate(-433.219 -349.074)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77604",
    "data-name": "Path 77604",
    className: "cls-322",
    d: "M534.25,391.529l11.971,6.912h.593l-11.971-6.912Z",
    transform: "translate(-458.918 -336.321)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77605",
    "data-name": "Path 77605",
    className: "cls-322",
    d: "M614.946,441.23h1.185l-.593-.684Z",
    transform: "translate(-528.234 -378.426)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77606",
    "data-name": "Path 77606",
    className: "cls-316",
    d: "M619.741,440.545v.684l-.593-.684Z",
    transform: "translate(-531.844 -378.426)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77607",
    "data-name": "Path 77607",
    className: "cls-331",
    d: "M530.64,391.529l-.593.684,11.971,6.912.593-.684Z",
    transform: "translate(-455.307 -336.321)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77608",
    "data-name": "Path 77608",
    className: "cls-332",
    d: "M530.047,392.214v-.684h.593Z",
    transform: "translate(-455.307 -336.321)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77609",
    "data-name": "Path 77609",
    className: "cls-322",
    d: "M611.394,346.991l11.971,6.912h.593l-11.971-6.912Z",
    transform: "translate(-525.183 -298.063)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77610",
    "data-name": "Path 77610",
    className: "cls-322",
    d: "M692.089,396.691h1.185l-.593-.684Z",
    transform: "translate(-594.5 -340.167)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77611",
    "data-name": "Path 77611",
    className: "cls-316",
    d: "M696.884,396.007v.684l-.593-.684Z",
    transform: "translate(-598.11 -340.167)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77612",
    "data-name": "Path 77612",
    className: "cls-331",
    d: "M607.783,346.991l-.593.684,11.971,6.912.593-.684Z",
    transform: "translate(-521.573 -298.063)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77613",
    "data-name": "Path 77613",
    className: "cls-332",
    d: "M607.191,347.675v-.684h.592Z",
    transform: "translate(-521.573 -298.063)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77614",
    "data-name": "Path 77614",
    className: "cls-322",
    d: "M637.108,332.144l11.971,6.912h.593L637.7,332.144Z",
    transform: "translate(-547.271 -285.31)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77615",
    "data-name": "Path 77615",
    className: "cls-322",
    d: "M717.8,381.845h1.185l-.593-.684Z",
    transform: "translate(-616.588 -327.414)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77616",
    "data-name": "Path 77616",
    className: "cls-316",
    d: "M722.6,381.16v.684l-.593-.684Z",
    transform: "translate(-620.198 -327.414)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77617",
    "data-name": "Path 77617",
    className: "cls-331",
    d: "M633.5,332.145l-.593.684,11.971,6.912.593-.684Z",
    transform: "translate(-543.661 -285.31)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77618",
    "data-name": "Path 77618",
    className: "cls-332",
    d: "M632.905,332.829v-.684h.593Z",
    transform: "translate(-543.661 -285.31)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72523",
    "data-name": "Group 72523",
    transform: "translate(83.019 55.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72522",
    "data-name": "Group 72522",
    className: "cls-333"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26703",
    "data-name": "Rectangle 26703",
    className: "cls-334",
    width: 10.942,
    height: 5.1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72540",
    "data-name": "Group 72540"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72539",
    "data-name": "Group 72539",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77620",
    "data-name": "Path 77620",
    className: "cls-7",
    d: "M599.311,374.641l-2.9-1.671a2.085,2.085,0,0,0-1.887,0l-5.378,3.105a.575.575,0,0,0,0,1.09l2.9,1.672a2.086,2.086,0,0,0,1.887,0l5.378-3.105a.575.575,0,0,0,0-1.09",
    transform: "translate(-505.74 -320.184)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77621",
    "data-name": "Path 77621",
    className: "cls-322",
    d: "M631.66,418.077l1.862,1.075h.593l-1.862-1.075Z",
    transform: "translate(-542.592 -359.125)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77622",
    "data-name": "Path 77622",
    className: "cls-322",
    d: "M640.66,426.383h1.185l-.593-.684Z",
    transform: "translate(-550.323 -365.673)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77623",
    "data-name": "Path 77623",
    className: "cls-316",
    d: "M645.455,425.7v.684l-.593-.684Z",
    transform: "translate(-553.933 -365.673)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77624",
    "data-name": "Path 77624",
    className: "cls-331",
    d: "M628.05,418.077l-.593.684,1.862,1.075.593-.684Z",
    transform: "translate(-538.982 -359.125)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77625",
    "data-name": "Path 77625",
    className: "cls-322",
    d: "M657.375,403.23l1.862,1.075h.592l-1.862-1.075Z",
    transform: "translate(-564.681 -346.372)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77626",
    "data-name": "Path 77626",
    className: "cls-322",
    d: "M666.374,411.537h1.185l-.593-.684Z",
    transform: "translate(-572.411 -352.92)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77627",
    "data-name": "Path 77627",
    className: "cls-316",
    d: "M671.17,410.853v.684l-.593-.684Z",
    transform: "translate(-576.021 -352.92)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77628",
    "data-name": "Path 77628",
    className: "cls-331",
    d: "M653.764,403.23l-.593.684,1.862,1.075.593-.684Z",
    transform: "translate(-561.07 -346.372)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72526",
    "data-name": "Group 72526",
    className: "cls-148",
    transform: "translate(92.102 56.858)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72525",
    "data-name": "Group 72525"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72524",
    "data-name": "Group 72524",
    className: "cls-335"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77629",
    "data-name": "Path 77629",
    className: "cls-319",
    d: "M653.555,404.136l.418-.785-.208-.12-.593.684Z",
    transform: "translate(-653.172 -403.231)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72529",
    "data-name": "Group 72529",
    className: "cls-148",
    transform: "translate(92.694 56.858)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72528",
    "data-name": "Group 72528"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72527",
    "data-name": "Group 72527",
    className: "cls-336"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77630",
    "data-name": "Path 77630",
    className: "cls-319",
    d: "M658.35,403.452l-.767-.1-.208-.12h.593Z",
    transform: "translate(-657.375 -403.23)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72532",
    "data-name": "Group 72532",
    className: "cls-148",
    transform: "translate(88.476 58.952)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72531",
    "data-name": "Group 72531"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72530",
    "data-name": "Group 72530",
    className: "cls-337"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77631",
    "data-name": "Path 77631",
    className: "cls-319",
    d: "M627.835,418.979l.423-.782-.208-.12-.593.684Z",
    transform: "translate(-627.457 -418.077)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72535",
    "data-name": "Group 72535",
    className: "cls-148",
    transform: "translate(89.068 58.952)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72534",
    "data-name": "Group 72534"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72533",
    "data-name": "Group 72533",
    className: "cls-336"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77632",
    "data-name": "Path 77632",
    className: "cls-319",
    d: "M632.636,418.3l-.767-.1-.208-.12h.593Z",
    transform: "translate(-631.66 -418.077)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_77633",
    "data-name": "Path 77633",
    className: "cls-301",
    d: "M643.071,473.262l-2.075-1-2.932,1.693c-1.666-.718-4.159.721-5.824,3.363l-13.472,7.778.393,1.974,1.225,2.725,22.685-13.1Z",
    transform: "translate(-531.518 -405.667)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72538",
    "data-name": "Group 72538",
    className: "cls-31",
    transform: "translate(86.409 58.007)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72537",
    "data-name": "Group 72537"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72536",
    "data-name": "Group 72536",
    className: "cls-338"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77634",
    "data-name": "Path 77634",
    className: "cls-321",
    d: "M635.641,423.587l-19.37,11.184c-.651.376-1.315-.008-1.484-.857l-1.988-9.989,21.726-12.544,1.988,9.989a2.194,2.194,0,0,1-.872,2.217",
    transform: "translate(-612.799 -411.381)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72542",
    "data-name": "Group 72542",
    transform: "translate(89.132 58.198)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72541",
    "data-name": "Group 72541",
    className: "cls-339"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26710",
    "data-name": "Rectangle 26710",
    className: "cls-340",
    width: 31.088,
    height: 30.266,
    transform: "translate(-10.039 18.024) rotate(-60.884)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72544",
    "data-name": "Group 72544"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72543",
    "data-name": "Group 72543",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77636",
    "data-name": "Path 77636",
    className: "cls-320",
    d: "M630.361,403.482l-23.91,13.8,2.13,10.7,1.225,2.725,22.685-13.1v-3.432Zm.158,13.51-19.37,11.184c-.651.376-1.315-.008-1.484-.857l-1.988-9.989L629.4,404.787l1.988,9.989a2.194,2.194,0,0,1-.872,2.217",
    transform: "translate(-520.937 -346.588)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77637",
    "data-name": "Path 77637",
    className: "cls-341",
    d: "M670.64,542.54l.251.145,3.539-2.043-.251-.145Z",
    transform: "translate(-576.075 -464.284)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77638",
    "data-name": "Path 77638",
    className: "cls-342",
    d: "M670.89,555.132l-.251-.145.3.263.251.145Z",
    transform: "translate(-576.075 -476.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77639",
    "data-name": "Path 77639",
    className: "cls-9",
    d: "M675.958,541.525l-3.539,2.043.3.263,3.317-1.915Z",
    transform: "translate(-577.603 -465.166)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77640",
    "data-name": "Path 77640",
    className: "cls-341",
    d: "M643.019,547.409l.251.145,5.811-3.355-.251-.145Z",
    transform: "translate(-552.349 -467.339)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77641",
    "data-name": "Path 77641",
    className: "cls-9",
    d: "M650.609,545.081l-5.811,3.355.078.39,5.811-3.355Z",
    transform: "translate(-553.877 -468.221)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77642",
    "data-name": "Path 77642",
    className: "cls-343",
    d: "M643.27,567.992l-.251-.145.078.391.251.145Z",
    transform: "translate(-552.349 -487.777)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77643",
    "data-name": "Path 77643",
    className: "cls-341",
    d: "M732.928,506.578l.251.145,3.539-2.043-.251-.145Z",
    transform: "translate(-629.581 -433.392)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77644",
    "data-name": "Path 77644",
    className: "cls-342",
    d: "M733.179,519.169l-.251-.145.3.263.251.145Z",
    transform: "translate(-629.581 -445.839)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77645",
    "data-name": "Path 77645",
    className: "cls-9",
    d: "M738.246,505.562l-3.539,2.043.3.262,3.317-1.915Z",
    transform: "translate(-631.109 -434.275)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77646",
    "data-name": "Path 77646",
    className: "cls-341",
    d: "M705.308,511.446l.251.145,5.811-3.355-.251-.145Z",
    transform: "translate(-605.855 -436.447)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77647",
    "data-name": "Path 77647",
    className: "cls-9",
    d: "M712.9,509.119l-5.811,3.355.078.39,5.811-3.355Z",
    transform: "translate(-607.383 -437.33)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77648",
    "data-name": "Path 77648",
    className: "cls-343",
    d: "M705.559,532.029l-.251-.145.078.391.251.145Z",
    transform: "translate(-605.855 -456.885)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72546",
    "data-name": "Group 72546",
    transform: "translate(84.824 83.828)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72545",
    "data-name": "Group 72545",
    className: "cls-344"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26712",
    "data-name": "Rectangle 26712",
    className: "cls-345",
    width: 2.155,
    height: 6.6,
    transform: "translate(0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72554",
    "data-name": "Group 72554"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72553",
    "data-name": "Group 72553",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72549",
    "data-name": "Group 72549",
    className: "cls-317",
    transform: "translate(84.824 83.828)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72548",
    "data-name": "Group 72548"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72547",
    "data-name": "Group 72547",
    className: "cls-346"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77650",
    "data-name": "Path 77650",
    className: "cls-319",
    d: "M601.563,594.5l.372.326,1.185,3.254a8.757,8.757,0,0,0,.6,1.375v-1.2c-.049-.124-.1-.257-.154-.4l-.854-2.343.689.6.319,1.083v-1.447Z",
    transform: "translate(-601.563 -594.498)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_77651",
    "data-name": "Path 77651",
    className: "cls-329",
    d: "M601.563,632.48l2.155.745v.5Z",
    transform: "translate(-516.739 -543.296)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77652",
    "data-name": "Path 77652",
    className: "cls-347",
    d: "M626.1,652.451l-1.256-.725,1.256-.286Z",
    transform: "translate(-536.74 -559.583)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77653",
    "data-name": "Path 77653",
    className: "cls-9",
    d: "M653.615,570.112v1.011l-19.863,11.468V581.58Z",
    transform: "translate(-544.389 -489.723)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72552",
    "data-name": "Group 72552",
    className: "cls-317",
    transform: "translate(77.605 79.231)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72551",
    "data-name": "Group 72551"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72550",
    "data-name": "Group 72550",
    className: "cls-348"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77654",
    "data-name": "Path 77654",
    className: "cls-319",
    d: "M552.064,563.046l-.322-1.152-1.377,1.2.331,1.184.72.416c.389.224.7.042.7-.406v-.9a1.212,1.212,0,0,0-.055-.348",
    transform: "translate(-550.365 -561.894)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72556",
    "data-name": "Group 72556",
    transform: "translate(77.274 77.913)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72555",
    "data-name": "Group 72555",
    className: "cls-349"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26716",
    "data-name": "Rectangle 26716",
    className: "cls-350",
    width: 3.075,
    height: 3.695,
    transform: "matrix(0.883, -0.469, 0.469, 0.883, -1.348, 0.717)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72570",
    "data-name": "Group 72570"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72569",
    "data-name": "Group 72569",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77656",
    "data-name": "Path 77656",
    className: "cls-106",
    d: "M549.442,555.536v.9c0,.448-.315.63-.7.406l-.72-.416V553.9l.72.416a1.555,1.555,0,0,1,.7,1.219",
    transform: "translate(-470.745 -475.798)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72559",
    "data-name": "Group 72559",
    className: "cls-148",
    transform: "translate(109.41 55.069)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72558",
    "data-name": "Group 72558"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72557",
    "data-name": "Group 72557",
    className: "cls-351"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77657",
    "data-name": "Path 77657",
    className: "cls-9",
    d: "M776.744,394.658l.841.485-.607-3.05-1.053-1.553Z",
    transform: "translate(-775.925 -390.54)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72562",
    "data-name": "Group 72562",
    className: "cls-28",
    transform: "translate(85.5 55.069)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72561",
    "data-name": "Group 72561"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72560",
    "data-name": "Group 72560",
    className: "cls-352"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77658",
    "data-name": "Path 77658",
    className: "cls-353",
    d: "M606.358,404.344l1.053,1.553,23.91-13.8-1.053-1.553Z",
    transform: "translate(-606.358 -390.54)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72565",
    "data-name": "Group 72565",
    className: "cls-28",
    transform: "translate(86.553 56.622)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72564",
    "data-name": "Group 72564"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72563",
    "data-name": "Group 72563",
    className: "cls-354"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77659",
    "data-name": "Path 77659",
    className: "cls-9",
    d: "M637.735,401.554l-23.91,13.8.607,3.05,23.91-13.8Z",
    transform: "translate(-613.826 -401.554)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72568",
    "data-name": "Group 72568",
    className: "cls-28",
    transform: "translate(85.5 68.873)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72567",
    "data-name": "Group 72567"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72566",
    "data-name": "Group 72566",
    className: "cls-351"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77660",
    "data-name": "Path 77660",
    className: "cls-355",
    d: "M607.178,492.558l.841.485-.607-3.05-1.053-1.553Z",
    transform: "translate(-606.358 -488.44)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72575",
    "data-name": "Group 72575",
    transform: "translate(82.083 81.076)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72574",
    "data-name": "Group 72574",
    className: "cls-356"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72573",
    "data-name": "Group 72573"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72572",
    "data-name": "Group 72572"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72571",
    "data-name": "Group 72571",
    className: "cls-357"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_26722",
    "data-name": "Rectangle 26722",
    width: 2.978,
    height: 2.166,
    transform: "translate(-0.051 -0.024)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAgCAIAAADmJA0tAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAALKADAAQAAAABAAAAIAAAAAAaViiYAAADeklEQVRYCb2Xv1IUQRDGd/f2DvQxDC0MLLTkASxTDcHAEMqIADNJrNLMQEwQAgO1AEMDE3NLVCj/UWb6Htze7Prr6WWYm5077s7TKWqvZ7env6+/7pld0p0nz/Y2thNvdNp5p9OZmWmfPzfTabezLLtxZ5E/z2XKZjbleBOFi5CokiTLUqJh/J8RIZFUoFsC/4tFhIRQqDlUaSqS/OsRIZE54Gkr8evb0bsXe82U8uYtskcJrozm04nvbK6tQ0KXB3stosTEMIMWkv2967eUQVlVb5+/CjwjJOp+mMbmABh4LUFVVT1jiqI4Pu4+vrvm84iUA3QOKLc/JiuJll+zB55R9BjGmJKf7x8Ofn7+cvHqZaUSI8HmYPhUx7T98pdlacqygAIEjOn1uCHT10+3H7zcHELCYY7NBOVd/5NIDW/x7QUZ4GGwv77/9GP/4NLCFcCiStQVsIeW7BNHaoiB8gigDgqvyisktpVBGGCqzuu3V978PoyTAJQoo0ELaFB++t+mK2i2CDW8cDLA96m7u7G1tLoS2R2azYhXxHcdIPDG0PzdLpugJxeu3aLb7WFAKGAAhL7Ao+WoCcgeGTya5VcB4GENEaCugjGDwySIESGhteiXrS9IoD/dJ1LbDWjhLbqILzya2fuxFleXKUeEhHWKN2MAD4DN2+KXdedr7dkAVMfHC+y5a/OPduuPqRgJj4AfxukPNgMMKq34UGFwBogSsCjLANKfAo8Aujn1foREVSYaxcVCAE5fXSDwJG0MHXdSCAjoRhDDx2vaD3e2fPiBJEqSlK8aAQMSP0hw1ewld5uuTV1Q6z44cW4C6x0tf/Qpb+3q5oV5/xmbgm/d2Vm+dfnN23mLgZsef4JN3oUcv8DbIQezHyGwm/oHDpFyEJ0hCheyswHIW9Jl2mvcFB6UX/Cl/4OI/vRMeHUWErgefZTj0w2kBUw/d0XwNIUEeeNgGQi+bX+/cd3q2hiif+Aq5eBFwjEePKAIec4lbbUyfKBl/yCT0BLYgb8/HR1eV4kSzXblJmqDm5kMIiBTIHqV0kDIxwvsEfUPVokS3OLsDP4PC/zOnE4Gr2FrEkzuLy0HnXEmsHMYV3+3UI1TEswn4IEA7vQNQo8+7SMxFo+/0T/gF5LgMf1xtH84pDSID4NoOwfRR5xGSLiVyobp3MLpkcqb1zlMy/gDMm8xEGghWMkAAAAASUVORK5CYII="
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72577",
    "data-name": "Group 72577"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72576",
    "data-name": "Group 72576",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77662",
    "data-name": "Path 77662",
    className: "cls-9",
    d: "M583.548,576.852a.671.671,0,0,0-.613-.559l-.021.008a.369.369,0,0,1-.007-.077v-1.245h-.787v1.245a.853.853,0,0,0,.392.773.73.73,0,0,0,.369.1,1,1,0,0,0,.5-.144Z",
    transform: "translate(-500.037 -493.903)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72579",
    "data-name": "Group 72579",
    transform: "translate(84.49 81.409)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72578",
    "data-name": "Group 72578",
    className: "cls-358"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26725",
    "data-name": "Rectangle 26725",
    className: "cls-359",
    width: 0.911,
    height: 0.966,
    transform: "translate(-0.358 0.191) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72581",
    "data-name": "Group 72581",
    transform: "translate(80.798 73.972)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72580",
    "data-name": "Group 72580",
    className: "cls-360"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26726",
    "data-name": "Rectangle 26726",
    className: "cls-361",
    width: 8.415,
    height: 6.704,
    transform: "translate(-3.388 5.907) rotate(-60.162)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72586",
    "data-name": "Group 72586"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72585",
    "data-name": "Group 72585",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72584",
    "data-name": "Group 72584",
    className: "cls-148",
    transform: "translate(82.476 74.238)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72583",
    "data-name": "Group 72583"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72582",
    "data-name": "Group 72582",
    className: "cls-362"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77665",
    "data-name": "Path 77665",
    className: "cls-259",
    d: "M586.356,526.516a.308.308,0,0,0-.308.031l-.307.177a.337.337,0,0,1-.168.045h-.662v.454h.171l.787-.454.281-.162a.309.309,0,0,1,.31-.031Z",
    transform: "translate(-584.911 -526.488)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_77666",
    "data-name": "Path 77666",
    className: "cls-9",
    d: "M579.368,526.97l-1.914,1.105a.968.968,0,0,0-.439.759v5.316c0,.28.2.393.439.253l1.914-1.105a.969.969,0,0,0,.439-.76v-5.316c0-.28-.2-.393-.439-.253",
    transform: "translate(-495.652 -452.612)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72591",
    "data-name": "Group 72591",
    transform: "translate(82.083 71.068)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72590",
    "data-name": "Group 72590",
    className: "cls-363"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72589",
    "data-name": "Group 72589",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72588",
    "data-name": "Group 72588"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72587",
    "data-name": "Group 72587",
    className: "cls-364"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_26729",
    "data-name": "Rectangle 26729",
    width: 2.978,
    height: 3.723,
    transform: "translate(-0.051 -0.033)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAA3CAIAAAD49z8OAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAALKADAAQAAAABAAAANwAAAADIlmMKAAAEW0lEQVRYCb2YP2/cRhDF7wx/kwApAluFEiPuHbiNS6dJGZcqpDKNgbgMglSCXNpA7NZwlyZVADuxAgUSXMX+Hjn+Of/ezHK5S1InnURycSCXR97Om/feDFdarGcc/52c7t/7th/w5mKW8eHfs9+fveRINCb3v3+Yhl2CK72eYk5UPnHlqqp++eN1vGQyLYhO+Lquy6oqyvKznVsHhz9HHFPJkfJPMPgmdlXVfjx7e/z+73++uLPrOMZnoh8eAohdFOgAjLrUqD/f3Xn8/NBBjMxEh3+Ckj4UGAvNpAJHdfLnX6dv3t2++xU4RmMCAg73f/TMOJI9SReroqzqBkqYgKtuquHVx2MeHoGJPv8xeybNQBExATj8sVwuHe6LX4++23t0XSbIHhC+IqsTAcELsx8ZOw3Rj2l4/wnHn347ujoTHflVfoRXYA2sZ8dwWdcLko8ERARMqJSrgBiU39wHANHuQ2bEEMTHeoH+NLrmD/d+QI7tQPTlV7rufzvq0mIbEvlvc3gHtQWIrvxqf1b0BqQlwMrB7T+I4NbXX0KAF+cWIPr8e/buPzg3LWAeR+B++D+HfbNhGv6yIFIDYm/juVL9a3h4m+qK+235eYB4dPnjZTq5oERTCYhC6iQNAFoR/jf53f/1erHG/unScQ7/T148jZf9ySZPRAROwP+kX5TeCYL7jA7uWvENIOjL30fAN8MgUhMIQVmuViLBmZAKVgUKzxi03znybwECH/jTnvdqVdAEIUJaFAVfuv6DzYcfbpD/siCiCjRBois2HxxR4kfNfKFBBBfKfykQCMGHR6GagHCg7EVA0GKBAgPqLy4p/yCIbnUcfPPAnyP6SkNMKH97L5B98IGc0GLZlv8OlMyYCOG3tRWQDUIPNhHqFEFc5ZrhfZ0WRBQCKwBADSgIQV2CQALF2AC6Dv9xnS6IWBEQIC3MBGpQVQXvfQSb+08nzObLjAkehQYNvYS0OwWKXgVyYxhwwDak3/+b+1c53/AfRRpwgxqRxNBeYG1CxIVBgAnGRcDiGQgosPCc1Y54RVADqRD4gD1IxDTWRCAiDZBu+RsVtiNNw0DDiD5IV249QcZqyxJDezLkyNxozTj95YhzMRFbpFQQAbIm5/TNBA1TCOGZtCAISWSqkfBCkJclfhwx9c5SwZgeEkUY4oKabKtSHRpLdn454uUN18JBcKQqOdYVWmRRRi/LdPUWBFqYIeSI9UIdarYRqsOFcAmY29u63bJOaghSbT3Bhe3Wlb/h0GSekYHwkIkj58GQM+F/suaOnANHYKLxgYecG0Yux1KdCkskO7cZmWhCRQ7ipLkz5blhgqYoR6SviynD5ms3IFSWXpmzcuBgWhDAaJqVIcrBTnoVQIT0/cRxXjpSJsjWnKGsZ0WRgSByaNjJnxiTCuGLZyD01fxNu/MCCyKoUmfIvw2RM+Hd2zZW7SPTzzIQ/m+f2THkb9GQ87xaEDQwobdWY8nmPL0MTYRPxkbF1FQrAN4AAAAASUVORK5CYII="
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72593",
    "data-name": "Group 72593",
    transform: "translate(84.49 71.049)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72592",
    "data-name": "Group 72592",
    className: "cls-365"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26731",
    "data-name": "Rectangle 26731",
    className: "cls-366",
    width: 0.91,
    height: 0.966,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, -0.358, 0.191)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72595",
    "data-name": "Group 72595",
    transform: "translate(82.083 74.52)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72594",
    "data-name": "Group 72594",
    className: "cls-367"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26732",
    "data-name": "Rectangle 26732",
    className: "cls-368",
    width: 0.787,
    height: 0.454,
    transform: "translate(0 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72597",
    "data-name": "Group 72597"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72596",
    "data-name": "Group 72596",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77670",
    "data-name": "Path 77670",
    className: "cls-9",
    d: "M655.777,599.556l11.718-6.766.984-3.5-.648-.374L653.9,596.957l1.042.6Z",
    transform: "translate(-561.699 -505.875)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77671",
    "data-name": "Path 77671",
    className: "cls-369",
    d: "M751.673,589.961l-.916-.529-.135.481.522.3-.849,3.019.394.227Z",
    transform: "translate(-644.499 -506.318)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77672",
    "data-name": "Path 77672",
    className: "cls-369",
    d: "M659.349,635.826l.378.372.916.529-1.057-1.038Z",
    transform: "translate(-566.376 -546.052)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77673",
    "data-name": "Path 77673",
    className: "cls-309",
    d: "M652.928,503.711l-22.685,13.1v8.019l4.342-2.507,1.057,1.038,11.887-6.863,1.057-2.258,4.342-2.507Z",
    transform: "translate(-541.374 -432.684)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26733",
    "data-name": "Rectangle 26733",
    className: "cls-370",
    width: 1.225,
    height: 8.388,
    transform: "translate(87.643 94.212)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77674",
    "data-name": "Path 77674",
    className: "cls-309",
    d: "M648.548,577.781l-.984,3.5-11.959,6.9-.984-2.364-4.379,2.528v8.388l22.685-13.1v-8.388Z",
    transform: "translate(-541.373 -494.139)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72599",
    "data-name": "Group 72599",
    transform: "translate(107.708 72.905)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72598",
    "data-name": "Group 72598",
    className: "cls-371"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26735",
    "data-name": "Rectangle 26735",
    className: "cls-372",
    width: 5.947,
    height: 7.429,
    transform: "translate(-2.978 1.707) rotate(-29.827)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72601",
    "data-name": "Group 72601"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72600",
    "data-name": "Group 72600",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77676",
    "data-name": "Path 77676",
    className: "cls-373",
    d: "M633.235,683.789l-.288-.692-4.32,2.494h-.265V686.6Z",
    transform: "translate(-539.759 -586.776)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77677",
    "data-name": "Path 77677",
    className: "cls-374",
    d: "M627.386,688.005l-4.873,2.813h-.477l-.483.279h1.225l4.982-2.876Z",
    transform: "translate(-533.91 -590.992)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77678",
    "data-name": "Path 77678",
    className: "cls-369",
    d: "M661.108,682.158l-.229.132.288.692.374.216Z",
    transform: "translate(-567.691 -585.97)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77679",
    "data-name": "Path 77679",
    className: "cls-309",
    d: "M621.553,700.785h.483V701.8l-.483.279Z",
    transform: "translate(-533.91 -601.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26736",
    "data-name": "Rectangle 26736",
    className: "cls-375",
    width: 0.477,
    height: 1.012,
    transform: "translate(88.126 98.815)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72603",
    "data-name": "Group 72603",
    transform: "translate(89.815 84.248)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72602",
    "data-name": "Group 72602",
    className: "cls-376"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26738",
    "data-name": "Rectangle 26738",
    className: "cls-377",
    width: 5.098,
    height: 5.905,
    transform: "translate(-2.241 1.308) rotate(-30.28)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72605",
    "data-name": "Group 72605",
    transform: "translate(89.906 84.248)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72604",
    "data-name": "Group 72604",
    className: "cls-378"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26739",
    "data-name": "Rectangle 26739",
    className: "cls-379",
    width: 4.337,
    height: 5.276,
    transform: "translate(-1.61 0.668) rotate(-22.542)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72607",
    "data-name": "Group 72607"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72606",
    "data-name": "Group 72606",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77682",
    "data-name": "Path 77682",
    className: "cls-374",
    d: "M766.826,589.716l-.483.279v.461l-3.36,1.94-.145.516,3.988-2.3Z",
    transform: "translate(-655.272 -506.562)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77683",
    "data-name": "Path 77683",
    className: "cls-380",
    d: "M787.694,582.29v-1.265l.483-.279v1.265Z",
    transform: "translate(-676.624 -498.857)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77684",
    "data-name": "Path 77684",
    className: "cls-373",
    d: "M767.225,584.451v-1.726l-2.781,1.605-.579,2.06Z",
    transform: "translate(-656.155 -500.557)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77685",
    "data-name": "Path 77685",
    className: "cls-374",
    d: "M760.771,610.72l-.483.279v.461l-4.354,2.514-.145.516,4.982-2.876Z",
    transform: "translate(-649.217 -524.604)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77686",
    "data-name": "Path 77686",
    className: "cls-380",
    d: "M787.694,608.577v-.4l.483-.279v.4Z",
    transform: "translate(-676.624 -522.183)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77687",
    "data-name": "Path 77687",
    className: "cls-373",
    d: "M761.171,610.739v-.858l-4.066,2.347-.288,1.025Z",
    transform: "translate(-650.101 -523.883)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77688",
    "data-name": "Path 77688",
    className: "cls-373",
    d: "M632.241,662.6l-.579-1.391-3.035,1.752h-.265v1.879Z",
    transform: "translate(-539.758 -567.97)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77689",
    "data-name": "Path 77689",
    className: "cls-374",
    d: "M626.393,671.071l-3.879,2.24h-.477l-.483.279h1.225l3.988-2.3Z",
    transform: "translate(-533.91 -576.445)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77690",
    "data-name": "Path 77690",
    className: "cls-369",
    d: "M651.995,660.265l-.229.132.579,1.391h0l.374.216Z",
    transform: "translate(-559.863 -567.163)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77691",
    "data-name": "Path 77691",
    className: "cls-309",
    d: "M621.553,673.63h.483v1.879l-.483.279Z",
    transform: "translate(-533.91 -578.644)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26740",
    "data-name": "Rectangle 26740",
    className: "cls-375",
    width: 0.477,
    height: 1.879,
    transform: "translate(88.126 94.986)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77692",
    "data-name": "Path 77692",
    className: "cls-9",
    d: "M672.977,640.152l9.39-5.421.724-2.576-10.838,6.257Z",
    transform: "translate(-577.461 -543.017)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77693",
    "data-name": "Path 77693",
    className: "cls-370",
    d: "M621.554,577.272v10.744h1.225V580Z",
    transform: "translate(-533.91 -495.873)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77694",
    "data-name": "Path 77694",
    className: "cls-9",
    d: "M669.861,541.186l-11.324,6.538-1.968-4.729,15.261-8.811Z",
    transform: "translate(-563.988 -458.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77695",
    "data-name": "Path 77695",
    className: "cls-374",
    d: "M680.528,582.229l-11.083,6.4.153.367,11.324-6.538Z",
    transform: "translate(-575.049 -500.131)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77696",
    "data-name": "Path 77696",
    className: "cls-369",
    d: "M750.4,534.183l-.547.316-1.816,6.459.394.227Z",
    transform: "translate(-642.563 -458.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77697",
    "data-name": "Path 77697",
    className: "cls-9",
    d: "M637.049,601.791l-.091.052.536,3.457a1.029,1.029,0,0,0,.285.6,1.176,1.176,0,0,0,.909-.172Z",
    transform: "translate(-547.143 -516.935)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72609",
    "data-name": "Group 72609",
    transform: "translate(107.708 73.301)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72608",
    "data-name": "Group 72608",
    className: "cls-381"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26742",
    "data-name": "Rectangle 26742",
    className: "cls-382",
    width: 6.863,
    height: 3.903,
    transform: "translate(-1.706 6.022) rotate(-74.179)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72623",
    "data-name": "Group 72623"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72622",
    "data-name": "Group 72622",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77699",
    "data-name": "Path 77699",
    className: "cls-9",
    d: "M767.918,524.479a3.386,3.386,0,0,0,1.491-2.323l.487-3.7-.339.2Z",
    transform: "translate(-659.636 -445.347)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77700",
    "data-name": "Path 77700",
    className: "cls-374",
    d: "M678.91,616.394l-11.718,6.765.153.367,11.959-6.9Z",
    transform: "translate(-573.114 -529.479)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77701",
    "data-name": "Path 77701",
    className: "cls-374",
    d: "M685.453,648.81l-9.148,5.282.153.367,9.389-5.421Z",
    transform: "translate(-580.941 -557.324)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77702",
    "data-name": "Path 77702",
    className: "cls-369",
    d: "M742.3,632.156l-.547.316-.571,2.033.394.227Z",
    transform: "translate(-636.671 -543.018)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72612",
    "data-name": "Group 72612",
    className: "cls-383",
    transform: "translate(82.065 64.503)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72611",
    "data-name": "Group 72611"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72610",
    "data-name": "Group 72610",
    className: "cls-384"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77703",
    "data-name": "Path 77703",
    className: "cls-385",
    d: "M583.013,457.839l-.684-.395a.477.477,0,0,1,.207.365c0,.232-.219.434-.544.541l.794-.026c.457-.015.827-.226.853-.485Z",
    transform: "translate(-581.992 -457.444)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72615",
    "data-name": "Group 72615",
    className: "cls-383",
    transform: "translate(82.098 64.288)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72614",
    "data-name": "Group 72614"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72613",
    "data-name": "Group 72613",
    className: "cls-386"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77704",
    "data-name": "Path 77704",
    className: "cls-385",
    d: "M582.964,455.926l-.736.037.987.57.408-.472a1.327,1.327,0,0,0-.66-.136",
    transform: "translate(-582.228 -455.924)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72618",
    "data-name": "Group 72618",
    className: "cls-387",
    transform: "translate(83.085 64.426)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72617",
    "data-name": "Group 72617"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72616",
    "data-name": "Group 72616",
    className: "cls-388"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77705",
    "data-name": "Path 77705",
    className: "cls-385",
    d: "M589.639,456.9l-.409.472h.628a.635.635,0,0,0-.219-.472",
    transform: "translate(-589.23 -456.899)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72621",
    "data-name": "Group 72621",
    className: "cls-148",
    transform: "translate(80.138 64.243)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72620",
    "data-name": "Group 72620"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72619",
    "data-name": "Group 72619",
    className: "cls-389"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77706",
    "data-name": "Path 77706",
    className: "cls-319",
    d: "M570.6,455.865l-.256-.148a1.665,1.665,0,0,0-.626-.116h-.306c-.6,0-1.082.28-1.082.625s.484.625,1.082.625h.306c.6,0,1.082-.28,1.082-.625a.475.475,0,0,0-.2-.361",
    transform: "translate(-568.331 -455.602)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72625",
    "data-name": "Group 72625",
    transform: "translate(80.138 63.784)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72624",
    "data-name": "Group 72624",
    className: "cls-390"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26748",
    "data-name": "Rectangle 26748",
    className: "cls-391",
    width: 2.164,
    height: 1.709,
    transform: "translate(0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72627",
    "data-name": "Group 72627"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72626",
    "data-name": "Group 72626",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77708",
    "data-name": "Path 77708",
    className: "cls-7",
    d: "M569.413,452.345c-.6,0-1.082.28-1.082.625s.484.625,1.082.625,1.082-.28,1.082-.625-.484-.625-1.082-.625",
    transform: "translate(-488.193 -388.561)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77709",
    "data-name": "Path 77709",
    className: "cls-392",
    d: "M570.1,452.808c-.535,0-.969.25-.969.559s.434.559.969.559.969-.25.969-.559-.434-.559-.969-.559",
    transform: "translate(-488.881 -388.959)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72629",
    "data-name": "Group 72629",
    transform: "translate(80.696 63.034)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72628",
    "data-name": "Group 72628",
    className: "cls-393"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26750",
    "data-name": "Rectangle 26750",
    className: "cls-394",
    width: 1.681,
    height: 1.625,
    transform: "matrix(0.5, -0.866, 0.866, 0.5, -0.599, 0.965)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72650",
    "data-name": "Group 72650"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72649",
    "data-name": "Group 72649",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77711",
    "data-name": "Path 77711",
    className: "cls-395",
    d: "M573.77,448.194c.167-.29.439-.447.606-.35s.167.41,0,.7-.439.447-.606.35-.167-.41,0-.7",
    transform: "translate(-492.757 -384.67)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72634",
    "data-name": "Group 72634",
    className: "cls-396",
    transform: "translate(80.251 62.43)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72633",
    "data-name": "Group 72633"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72632",
    "data-name": "Group 72632",
    className: "cls-397"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72631",
    "data-name": "Group 72631",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72630",
    "data-name": "Group 72630",
    className: "cls-398"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26751",
    "data-name": "Rectangle 26751",
    className: "cls-399",
    width: 1.938,
    height: 2.538,
    transform: "translate(0)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72639",
    "data-name": "Group 72639",
    className: "cls-396",
    transform: "translate(80.364 61.936)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72638",
    "data-name": "Group 72638"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72637",
    "data-name": "Group 72637",
    className: "cls-400"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72636",
    "data-name": "Group 72636",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72635",
    "data-name": "Group 72635",
    className: "cls-401"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26753",
    "data-name": "Rectangle 26753",
    className: "cls-402",
    width: 1.712,
    height: 0.988,
    transform: "translate(0 0)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72642",
    "data-name": "Group 72642",
    className: "cls-396",
    transform: "translate(80.532 61.936)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72641",
    "data-name": "Group 72641"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72640",
    "data-name": "Group 72640",
    className: "cls-403"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77714",
    "data-name": "Path 77714",
    className: "cls-404",
    d: "M571.808,439.241c-.38,0-.689.178-.689.4s.308.4.689.4.689-.178.689-.4-.308-.4-.689-.4",
    transform: "translate(-571.119 -439.241)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72645",
    "data-name": "Group 72645",
    className: "cls-383",
    transform: "translate(103.213 52.48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72644",
    "data-name": "Group 72644"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72643",
    "data-name": "Group 72643",
    className: "cls-405"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77715",
    "data-name": "Path 77715",
    className: "cls-385",
    d: "M733.384,372.709l-.91-.525a.384.384,0,0,1,.046.177c0,.232-.219.433-.544.541l.794-.027a1.278,1.278,0,0,0,.614-.166",
    transform: "translate(-731.975 -372.183)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72648",
    "data-name": "Group 72648",
    className: "cls-148",
    transform: "translate(101.287 52.033)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72647",
    "data-name": "Group 72647"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72646",
    "data-name": "Group 72646",
    className: "cls-389"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77716",
    "data-name": "Path 77716",
    className: "cls-319",
    d: "M719.395,370.259h.306c.6,0,1.082-.28,1.082-.625a.385.385,0,0,0-.045-.177l-.731-.422a1.835,1.835,0,0,0-.306-.026h-.306c-.6,0-1.082.28-1.082.625s.484.625,1.082.625",
    transform: "translate(-718.313 -369.01)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72652",
    "data-name": "Group 72652",
    transform: "translate(101.287 51.574)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72651",
    "data-name": "Group 72651",
    className: "cls-406"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26759",
    "data-name": "Rectangle 26759",
    className: "cls-407",
    width: 2.164,
    height: 1.708
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72654",
    "data-name": "Group 72654"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72653",
    "data-name": "Group 72653",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77718",
    "data-name": "Path 77718",
    className: "cls-7",
    d: "M719.395,365.753c-.6,0-1.082.28-1.082.625s.484.625,1.082.625,1.082-.28,1.082-.625-.484-.625-1.082-.625",
    transform: "translate(-617.026 -314.179)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77719",
    "data-name": "Path 77719",
    className: "cls-392",
    d: "M720.084,366.216c-.535,0-.969.25-.969.559s.434.559.969.559.969-.25.969-.559-.434-.559-.969-.559",
    transform: "translate(-617.715 -314.577)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72656",
    "data-name": "Group 72656",
    transform: "translate(101.844 50.824)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72655",
    "data-name": "Group 72655",
    className: "cls-408"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26761",
    "data-name": "Rectangle 26761",
    className: "cls-409",
    width: 1.681,
    height: 1.625,
    transform: "translate(-0.599 0.965) rotate(-60)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72671",
    "data-name": "Group 72671"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72670",
    "data-name": "Group 72670",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77721",
    "data-name": "Path 77721",
    className: "cls-395",
    d: "M723.752,361.6c.167-.29.439-.447.606-.35s.167.41,0,.7-.439.447-.606.35-.167-.41,0-.7",
    transform: "translate(-621.591 -310.288)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72661",
    "data-name": "Group 72661",
    className: "cls-396",
    transform: "translate(101.4 50.22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72660",
    "data-name": "Group 72660"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72659",
    "data-name": "Group 72659",
    className: "cls-397"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72658",
    "data-name": "Group 72658",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72657",
    "data-name": "Group 72657",
    className: "cls-410"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26762",
    "data-name": "Rectangle 26762",
    className: "cls-411",
    width: 1.938,
    height: 2.538
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72666",
    "data-name": "Group 72666",
    className: "cls-396",
    transform: "translate(101.513 49.726)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72665",
    "data-name": "Group 72665"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72664",
    "data-name": "Group 72664",
    className: "cls-400"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72663",
    "data-name": "Group 72663"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72662",
    "data-name": "Group 72662",
    className: "cls-412"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26764",
    "data-name": "Rectangle 26764",
    className: "cls-413",
    width: 1.712,
    height: 0.988,
    transform: "translate(0 0)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72669",
    "data-name": "Group 72669",
    className: "cls-396",
    transform: "translate(101.68 49.726)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72668",
    "data-name": "Group 72668"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72667",
    "data-name": "Group 72667",
    className: "cls-403"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77724",
    "data-name": "Path 77724",
    className: "cls-404",
    d: "M721.79,352.649c-.38,0-.689.178-.689.4s.308.4.689.4.689-.178.689-.4-.308-.4-.689-.4",
    transform: "translate(-721.101 -352.649)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrapBins);
export default __webpack_public_path__ + "static/media/ScrapBins.eee074782d71b6408c832194ba719d38.svg";
export { ForwardRef as ReactComponent };